/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".js/" + ({"1":"vendor","2":"catalog-overview","3":"store-info","4":"legal","5":"products-overview","6":"user-type-selection","7":"order-creation","8":"cart-overview","9":"/admin/subscription-details","10":"order-payment","11":"orders-overview","12":"/admin/subscriptions-overview","13":"/admin/orders-overview","14":"/admin/group-purchases-overview","15":"verify-email","16":"/store/register","17":"order-overview","18":"order-confirmation","19":"password-lost","20":"password-change","21":"/myfundels/validate-ticket","22":"user-profile","23":"subscription-details","24":"/myfundels/request-demo","25":"order-details","26":"myfundels-register","27":"linked-subscription-details","28":"digital-book-details","29":"complete-profile","30":"/admin/order-details","31":"/admin/linked-subscription-details","32":"/admin/group-purchases-details","33":"/admin/customers-overview","34":"/admin/customer-details","35":"store-login","36":"profile-deleted","37":"outdated","38":"index","39":"help","40":"book","41":"css-components","42":"code","43":"unexpected_error","44":"bios_unknown","45":"bios_checksum_invalid","46":"404","47":"404-invoice","48":"services_test"}[chunkId]||chunkId) + "." + {"1":"ebee6036dd14e9e3aa68","2":"fc98ac18e4dac765ef14","3":"6ae05939ce9507c6924d","4":"a1b5fc21cf04441d9b25","5":"ac5f631fe528367a0c53","6":"3eee03d7630969d626c0","7":"e0a59f9fe3f43ff50985","8":"065a6be31e953b6f2638","9":"ac6449f2a767d2048020","10":"cbc99e8cbb11573193e0","11":"2a9dc89a160834efc0cb","12":"de4608d5f368ae5de8e1","13":"d2558382705bb0e70521","14":"617c8238a0120aac5bca","15":"4a4b838251d85fde3451","16":"f2e394d38cbfd330d29b","17":"c491704ff0ec66ffd1ff","18":"de2f273533f0f8559824","19":"a1146fb0d889585dc53b","20":"b6f345e1b9fff5a4849d","21":"a9698f443bc09f65c816","22":"04cfc359a73cfe015089","23":"e04503d1c9eaf74a1930","24":"6f7310b8619a0ef63aec","25":"40db7eb3cf1e275b6249","26":"05f83e1a4cb43fc63439","27":"c3b57a430ddf369b7679","28":"a41a890dd0c255026a48","29":"609035f5ca1ea0154b8c","30":"67902f678ae7a4d9c65c","31":"daeffb2878197163edb6","32":"bb6263f53ce2ff206456","33":"d7136c66938523aebe18","34":"ba5b18078cde63367662","35":"cc44873238f5f6986961","36":"f4fc36cc2fe271f2fd8a","37":"fedec59decc3525819bd","38":"f9cb0a8d378b6ab53cc9","39":"2e165951b58395a5d9ca","40":"8bc5494c4a70eea87ca0","41":"5af20213092ae7ed5791","42":"7f616c33eda7b30d59f7","43":"d2cee4cdd2e84fb9490f","44":"b62800fec67bb981e19c","45":"e8f72db40bbf0b7cfbc0","46":"048cf21f86a09355907d","47":"59005600297efcfa716d","48":"fdac828e0167a4e0e381"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 04/01/2017.
	 */
	var config = __webpack_require__(227);
	
	var utils = {};
	var queryParams;
	var performanceStart;
	var performanceEnd;
	
	(function (Utils) {
	  Utils.emptyStringChar = "-";
	
	  Utils.UUID = function () {
	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c === "x" ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	  };
	
	  Utils.generateUIDShort = function () {
	    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	  };
	
	  Utils.redirect = function (link) {
	    window.location.href = link;
	  };
	
	  Utils.refreshPage = function () {
	    window.location.reload(false);
	  };
	
	  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
	  Utils.isUndefined = function (obj) {
	    return typeof obj === "undefined";
	  };
	
	  Utils.isDefined = function (obj) {
	    return !Utils.isUndefined(obj);
	  };
	
	  Utils.isNull = function (obj) {
	    return typeof obj === "undefined" || obj === null;
	  };
	
	  Utils.isNotNull = function (obj) {
	    return !Utils.isNull(obj);
	  };
	
	  Utils.isNullOrEmpty = function (str) {
	    return Utils.isNull(str) || str === "";
	  };
	
	  Utils.isString = function (value) {
	    return typeof value === "string";
	  };
	
	  Utils.isBoolean = function (value) {
	    return value === true || value === false;
	  };
	
	  Utils.isNumber = function (value) {
	    return Utils.isNotNull(value) && typeof value === "number";
	  };
	
	  Utils.isArray = function (obj) {
	    return Utils.isNotNull(obj) && Array.isArray(obj);
	  };
	
	  Utils.isObject = function (obj) {
	    return Utils.isNotNull(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
	  };
	
	  Utils.isMomentObject = function (obj) {
	    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
	  };
	
	  Utils.isFunction = function (obj) {
	    return typeof obj === "function";
	  };
	
	  Utils.isValidEmail = function (email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  };
	
	  Utils.isValidBtwNumber = function (btw) {
	    if (!btw) return false;
	
	    var re = /^((BE)(0\d{9})|(NL)(\d{9}(B\d{2}|BO2)))$/;
	    var cleanedBtw = btw.replaceAll(" ", "").replaceAll(".", "");
	    return re.test(cleanedBtw);
	  };
	
	  Utils.stringToInt = function (value) {
	    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
	      return Number(value);
	    }
	
	    return NaN;
	  };
	
	  Utils.stringToBoolean = function (str) {
	    return str === "true";
	  };
	
	  Utils.stringifyJSON = function (obj, replacer, space) {
	    return JSON.stringify(obj, replacer, space);
	  };
	
	  Utils.parseJSON = function (str, safe) {
	    if (safe) {
	      try {
	        var objValue = JSON.parse(str);
	        return objValue;
	      } catch (e) {
	        return str;
	      }
	    } else {
	      return JSON.parse(str);
	    }
	  };
	
	  Utils.roundNumber = function (number, decimals) {
	    if (Utils.isNumber(number)) {
	      var rounder = Math.pow(10, decimals);
	      return Math.round(number * rounder) / rounder;
	    }
	
	    return NaN;
	  };
	
	  Utils.getRandomIntInclusive = function (min, max) {
	    min = Math.ceil(min);
	    max = Math.floor(max);
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	
	  Utils.getMinSafeInt = function () {
	    return Number.MIN_SAFE_INTEGER;
	  };
	
	  Utils.getMaxSafeInt = function () {
	    return Number.MAX_SAFE_INTEGER;
	  };
	
	  Utils.removeWhitespace = function (str) {
	    if (Utils.isNotNull(str) && Utils.isString(str)) {
	      return str.replace(/ /g, "");;
	    }
	
	    return str;
	  };
	
	  Utils.devLog = function () {
	    if (false) {
	      console.log.apply(console, arguments);
	    }
	  };
	
	  Utils.getQueryParam = function (name) {
	    return queryParams[name];
	  };
	
	  Utils.getPathSection = function (index) {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    for (var i = 0; i < pathSections.length; i++) {
	      var pathSection = pathSections[i];
	
	      if (Utils.isNullOrEmpty(pathSection)) {
	        index++;
	        continue;
	      }
	
	      if (i + 1 === index) {
	        return pathSection;
	      }
	    }
	
	    return null;
	  };
	
	  Utils.getUrlHash = function () {
	    return window.location.hash;
	  };
	
	  Utils.readCookie = function (name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(";");
	
	    for (var i = 0; i < ca.length; i++) {
	      var c = ca[i];
	      while (c.charAt(0) === " ") {
	        c = c.substring(1, c.length);
	      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	    }
	
	    return null;
	  };
	
	  Utils.getServiceUrl = function (command) {
	    return config.serviceBaseURL + config.serviceVersion + "/" + command;
	  };
	
	  Utils.format = function (format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return utils.isDefined(args[number]) ? args[number] : match;
	    });
	  };
	
	  Utils.getValueFromSplit = function (str, index, splitStr) {
	    var result;
	
	    if (!utils.isNullOrEmpty(str)) {
	      var split = str.split(splitStr);
	
	      if (split.length >= index + 1) {
	        result = split[index];
	      }
	    }
	
	    return result;
	  };
	
	  Utils.performance = function () {
	    var result = null;
	
	    if (utils.isNotNull(performanceStart)) {
	      performanceEnd = performance.now();
	      result = performanceEnd - performanceStart;
	
	      performanceStart = null;
	      performanceEnd = null;
	    } else {
	      performanceStart = performance.now();
	    }
	
	    return result;
	  };
	
	  Utils.getColorClassForStatus = function (status) {
	    switch (status) {
	      case "payed":
	      case "valid":
	      case "complete":
	        return "text-green";
	      case "awaiting_payment":
	      case "expired":
	        return "text-red-warm";
	      default:
	        return "";
	    }
	  };
	
	  Utils.getReadableLanguageForKey = function (key) {
	    switch (key.toUpperCase()) {
	      case "NL":
	        return "globals.languages.dutch";
	      default:
	        return key;
	    }
	  };
	
	  Utils.getReadableCountryForKey = function (key) {
	    switch (key.toUpperCase()) {
	      case "BE":
	        return "globals.countries.belgium";
	      case "NL":
	        return "globals.countries.netherlands";
	      default:
	        return key;
	    }
	  };
	
	  Utils.getReadableLocaleForKey = function (key) {
	    switch (key.toUpperCase()) {
	      case "NL_BE":
	        return "globals.locales.nl_BE";
	      case "NL_NL":
	        return "globals.locals.nl_NL";
	      default:
	        return key;
	    }
	  };
	
	  return Utils;
	})(utils);
	
	// Load query parameters once
	(window.onpopstate = function () {
	  var match,
	      pl = /\+/g,
	      // Regex for replacing addition symbol with a space
	  search = /([^&=]+)=?([^&]*)/g,
	      decode = function decode(s) {
	    return decodeURIComponent(s.replace(pl, " "));
	  },
	      query = window.location.search.substring(1);
	
	  queryParams = {};
	  while (match = search.exec(query)) {
	    var name = decode(match[1]);
	    var value = decode(match[2]);
	
	    if (queryParams.hasOwnProperty(name)) {
	      if (!utils.isArray(queryParams[name])) {
	        // Make it an array
	        queryParams[name] = [queryParams[name]];
	      }
	
	      queryParams[name].push(value);
	    } else {
	      queryParams[name] = value;
	    }
	  }
	})();
	
	module.exports = utils;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by IntelliJ IDEA.
	 * User: jv
	 * Date: 12/05/16
	 * Time: 12:56
	 */
	var utils = __webpack_require__(3);
	
	var languageManager = {};
	
	(function (LanguageManager) {
	  var localeBasePath = "/assets/localization/";
	  var locale = null;
	  var localeMap = null;
	
	  LanguageManager.init = function (callback, defaultLocale) {
	    locale = localStorage.getItem("locale");
	    if (locale === null) {
	      locale = typeof defaultLocale !== "undefined" ? defaultLocale : "nl-BE";
	      localStorage.setItem("locale", locale);
	    }
	
	    var tmpLocale = utils.getQueryParam("locale");
	    if (typeof tmpLocale !== "undefined" && tmpLocale !== null && tmpLocale !== "") {
	      locale = tmpLocale;
	      localStorage.setItem("locale", locale);
	    }
	
	    $("html").addClass(locale);
	
	    getLocaleJSON(function () {
	      _init(callback);
	    }, function () {
	      var html = $("html");
	      html.removeClass(locale);
	      locale = typeof defaultLocale !== "undefined" ? defaultLocale : "nl-BE";
	      html.addClass(locale);
	      console.log("locale not found, switching to default [%s]", locale);
	      localStorage.setItem("locale", locale);
	      getLocaleJSON(function () {
	        _init(callback);
	      });
	    });
	  };
	
	  function _init(callback) {
	    applyLocale();
	    $(".page-wrapper").show();
	
	    if (LanguageManager.onInit !== null && typeof LanguageManager.onInit === "function") {
	      LanguageManager.onInit();
	    }
	
	    if (LanguageManager.onInitGlobal !== null && typeof LanguageManager.onInitGlobal === "function") {
	      LanguageManager.onInitGlobal();
	    }
	
	    if (typeof callback === "function") {
	      callback();
	    }
	  }
	
	  LanguageManager.onInit = null;
	
	  LanguageManager.onInitGlobal = null;
	
	  LanguageManager.changeLocale = function (newLocale) {
	    $("html").removeClass(locale).addClass(newLocale);
	    locale = newLocale;
	    localStorage.setItem("locale", locale);
	    LanguageManager.localize();
	  };
	
	  LanguageManager.getCurrentLocale = function () {
	    return locale;
	  };
	
	  LanguageManager.localize = function () {
	    if (!localeMapIsDefined() || locale !== localeMap.locale) {
	      getLocaleJSON(function () {
	        applyLocale();
	      });
	    } else {
	      applyLocale();
	    }
	  };
	
	  LanguageManager.applyLocaleOnHTML = function () {
	    applyLocale();
	  };
	
	  function getLocaleJSON(callback, failCb) {
	    var req = __webpack_require__(116);
	
	    try {
	      var localeRequire = "./" + locale + ".json";
	
	      if ($.inArray(localeRequire, req.keys()) !== -1) {
	        localeMap = req(localeRequire);
	
	        if (typeof callback === "function") {
	          callback();
	        }
	      } else if (typeof failCb === "function") {
	        failCb();
	      } else if (locale !== "nl-BE") {
	        $("html").removeClass(locale).addClass("nl-BE");
	        locale = "nl-BE";
	        localStorage.setItem("locale", locale);
	        getLocaleJSON(callback);
	      } else {
	        alert("Localisation could not be loaded, contact your site administrator.");
	      }
	    } catch (e) {
	      console.error(e);
	    }
	  }
	
	  function applyLocale() {
	    $("[data-localize]").each(function () {
	      var element = $(this);
	      var key = $(this).data("localize");
	
	      if ((typeof localeMap === "undefined" ? "undefined" : _typeof(localeMap)) === "object" && localeMap.localization.hasOwnProperty(key)) {
	        changeTextOrPlaceholder(element, localeMap.localization[key]);
	      } else {
	        changeTextOrPlaceholder(element, key);
	      }
	    });
	  }
	
	  function changeTextOrPlaceholder(element, text) {
	    if (element.is("input") || element.is("textarea")) {
	      //element.attr("placeholder", text.toLowerCase());
	      element.attr("placeholder", text);
	    } else {
	      replaceNodeText(element, text);
	    }
	  }
	
	  function replaceNodeText(element, text) {
	    element.html(text);
	  }
	
	  LanguageManager.getValueForKey = function (key) {
	    if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	      return localeMap.localization[key];
	    } else {
	      return key;
	    }
	  };
	
	  LanguageManager.hasKey = function (key) {
	    return localeMapIsDefined() && localeMap.localization.hasOwnProperty(key);
	  };
	
	  function localeMapIsDefined() {
	    return utils.isNotNull(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
	  }
	})(languageManager);
	
	module.exports = languageManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 23/12/2016.
	 */
	//Styles
	//require("bootstrap-loader"); // Using this module makes it so bootstrap isn't in a separate css file, it puts it as a style element AFTER all the other css files which makes it so you can't override anything anymore. Worked in development but not in test/production
	__webpack_require__(363);
	__webpack_require__(606); // needed for 'icon-ios' (\F370)
	__webpack_require__(607); // 'old' icons which are different/pro in de 5.x version :(
	__webpack_require__(623);
	
	__webpack_require__(398);
	// require("script-loader!Sources/misc/google-analytics");
	var CookieConsentController = __webpack_require__(385);
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var StorageController = __webpack_require__(123);
	var ModalDialog = __webpack_require__(183);
	var User = __webpack_require__(280);
	// Contains jQuery plugin so init this in the shared
	__webpack_require__(226);
	
	// These libs aren't nice and put themselves in window instead of being able to be required into a variable
	// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
	// https://webpack.github.io/docs/shimming-modules.html
	__webpack_require__(734);
	
	var shared = {};
	
	(function (Shared) {
	  Shared.defaultLocale = "nl-BE";
	
	  LanguageManager.onInitGlobal = function () {
	    try {
	      /*cookieconsent.initialise({
	        palette: {
	          popup: {
	            background: "#222222",
	            text: "#ffffff"
	          },
	          button: {
	            background: "#28aae1",
	            text: "#ffffff"
	          }
	        },
	        theme: "classic",
	        content: {
	          message: LanguageManager.getValueForKey("cookies.message"),
	          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
	          link: LanguageManager.getValueForKey("cookies.link.text"),
	          href: LanguageManager.getValueForKey("cookies.link")
	        }
	      });*/
	      CookieConsentController.initialize();
	    } catch (e) {
	      console.error(e);
	    }
	  };
	
	  Shared.isOutdated = function () {
	    return !Modernizr.filereader;
	  };
	
	  Shared.getLocaleFromPath = function () {
	    return utils.getPathSection(1);
	  };
	
	  Shared.getLocaleFromCookie = function () {
	    return utils.readCookie("my.fundels.com.locale");
	  };
	
	  Shared.getUserProfile = function () {
	    var tmpUser = StorageController.getFromLocal(StorageController.keys.LOGGED_IN_USER);
	    return utils.isNotNull(tmpUser) ? new User(tmpUser) : null;
	  };
	
	  Shared.setNavigationHighlight = function (link) {
	    var navbar = $("#navbar .nav.navbar-nav");
	
	    navbar.find("> li").removeClass("active");
	
	    switch (link) {
	      case "myfundels-products":
	        navbar.find("a[href='/products'],a[href='/products']").parent().addClass("active");
	        break;
	      case "myfundels-orders":
	        navbar.find("a[href='/orders']").parent().addClass("active");
	        break;
	      case "myfundels-help":
	        navbar.find("a[href='/help']").parent().addClass("active");
	        break;
	      case "store-info":
	        navbar.find("a[href='/store/info']").parent().addClass("active");
	        break;
	      case "store-catalog":
	        navbar.find("a[href='/store/catalog']").parent().addClass("active");
	        break;
	      default:
	        break;
	    }
	  };
	
	  Shared.setPageProperties = function () {
	    try {
	      var user = shared.getUserProfile();
	
	      if (utils.isNotNull(user)) {
	        $("#user-name-navbar").text(user.displayName);
	
	        if (user.type === "bibnet") {
	          // $("#account-nav-link").addClass("nav-item-hidden");
	          $("#account-nav-link").remove();
	        }
	      } else {
	        // added for validate-ticket page: logged in user must be visible on the page, but page is not secure (can be viewed when not logged in)
	        $("#user-name-navbar").text("");
	        $(".dropdown.profile-menu").hide();
	      }
	
	      var locale = shared.getLocaleFromCookie();
	
	      if (utils.isNull(locale)) locale = shared.getLocaleFromPath();
	      if (utils.isNull(locale)) locale = "nl_BE";
	
	      var isAdminPath = utils.getPathSection(2) === "admin";
	      if (utils.isNotNull(user) && user.isAdmin && !isAdminPath && !$("a[href='/admin']").length) {
	        $("#navbar .nav.navbar-nav").first().append("<li class='divider'><a href='/admin' data-localize='navigation.admin'></a></li>");
	      }
	
	      locale = locale.split("_");
	      var languageCode = locale[0];
	      var countryCode = locale[1];
	      $("#locale-selector-flag").addClass("flag-" + countryCode.toLowerCase());
	      $("#locale-selector-name").text(languageCode.toUpperCase());
	    } catch (e) {
	      console.error(e);
	    }
	  };
	
	  Shared.Dialog = ModalDialog;
	})(shared);
	
	shared.setPageProperties();
	
	if (shared.isOutdated()) {
	  utils.devLog("Browser is outdated, redirecting to /outdated");
	  utils.redirect("/outdated");
	}
	
	// if(__DEVELOPMENT__)
	// {
	//   // __DEVELOPMENT__ is automatically set to false in production builds
	//   // If development --> expose to window
	//   window.dev = require("Sources/misc/dev");
	//   window.shared = shared;
	// }
	
	module.exports = shared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsCookie = __webpack_require__(720);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This gives errors in the browser, don't know why :(
	//const Cookies = require("js-cookie");
	var utils = __webpack_require__(3); /**
	                                             * Created by jv on 13/01/2017.
	                                             */
	
	
	var storageController = {};
	
	(function (StorageController) {
	  StorageController.keys = {
	    LOGGED_IN_USER: "logged_in_user",
	    SUBSCRIPTION_KEY: "subscription_key",
	    ORDER_KEY: "order_key",
	    DIGITAL_BOOK_KEY: "digital_book_key",
	    USER_KEY: "user_key",
	    CUSTOMER_KEY: "customer_key",
	    GROUP_PURCHASE_KEY: "group_purchase_key",
	    STORE_USER_LOCALE: "store_user_locale",
	    STORE_USER_TYPE: "store_user_type",
	    TOKEN_SESSION_LIMIT: "token_session_limit",
	    STORE_PURCHASE_ORDER_REQUIRED: "store_purchase_order_required",
	    ADMIN_ORDERS_FILTERS: "admin_orders_filters",
	    ADMIN_SUBSCRIPTIONS_FILTERS: "admin_subscriptions_filters",
	    COOKIEPOLIYCY_ANALYTICS_CONSENT: "cookiepolicy_analytics_consent"
	  };
	
	  StorageController.clearAll = function () {
	    StorageController.clearSession();
	    StorageController.clearLocal();
	  };
	
	  StorageController.clearSession = function () {
	    sessionStorage.clear();
	  };
	
	  StorageController.clearLocal = function () {
	    localStorage.clear();
	  };
	
	  StorageController.removeFromSession = function (key) {
	    StorageController.saveToSession(key);
	  };
	
	  StorageController.saveToSession = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      // if obj is null then remove
	      if (utils.isUndefined(obj)) {
	        sessionStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          obj = utils.stringifyJSON(obj);
	        }
	
	        sessionStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromSession = function (key) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = sessionStorage.getItem(key);
	
	      if (tmpValue) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.removeFromLocal = function (key) {
	    StorageController.saveToLocal(key);
	  };
	
	  StorageController.saveToLocal = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      if (utils.isUndefined(obj)) {
	        localStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          obj = utils.stringifyJSON(obj);
	        }
	
	        localStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromLocal = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = localStorage.getItem(key);
	
	      if (tmpValue) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.saveCookie = function (name, value, daysUntilExpire) {
	    var options = {};
	    if (utils.isNumber(daysUntilExpire)) {
	      options.expires = daysUntilExpire;
	    }
	
	    _jsCookie2.default.set(name, value, { expires: daysUntilExpire });
	  };
	
	  StorageController.getCookie = function (name) {
	    return _jsCookie2.default.get(name);
	  };
	
	  StorageController.removeCookie = function (name) {
	    _jsCookie2.default.remove(name);
	  };
	
	  function storageKeyIsValid(key) {
	    for (var objKey in StorageController.keys) {
	      if (StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	})(storageController);
	
	module.exports = storageController;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 09/01/2017.
	 */
	var utils = __webpack_require__(3);
	var DataFilter = __webpack_require__(225);
	var elementCreator = __webpack_require__(131);
	var tableTemplate = __webpack_require__(389);
	
	//Styles
	__webpack_require__(615);
	
	/* Usage:
	    var tc = new TableCreator({
	      headers: headers,                      // Determines which properties of the data are shown
	      data: myData,
	      rowIdProperty: "id",                   // This is the property that is used to identify the row (must be on the root of the element)
	      appendTo: "#append-to-this-element",   // Default: "body"
	
	      this.sortable: false,                  // Default: false (depends on the sort property for the headers)
	      this.sortMinLength: 5                  // Default: 5 (if sortable is true, checks if the length is at least this as extra check)
	      this.searchable: false,                // Default: false
	
	      // css classes
	      wrapperClassName: "wrapper",           // Default: fo-wrapper
	      tableClassName: "table",               // Default: fo-table
	      headerClassName: "header",             // Default: fo-header
	      bodyClassName: "body",                 // Default: fo-body
	      rowClassName: "row",                   // Default: fo-row
	      cellClassName: "cell",                 // Default: fo-cell
	
	      headerTemplate: myHeaderTemplate,      // Default: defaultHeaderTemplate (see fundels-table-template for example)
	      bodyTemplate: mybodyTemplate,          // Default: defaultBodyTemplate (see fundels-table-template for example)
	
	      rowIdProperty: property that can be used as unique id for each row
	      onRowClick: whenRowIsClickThisIsCalled  // Default: null (function that is called when a row is clicked, gives the rowIdProperty of the element as parameter 'key')
	      onRender: called before each render
	      afterRender: called after each render (useful if you want to add custom event listeners)
	    });
	
	  tc.create();
	 */
	
	module.exports = function () {
	  function TableCreator(options) {
	    _classCallCheck(this, TableCreator);
	
	    if (!utils.isArray(options.data)) {
	      throw "options.data must be an Array";
	    }
	
	    this.headers = utils.isArray(options.headers) ? options.headers : [];
	    this.data = options.data;
	    this.filteredData = options.data.slice(0);
	
	    this.appendTo = utils.isNotNull(options.appendTo) ? $(options.appendTo) : $("body");
	    this.sortable = utils.isBoolean(options.sortable) ? options.sortable : false;
	    this.sortMinLength = utils.isNotNull(options.sortMinLength) ? options.sortMinLength : 5;
	    this.searchable = utils.isBoolean(options.searchable) ? options.searchable : false;
	
	    this.wrapperClassName = utils.isNullOrEmpty(options.wrapperClassName) ? "fo-wrapper" : options.wrapperClassName;
	    this.tableClassName = utils.isNullOrEmpty(options.tableClassName) ? "fo-table" : options.tableClassName;
	    this.headerClassName = utils.isNullOrEmpty(options.headerClassName) ? "fo-header" : options.headerClassName;
	    this.bodyClassName = utils.isNullOrEmpty(options.bodyClassName) ? "fo-body" : options.bodyClassName;
	    this.rowClassName = utils.isNullOrEmpty(options.rowClassName) ? "fo-row" : options.rowClassName;
	    this.cellClassName = utils.isNullOrEmpty(options.cellClassName) ? "fo-cell" : options.cellClassName;
	
	    this.headerTemplate = utils.isFunction(options.headerTemplate) ? options.headerTemplate : tableTemplate.defaultHeaderTemplate;
	    this.bodyTemplate = utils.isFunction(options.bodyTemplate) ? options.bodyTemplate : tableTemplate.defaultBodyTemplate;
	
	    //If not null it enforces that this property exists
	    this.rowIdProperty = utils.isNullOrEmpty(options.rowIdProperty) ? null : options.rowIdProperty;
	    this.onRowClick = utils.isFunction(options.onRowClick) ? options.onRowClick : null;
	    this.onRender = utils.isFunction(options.onRender) ? options.onRender : null;
	    this.afterRender = utils.isFunction(options.afterRender) ? options.afterRender : null;
	  }
	
	  _createClass(TableCreator, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        var tableElString = elementCreator.createStringElement({
	          tagName: "div",
	          classNames: [this.tableClassName]
	        });
	
	        var wrapperElString = elementCreator.createStringElement({
	          tagName: "div",
	          classNames: [this.wrapperClassName],
	          innerHTML: tableElString
	        });
	
	        this.appendTo.append(wrapperElString);
	        this.rerender();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.filteredData = this.data.slice(0);
	      this.rerender();
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.appendTo.show();
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.appendTo.hide();
	    }
	  }, {
	    key: "rerender",
	    value: function rerender(renderHeader) {
	      if (utils.isFunction(this.onRender)) {
	        this.onRender(this.appendTo);
	      }
	
	      if (renderHeader !== false) {
	        this.renderHeader();
	      }
	
	      this.renderBody();
	
	      if (utils.isFunction(this.afterRender)) {
	        this.afterRender(this.appendTo);
	      }
	
	      this.show();
	    }
	  }, {
	    key: "sort",
	    value: function sort(options) {
	      /*
	       * options.sortKey
	       * options.sortType = ""
	       * options.asc = false;
	       */
	
	      options.sortType = utils.isNull(options.sortType) ? "" : options.sortType;
	      options.asc = utils.isBoolean(options.asc) ? options.asc : false;
	
	      this.filteredData = DataFilter.sort(this.data, options.sortType, options.sortKey, options.asc);
	      this.rerender(false);
	    }
	  }, {
	    key: "filter",
	    value: function filter(options) {
	      /*
	       * options.property = null
	       * options.filterValues = []
	       * options.exact = false
	       * options.propertyType = "undefined"
	       */
	
	      if (this.searchable) {
	        options = utils.isNotNull(options) ? options : {};
	        options.property = utils.isUndefined(options.property) ? null : options.property;
	        options.filterValues = utils.isArray(options.filterValues) ? options.filterValues : [];
	        options.exact = utils.isBoolean(options.exact) ? options.exact : false;
	
	        this.filteredData = DataFilter.filter(this.data, options.property, options.filterValues, options.exact, options.propertyType);
	        this.rerender();
	      }
	    }
	  }, {
	    key: "reload",
	    value: function reload(data) {
	      utils.devLog("Reloading table with new data: %o", data);
	
	      if (!utils.isArray(data)) {
	        throw "data must be an Array";
	      }
	
	      this.data = data;
	      this.filteredData = this.data.slice(0);
	      this.rerender();
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var that = this;
	
	      var mainEl = this.appendTo;
	      mainEl.find("." + this.headerClassName).remove();
	
	      if (this.filteredData.length === 0) {
	        return;
	      }
	
	      var tHeader = elementCreator.createStringElement({
	        tagName: "div",
	        classNames: [this.headerClassName],
	        innerHTML: this.headerTemplate(this.headers, {
	          rowClasses: [that.rowClassName],
	          cellClasses: [that.cellClassName, "header"],
	          sortable: this.sortable && this.data.length >= this.sortMinLength
	        })
	      });
	
	      mainEl.find("." + this.tableClassName).append(tHeader);
	
	      if (this.sortable && this.data.length >= this.sortMinLength) {
	        mainEl.find("." + this.tableClassName + " ." + this.headerClassName + " .sort-link").off("click").on("click", function (e) {
	          var thisEl = $(this);
	          var sortIcons = thisEl.find(".sort-icons");
	          var sortKey = thisEl.attr("data-sort");
	          var sortType = thisEl.attr("data-sort-type");
	          var sortProperty = thisEl.attr("data-sort-property");
	          var asc = false;
	
	          sortKey = utils.isNotNull(sortProperty) ? sortProperty : sortKey;
	
	          if (sortIcons.hasClass("asc")) {
	            sortIcons.removeClass("asc").addClass("desc");
	          } else if (sortIcons.hasClass("desc")) {
	            asc = true;
	            sortIcons.removeClass("desc").addClass("asc");
	          } else {
	            mainEl.find("." + that.tableClassName + " ." + that.headerClassName + " .sort-link .sort-icons").removeClass("asc desc");
	            sortIcons.addClass("desc");
	          }
	
	          that.sort({
	            sortKey: sortKey,
	            sortType: sortType,
	            asc: asc
	          });
	
	          e.stopPropagation();
	        });
	      }
	    }
	  }, {
	    key: "renderBody",
	    value: function renderBody() {
	      var that = this;
	
	      var mainEl = this.appendTo;
	      mainEl.find("." + this.bodyClassName).remove();
	
	      var headerKeys = this.headers.map(function (el, index) {
	        return el.key;
	      });
	
	      var tBodyRows = "";
	
	      var rowClasses = [that.rowClassName];
	
	      if (utils.isFunction(that.onRowClick)) {
	        rowClasses.push("clickable");
	      }
	
	      for (var i = 0; i < this.filteredData.length; i++) {
	        tBodyRows += this.bodyTemplate(headerKeys, this.filteredData[i], {
	          rowClasses: rowClasses,
	          cellClasses: [that.cellClassName],
	          rowIdProperty: this.rowIdProperty,
	          index: i
	        });
	      }
	
	      var tBody = elementCreator.createStringElement({
	        tagName: "div",
	        classNames: [this.bodyClassName],
	        innerHTML: tBodyRows
	      });
	
	      mainEl.find("." + that.tableClassName).append(tBody);
	
	      if (utils.isFunction(that.onRowClick)) {
	        mainEl.find("." + this.tableClassName + " ." + this.bodyClassName + " ." + this.rowClassName).off("click").on("click", function (e) {
	          var selection = getSelection();
	
	          if (utils.isNullOrEmpty(selection.toString()) || !$.contains(e.target, selection.anchorNode)) {
	            // Only allow row clicks if you're not trying to select text from the row
	            var key = $(this).attr("data-row-" + that.rowIdProperty);
	            that.onRowClick(key);
	          }
	        });
	      }
	    }
	  }]);
	
	  return TableCreator;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 12/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	var elementCreator = {};
	
	(function (ElementCreator) {
	  ElementCreator.createStringElement = function (options) {
	    /*
	     * options.tagName = div
	     * options.classNames = []
	     * options.attributes = []
	     * options.value = null
	     */
	    options.tagName = utils.isDefined(options.tagName) ? options.tagName : "div";
	    options.classNames = utils.isArray(options.classNames) ? options.classNames : [];
	    options.attributes = utils.isArray(options.attributes) ? options.attributes : [];
	    options.innerHTML = utils.isDefined(options.innerHTML) ? options.innerHTML : null;
	
	    var classNames = createClassNames(options.classNames);
	    var attributes = createAttributes(options.attributes);
	
	    var element = "<" + options.tagName;
	    element += classNames;
	    element += attributes;
	
	    var isEmptyEl = isEmptyElement(options.tagName);
	
	    if (isEmptyEl) {
	      if (options.tagName === "input") {
	        element += ">";
	      } else {
	        element += "/>";
	      }
	
	      return element;
	    }
	
	    element += ">";
	
	    if (options.innerHTML !== null) {
	
	      element += options.innerHTML;
	    }
	
	    element += getClosingTag(options.tagName);
	
	    return element;
	  };
	
	  ElementCreator.arrayToAttributesString = function (attributes) {
	    var attributeString = "";
	
	    if (utils.isArray(attributes)) {
	      for (var i = 0; i < attributes.length; i++) {
	        var attribute = attributes[i];
	        if (attribute.hasOwnProperty("name") && attribute.hasOwnProperty("value")) {
	          attributeString += i > 0 ? " " : "";
	          attributeString += attribute.name + "='" + attribute.value + "'";
	        }
	      }
	    }
	
	    return attributeString;
	  };
	
	  function getClosingTag(tagName) {
	    return "</" + tagName + ">";
	  }
	
	  function createClassNames(classNames) {
	    var classNamesString = " class='";
	
	    for (var i = 0; i < classNames.length; i++) {
	      if (!utils.isNullOrEmpty(classNames[i])) {
	        classNamesString += (i > 0 ? " " : "") + classNames[i];
	      }
	    }
	
	    classNamesString += "'";
	
	    return classNamesString;
	  }
	
	  function createAttributes(attributes) {
	    var attributesStr = "";
	
	    for (var i = 0; i < attributes.length; i++) {
	      var attr = attributes[i];
	
	      attributesStr += " " + attr.name;
	
	      if (utils.isNotNull(attr.value)) {
	        attributesStr += "='" + attr.value + "'";
	      }
	    }
	
	    return attributesStr;
	  }
	
	  function isEmptyElement(tagName) {
	    var emptyElements = ["input", "img", "svg", "br", "base", "br", "col", "embed", "hr", "link", "meta", "param", "source", "track", "wbr"];
	
	    return $.inArray(tagName, emptyElements) !== -1;
	  }
	})(elementCreator);
	
	module.exports = elementCreator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 20/01/2017.
	 */
	var tooltip = {};
	
	(function (Tooltip) {
	  /*
	   *  options.selector
	   *  options.trigger
	   *  options.title
	   *  options.content
	   *  options.placement
	   */
	  Tooltip.create = function (options) {
	    $(options.selector).popover({
	      content: options.content,
	      title: options.title || "",
	      placement: options.placement || "auto",
	      trigger: options.trigger || "hover",
	      html: true
	    });
	  };
	})(tooltip);
	
	module.exports = tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 14/02/2017.
	 */
	var utils = __webpack_require__(3);
	var Tooltip = __webpack_require__(134);
	var FormGroupTemplate = __webpack_require__(199);
	
	//styles
	//...
	
	module.exports = function () {
	  function FormTemplate(options) {
	    _classCallCheck(this, FormTemplate);
	
	    /*
	     * options.formId
	     * options.appendTo
	     *
	     * options.formData (data to make the FormGroupTemplates)
	     *
	     * options.onRender
	     * options.afterRender
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.formId = options.formId;
	    this.appendTo = $(options.appendTo);
	
	    this.title = options.title;
	    this.titleTooltipTitle = options.titleTooltipTitle;
	    this.titleTooltipText = options.titleTooltipText;
	
	    this.formData = options.formData;
	
	    this.onRender = utils.isFunction(options.onRender) ? options.onRender : null;
	    this.afterRender = utils.isFunction(options.afterRender) ? options.afterRender : null;
	
	    this.formWrapperEl = null;
	
	    this.create();
	  }
	
	  _createClass(FormTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.rerender();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length) {
	        this.formWrapperEl.remove();
	      }
	
	      this._initialized = false;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length) {
	        this.formWrapperEl.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length) {
	        this.formWrapperEl.hide();
	      }
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      this.renderFormWrapper();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      for (var i = 0; i < this.formGroups.length; i++) {
	        this.formGroups[i].reset();
	      }
	    }
	  }, {
	    key: "getFormGroupByKey",
	    value: function getFormGroupByKey(key) {
	      for (var i = 0; i < this.formGroups.length; i++) {
	        if (this.formGroups[i].key === key) return this.formGroups[i];
	      }
	
	      return null;
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var formValid = true;
	
	      for (var i = 0; i < this.formGroups.length; i++) {
	        if (!this.formGroups[i].validate()) {
	          formValid = false;
	        }
	      }
	
	      if (!formValid) {
	        //Do something?
	      }
	
	      return formValid;
	    }
	  }, {
	    key: "renderFormWrapper",
	    value: function renderFormWrapper() {
	      if (utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length) {
	        this.formWrapperEl.remove();
	      }
	
	      this.formWrapperEl = $("<div class='form-wrapper clearfix'></div>");
	
	      if (utils.isNotNull(this.title)) {
	        var formTitleWrapper = $("<div class='clearfix'></div>");
	
	        formTitleWrapper.append("<h4 class='form-title'>" + this.title + "</h4>");
	
	        if (utils.isNotNull(this.titleTooltipText)) {
	          var tooltipBtn = $("<button type='button' class='btn btn-icon frameless question-circle'></button>");
	          formTitleWrapper.append(tooltipBtn);
	
	          Tooltip.create({
	            selector: tooltipBtn,
	            title: this.titleTooltipTitle,
	            content: this.titleTooltipText
	          });
	        }
	
	        this.formWrapperEl.append(formTitleWrapper);
	      }
	
	      if (!utils.isNullOrEmpty(this.formId)) {
	        this.formWrapperEl.attr("id", this.formId);
	      }
	
	      this.formGroups = [];
	
	      for (var i = 0; i < this.formData.length; i++) {
	        var fData = this.formData[i];
	        fData.appendTo = this.formWrapperEl;
	
	        this.formGroups.push(new FormGroupTemplate(fData));
	      }
	
	      this.appendTo.append(this.formWrapperEl);
	    }
	  }, {
	    key: "getDataObject",
	    value: function getDataObject() {
	      var data = {};
	
	      for (var i = 0; i < this.formGroups.length; i++) {
	        if (!this.formGroups.disabled) {
	          if (utils.isNotNull(this.formGroups[i].dataGroup)) {
	            if (!data.hasOwnProperty(this.formGroups[i].dataGroup)) {
	              data[this.formGroups[i].dataGroup] = {};
	            }
	
	            data[this.formGroups[i].dataGroup][this.formGroups[i].key] = this.formGroups[i].value;
	          } else {
	            data[this.formGroups[i].key] = this.formGroups[i].value;
	          }
	        }
	      }
	
	      return data;
	    }
	  }, {
	    key: "getFormGroupForKey",
	    value: function getFormGroupForKey(key) {
	      if (utils.isArray(this.formGroups)) {
	        for (var i = 0; i < this.formGroups.length; i++) {
	          if (this.formGroups[i].key === key) {
	            return this.formGroups[i];
	          }
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return FormTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var utils = __webpack_require__(3);
	var ModalDialog = __webpack_require__(183);
	var StorageController = __webpack_require__(123);
	var Shared = __webpack_require__(115);
	
	var loginManager = {};
	
	(function (LoginManager) {
	  LoginManager.logout = function (callback) {
	    $.ajax({
	      url: "/logout",
	      type: "GET",
	      cache: false
	    }).always(function () {
	      StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
	
	      if (utils.isFunction(callback)) {
	        callback();
	      }
	    });
	  };
	
	  LoginManager.login = function (username, password, successCb, failCb) {
	    LoginManager.logout(function () {
	      _login(username, password, successCb, failCb);
	    });
	  };
	
	  function _login(username, password, successCb, failCb) {
	    $("html").addClass("waiting");
	
	    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
	
	    $.ajax({
	      url: "/access/authenticate/password",
	      type: "POST",
	      cache: false,
	      dataType: "text",
	      // dataType: "xml",
	      data: {
	        username: utils.isDefined(username) ? username : null,
	        password: utils.isDefined(password) ? password : null
	      }
	    }).done(function (data, textStatus, jqXHR) {
	      var xmlDoc = $($.parseXML(data));
	      var referrer = xmlDoc.find("access-control").attr("referer");
	      var xmlData = xmlDoc.find("access-control").find("data").text();
	
	      utils.devLog("Login xml data: %s", xmlData);
	
	      $("html").removeClass("waiting");
	
	      if (isSuccess(xmlDoc)) {
	        xmlData = utils.parseJSON(xmlData, true);
	
	        if (utils.isNotNull(xmlData)) {
	          xmlData = xmlData.result;
	        } else {
	          console.error("User data is empty in login response");
	          return;
	        }
	
	        if (xmlData.authenticated) {
	          if (referrer.includes("/login", 0)) {
	            referrer = "/";
	          }
	
	          if (utils.isFunction(successCb)) {
	            successCb(referrer, xmlData);
	          }
	        } else {
	          // login failed (wrong credentials)
	          if (utils.isFunction(failCb)) {
	            failCb();
	          }
	        }
	      } else if (isError(xmlDoc)) {
	        var errorData = utils.parseJSON(xmlData, true);
	
	        if (utils.isNotNull(errorData) && utils.isNotNull(errorData.incomplete) && errorData.incomplete) {
	          ModalDialog.showMessageDialog("login_page.incomplete_profile.dialog.title", "login_page.incomplete_profile.dialog.message", null, true);
	        } else if (utils.isFunction(failCb)) {
	          failCb();
	        }
	      } else if (utils.isFunction(failCb)) {
	        // always fun to say: should not come here... :)
	        failCb();
	      }
	    }).fail(function (data) {
	      // error in authenticate call
	      console.log(data);
	      $("html").removeClass("waiting");
	
	      if (typeof failCb === "function") {
	        failCb();
	      }
	    });
	  }
	
	  function is(what, xml) {
	    return xml.find("access-control").attr("result") === what;
	  }
	
	  function isSuccess(xml) {
	    return is("success", xml);
	  }
	
	  function isError(xml) {
	    return is("error", xml);
	  }
	
	  LoginManager.isLoggedIn = function (callback) {
	    $.ajax({
	      url: "/access/authorize/principal",
	      type: "GET",
	      cache: false
	    }).done(function (data) {
	      var xmlDoc = $(data);
	
	      var userData;
	
	      if (utils.stringToBoolean(xmlDoc.find("access-control").attr("result")) === true) {
	        var xmlData = xmlDoc.find("access-control").find("data").text();
	
	        xmlData = utils.parseJSON(xmlData, true);
	
	        if (utils.isNotNull(xmlData)) {
	          userData = xmlData.result;
	        }
	      }
	
	      if (utils.isFunction(callback)) {
	        callback(userData);
	      }
	    }).fail(function (data) {
	      if (utils.isFunction(callback)) {
	        callback(null);
	      }
	    });
	  };
	})(loginManager);
	
	module.exports = loginManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 06/02/2017.
	 */
	var utils = __webpack_require__(3);
	var ElementCreator = __webpack_require__(131);
	var FormTemplate = __webpack_require__(135);
	// const FormGroupTemplate = require("Sources/templates/form-group.template");
	
	//styles
	__webpack_require__(611);
	
	module.exports = function () {
	  function DialogFormTemplate(options) {
	    _classCallCheck(this, DialogFormTemplate);
	
	    /*
	     * options.dialogId
	     * options.title
	     * options.disposable
	     *
	     * options.formData (data to make the FormGroupTemplates)
	     *
	     * options.submitText
	     * options.cancelText (if null --> no cancel button)
	     *
	     * options.onSubmit
	     * options.onCancel
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = options.dialogId;
	    this.backdropIdSuffix = "-modal-backdrop";
	    this.title = options.title;
	    this.description = options.description;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	
	    this.formData = options.formData;
	
	    this.submitDisabled = utils.isBoolean(options.submitDisabled) ? options.submitDisabled : false;
	    this.submitText = options.submitText;
	    this.submitWidth = options.submitWidth;
	    this.cancelText = options.cancelText;
	    this.cancelPosition = options.cancelPosition;
	
	    this.onSubmit = options.onSubmit;
	    this.onCancel = options.onCancel;
	
	    this.formTemplate = null;
	
	    this.create();
	  }
	
	  _createClass(DialogFormTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	        this.renderTitle();
	        this.renderDescription();
	        this.renderFormWrapper();
	        this.renderButtons();
	
	        this.backdrop = ElementCreator.createStringElement({
	          classNames: ["modal-backdrop", "fade", "in"],
	          attributes: [{ name: "id", value: this.backdropId }]
	        });
	
	        this.addToDOM();
	
	        if (this.disposable) {
	          this.addDisposeListener();
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	    }
	  }, {
	    key: "renderTitle",
	    value: function renderTitle() {
	      this.dialogEl.find(".modal-content").append("<h3 class='dialog-title'>" + this.title + "</h3>");
	    }
	  }, {
	    key: "renderDescription",
	    value: function renderDescription() {
	      if (!utils.isNullOrEmpty(this.description)) {
	        this.dialogEl.find(".modal-content").append("<p class='dialog-description'>" + this.description + "</p>");
	      }
	    }
	  }, {
	    key: "renderFormWrapper",
	    value: function renderFormWrapper() {
	      if (utils.isNull(this.formTemplate)) {
	        this.formTemplate = new FormTemplate({
	          formId: this.dialogId + "-form",
	          appendTo: this.dialogEl.find(".modal-content"),
	          formData: this.formData
	        });
	
	        this.formData = null;
	      } else {
	        this.formTemplate.rerender();
	      }
	    }
	  }, {
	    key: "renderButtons",
	    value: function renderButtons() {
	      var that = this;
	      var buttonWrapper = $("<div class='button-wrapper clearfix'></div>");
	
	      if (utils.isNotNull(that.cancelText) || that.cancelPosition === "top-right") {
	        var classNames = ["btn", "btn-main", "no-icon", "pull-right"];
	        var innerHTML = that.cancelText;
	
	        if (that.cancelPosition === "top-right") {
	          classNames = ["btn", "btn-icon", "frameless", "cross-circle", "dark-grey", "pull-right"];
	          innerHTML = null;
	        }
	
	        var cancelBtn = $(ElementCreator.createStringElement({
	          tagName: "button",
	          classNames: classNames,
	          attributes: [{ name: "type", value: "button" }],
	          innerHTML: innerHTML
	        }));
	
	        cancelBtn.on("click", function () {
	          that.cancel();
	        });
	
	        if (that.cancelPosition === "top-right") {
	          this.dialogEl.find(".modal-content").prepend(cancelBtn);
	        } else {
	          buttonWrapper.append(cancelBtn);
	        }
	      }
	
	      var submitBtn = $("<button class='btn btn-main no-icon pull-right dft-submit-btn' type='button'>" + that.submitText + "</button>");
	
	      if (utils.isNotNull(that.submitWidth)) {
	        submitBtn.css("width", that.submitWidth);
	      }
	
	      if (this.submitDisabled === true) {
	        submitBtn.prop("disabled", true).addClass("disabled");
	      }
	
	      submitBtn.on("click", function (e) {
	        if (this.submitDisabled === true) {
	          e.preventDefault();
	          return;
	        }
	
	        if (utils.isFunction(that.onSubmit)) {
	          that.onSubmit(that.formTemplate.getDataObject());
	        }
	      });
	
	      buttonWrapper.append(submitBtn);
	      this.dialogEl.find(".modal-content").append(buttonWrapper);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.close();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.formTemplate.reset();
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      return this.formTemplate.validate();
	    }
	  }, {
	    key: "getFormGroupForKey",
	    value: function getFormGroupForKey(key) {
	      if (utils.isNotNull(this.formTemplate)) {
	        return this.formTemplate.getFormGroupForKey(key);
	      }
	
	      return null;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.open();
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists) {
	        $body.append(this.backdrop);
	      }
	
	      // Reading a css property forces layout to be computed
	      this.dialogEl.css("width");
	      this.dialogEl.addClass("in");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.close();
	    }
	  }, {
	    key: "close",
	    value: function close(callback) {
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      $("#" + this.backdropId).remove();
	
	      this.dialogEl.removeClass("in");
	
	      var that = this;
	      setTimeout(function () {
	        that.dialogEl.hide();
	
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }, 150);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var that = this;
	      if (that._destroying !== true) {
	        that._destroying = true;
	        that.close(function () {
	          that.formTemplate.destroy();
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        });
	      }
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	
	        that.cancel();
	      });
	    }
	  }, {
	    key: "addToDOM",
	    value: function addToDOM() {
	      this.dialogEl.appendTo("body");
	    }
	  }, {
	    key: "submitDisabled",
	    set: function set(flag) {
	      this._submitDisabled = flag;
	
	      if (utils.isNotNull(this.dialogEl) && this.dialogEl.length) {
	        var submitBtn = this.dialogEl.find(".dft-submit-btn");;
	
	        if (utils.isNotNull(submitBtn) && submitBtn.length) {
	          submitBtn.prop("disabled", this.submitDisabled);
	
	          if (this.submitDisabled && !submitBtn.hasClass("disabled")) {
	            submitBtn.addClass("disabled");
	          } else {
	            submitBtn.removeClass("disabled");
	          }
	        }
	      }
	    },
	    get: function get() {
	      return this._submitDisabled;
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }]);
	
	  return DialogFormTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 31/03/2017.
	 */
	var utils = __webpack_require__(3);
	
	var adminShared = {};
	
	(function (AdminShared) {
	  AdminShared.setNavigationHighlight = function (link) {
	    var navbar = $("#navbar .nav.navbar-nav");
	
	    navbar.find("> li").removeClass("active");
	
	    switch (link) {
	      case "users":
	        navbar.find("a[href='/admin/users']").parent().addClass("active");
	        break;
	      case "orders":
	        navbar.find("a[href='/admin/orders-overview']").parent().addClass("active");
	        break;
	      case "subscriptions":
	        navbar.find("a[href='/admin/subscriptions-overview']").parent().addClass("active");
	        break;
	      case "customers":
	        navbar.find("a[href='/admin/customers-overview']").parent().addClass("active");
	        break;
	      case "mailing":
	        navbar.find("a[href='/admin/mailing']").parent().addClass("active");
	        break;
	      case "stats":
	        navbar.find("a[href='/admin/stats']").parent().addClass("active");
	        break;
	      default:
	        break;
	    }
	  };
	
	  (function setUpAdminLogo() {
	    var $html = $("html");
	    var $body = $("body");
	
	    if (!$html.hasClass("admin")) {
	      $("html").addClass("admin");
	    }
	
	    var icons = ["paper", "scissors", "rock"];
	
	    $body.append("<span class='admin-indicator " + icons[Math.floor(Math.random() * icons.length)] + "'></span>");
	
	    $(window).scroll(function (e) {
	      setIndicatorTop();
	    });
	
	    function setIndicatorTop() {
	      var scrollTop = $(document).scrollTop();
	      var indicatorEl = $("body > .admin-indicator");
	
	      if (scrollTop < 172) {
	        var tmp = Math.max(172 - scrollTop + 5, 65);
	        indicatorEl.css("top", tmp + "px");
	      } else if (indicatorEl.scrollTop() !== 65) {
	        indicatorEl.css("top", "65px");
	      }
	    }
	
	    setIndicatorTop();
	  })();
	})(adminShared);
	
	module.exports = adminShared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 31/03/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var Error = __webpack_require__(167);
	var Order = __webpack_require__(198);
	var Subscription = __webpack_require__(279);
	var Customer = __webpack_require__(228);
	var SubscriptionHistory = __webpack_require__(368);
	var GroupPurchase = __webpack_require__(367);
	
	var adminServices = {};
	
	(function (AdminServices) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  AdminServices.getOrders = function (filters, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_orders"),
	      cache: false,
	      dataType: "json",
	      contentType: "application/json",
	      data: {
	        keyword: filters.keyword,
	        status: filters.status,
	        orderTypes: filters.orderTypes,
	        offset: filters.offset,
	        limit: filters.limit,
	        fromDate: filters.fromDate,
	        tillDate: filters.tillDate
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var orders = [];
	        var rowCount;
	
	        if (data.result.result.hasOwnProperty("orders")) {
	          for (var i = 0; i < data.result.result.orders.length; i++) {
	            orders.push(new Order(data.result.result.orders[i]));
	          }
	        }
	
	        if (data.result.result.hasOwnProperty("row-count")) {
	          rowCount = data.result.result["row-count"];
	        }
	
	        successCb(orders, rowCount);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getSubscriptions = function (filters, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_subscriptions"),
	      cache: false,
	      dataType: "json",
	      contentType: "application/json",
	      data: {
	        keyword: filters.keyword,
	        status: filters.status,
	        paymentStatus: filters.paymentStatus,
	        subscriptionTypes: filters.subscriptionTypes,
	        offset: filters.offset,
	        limit: filters.limit
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptions = [];
	        var rowCount;
	
	        if (data.result.result.hasOwnProperty("summaries")) {
	          for (var i = 0; i < data.result.result.summaries.length; i++) {
	            subscriptions.push(new Subscription(data.result.result.summaries[i]));
	          }
	        }
	
	        if (data.result.result.hasOwnProperty("row-count")) {
	          rowCount = data.result.result["row-count"];
	        }
	
	        successCb(subscriptions, rowCount);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrderContact = function (contactObj, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("update_order_contact"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "order-number": contactObj.orderNumber,
	        "type": contactObj.type,
	        "firstname": contactObj.firstname,
	        "lastname": contactObj.lastname,
	        "email": contactObj.email,
	        "phone": contactObj.phone,
	        "mobile": contactObj.mobile,
	        "organisation": contactObj.organisation,
	        "address1": contactObj.address1,
	        "address2": contactObj.address2,
	        "zip": contactObj.zip,
	        "city": contactObj.city,
	        "country": contactObj.country,
	        "identification": contactObj.identification
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Order(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrder = function (orderObj, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("admin_update_order"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "number": orderObj.number,
	        "profile-key": orderObj.profileKey,
	        "customer-key": orderObj.customerKey,
	        "type": orderObj.type,
	        "bestelbon-required": orderObj.purchaseOrderRequired,
	        "bestelbon-number": orderObj.purchaseOrderNumber,
	        "vat": orderObj.vat,
	        "company-number": orderObj.companyNumber,
	        "remark": orderObj.remark,
	        "on-hold": orderObj.onHold,
	        "comment": orderObj.comment
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getCustomers = function (keyword, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_customers"),
	      cache: false,
	      dataType: "json",
	      data: {
	        keyword: keyword
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var customers = [];
	
	        if (data.result.result.hasOwnProperty("customer-list")) {
	          for (var i = 0; i < data.result.result["customer-list"].length; i++) {
	            customers.push(new Customer(data.result.result["customer-list"][i]));
	          }
	        }
	
	        successCb(customers);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getCustomerDetails = function (customerKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_get_customer"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "key": customerKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Customer(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateCustomer = function (customerObj, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_customer"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "key": customerObj.key,
	        "type": customerObj.type,
	        "country": customerObj.country,
	        "identification": customerObj.identification,
	        "description": customerObj.description
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrderStatus = function (orderNumber, status, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_order_status"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "number": orderNumber,
	        "status": status
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrderOnHold = function (orderNumber, onHold, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_order_on_hold"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "number": orderNumber,
	        "on-hold": onHold
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrderComment = function (orderNumber, comment, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_order_comment"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "number": orderNumber,
	        "comment": comment
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getSubscriptionsForCustomer = function (customerKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_subscriptions_for_customer"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "customer-key": customerKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptions = [];
	
	        if (data.result.result.hasOwnProperty("summaries")) {
	          for (var i = 0; i < data.result.result.summaries.length; i++) {
	            subscriptions.push(new Subscription(data.result.result.summaries[i]));
	          }
	        }
	
	        successCb(subscriptions);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getOrdersForCustomer = function (customerKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_orders_for_customer"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "customer-key": customerKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var orders = [];
	
	        if (data.result.result.hasOwnProperty("orders")) {
	          for (var i = 0; i < data.result.result.orders.length; i++) {
	            orders.push(new Order(data.result.result.orders[i]));
	          }
	        }
	
	        successCb(orders);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateOrderDelivery = function (dataObj, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_order_delivery"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "number": dataObj.number,
	        "article-codes": dataObj.articleCodes,
	        "delivery-date": dataObj.deliveryDate
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getHistoryForSubscription = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_subscription_history"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var history = [];
	
	        if (data.result.result.hasOwnProperty("subscription-history-list")) {
	          for (var i = 0; i < data.result.result["subscription-history-list"].length; i++) {
	            history.push(new SubscriptionHistory(data.result.result["subscription-history-list"][i]));
	          }
	        }
	
	        successCb(history);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateSubscriptionGrace = function (subscriptionKey, grace, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_subscription_grace"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        grace: grace
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.updateSubscriptionCorrection = function (subscriptionKey, correction, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_update_subscription_correction"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        correction: correction
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getGroupPurchases = function (successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_group_purchases"),
	      cache: false,
	      dataType: "json",
	      data: {}
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var groupPurchases = [];
	
	        if (data.result.result.hasOwnProperty("group-purchase-list")) {
	          for (var i = 0; i < data.result.result["group-purchase-list"].length; i++) {
	            groupPurchases.push(new GroupPurchase(data.result.result["group-purchase-list"][i]));
	          }
	        }
	
	        successCb(groupPurchases);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getGroupPurchase = function (groupPurchaseKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_get_group_purchase"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "group-purchase-key": groupPurchaseKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new GroupPurchase(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getSubscriptionsForGroupPurchase = function (groupPurchaseKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_subscriptions_for_group_purchase"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "group-purchase-key": groupPurchaseKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptions = [];
	
	        if (data.result.result.hasOwnProperty("summaries")) {
	          for (var i = 0; i < data.result.result.summaries.length; i++) {
	            subscriptions.push(new Subscription(data.result.result.summaries[i]));
	          }
	        }
	
	        successCb(subscriptions);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  AdminServices.getOrdersForGroupPurchase = function (groupPurchaseKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("admin_list_orders_for_group_purchase"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "group-purchase-key": groupPurchaseKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var orders = [];
	
	        if (data.result.result.hasOwnProperty("orders")) {
	          for (var i = 0; i < data.result.result.orders.length; i++) {
	            orders.push(new Order(data.result.result.orders[i]));
	          }
	        }
	
	        successCb(orders);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(adminServices);
	
	module.exports = adminServices;

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var ElementCreator = __webpack_require__(131);
	
	//Styles
	__webpack_require__(617);
	
	var template = {};
	
	(function (Template) {
	  Template.createTitle = function (title, customClasses) {
	    if (utils.isNotNull(customClasses) && utils.isString(customClasses)) {
	      customClasses = " " + customClasses;
	    } else {
	      customClasses = "";
	    }
	
	    return "<h4 class='person-info-title" + customClasses + "'>" + title + "</h4>";
	  };
	
	  Template.createInfoWrapper = function (data, options) {
	    var infoWrapperClasses = ["person-info-wrapper", "inner"];
	
	    if (utils.isNotNull(options) && utils.isArray(options.infoWrapperClasses)) {
	      infoWrapperClasses = infoWrapperClasses.concat(options.infoWrapperClasses);
	    }
	
	    var infoWrapperEl = "";
	    for (var i = 0; i < data.length; i++) {
	      var value = normalize(data[i].value);
	
	      if (utils.isArray(value)) {
	        var tmpValue = "";
	        for (var x = 0; x < value.length; x++) {
	          if (utils.isNotNull(value[x])) {
	            tmpValue += ElementCreator.createStringElement({ innerHTML: value[x] });
	          }
	        }
	        value = tmpValue;
	      }
	
	      var classNames = utils.isArray(data[i].options.classNames) ? data[i].options.classNames.join(" ") : "";
	
	      infoWrapperEl += "<div class='" + classNames + "'>";
	
	      if (utils.isNotNull(data[i].label)) {
	        infoWrapperEl += "<div class='person-info-label'>" + LanguageManager.getValueForKey(data[i].label) + "</div>";
	      }
	      infoWrapperEl += "<div class='person-info-value'>" + value + "</div>";
	      infoWrapperEl += "</div>";
	    }
	
	    return ElementCreator.createStringElement({
	      classNames: infoWrapperClasses,
	      innerHTML: infoWrapperEl
	    });
	  };
	
	  function normalize(data) {
	    return utils.isNullOrEmpty(data) ? "-" : data;
	  }
	})(template);
	
	module.exports = template;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var User = __webpack_require__(280);
	var Error = __webpack_require__(167);
	var ProfileSubscriptionGuest = __webpack_require__(375);
	
	var profileServices = {};
	
	(function (ProfileServices) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  ProfileServices.getLoggedInUser = function (username, password, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("login_profile"),
	      cache: false,
	      dataType: "json",
	      data: {
	        username: username,
	        password: password
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new User(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.getProfileFromUserKey = function (userKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_profile_by_userkey"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "user-key": userKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new User(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.resetPassword = function (username, successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("reset_password"),
	      cache: false,
	      dataType: "json",
	      data: {
	        username: username
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.changePassword = function (username, ticket, passwordOld, passwordNew, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("change_password"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "username": username,
	        "ticket": ticket,
	        "password-old": passwordOld,
	        "password-new": passwordNew
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.updateProfile = function (profileData, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("update_profile"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "user-key": profileData.userKey,
	        firstname: profileData.firstname,
	        lastname: profileData.lastname,
	        locale: profileData.locale,
	        newsletter: profileData.newsletter === true ? "1" : "0"
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new User(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.updateIncompleteProfile = function (profileData, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("update_incomplete_profile"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "user-key": profileData.userKey,
	        ticket: profileData.ticket,
	        firstname: profileData.firstname,
	        lastname: profileData.lastname,
	        locale: profileData.locale,
	        "password-new": profileData.password,
	        newsletter: profileData.newsletter === true ? "1" : "0"
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.registerProfile = function (profileData, successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("register_profile"),
	      cache: false,
	      dataType: "json",
	      data: {
	        email: profileData.email,
	        firstname: profileData.firstname,
	        lastname: profileData.lastname,
	        locale: profileData.locale,
	        password: profileData.password
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.verifyEmail = function (code, successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("verify_email"),
	      cache: false,
	      dataType: "json",
	      data: {
	        code: code
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.getProfileSubscriptionGuests = function (profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_profile_subscription_guests"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var guests = [];
	
	        if (data.result.result.hasOwnProperty("profile-subscription-guest-list")) {
	          for (var i = 0; i < data.result.result["profile-subscription-guest-list"].length; i++) {
	            guests.push(new ProfileSubscriptionGuest(data.result.result["profile-subscription-guest-list"][i]));
	          }
	        }
	
	        successCb(guests);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  ProfileServices.requestDeleteProfile = function (successCb, failCb) {
	    ProfileServices.deleteProfile(null, successCb, failCb);
	  };
	
	  ProfileServices.deleteProfile = function (ticket, successCb, failCb) {
	    var commandData = {};
	
	    if (ticket !== null && ticket !== undefined && ticket !== "") {
	      commandData.ticket = ticket;
	    }
	
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("delete_profile"),
	      cache: false,
	      dataType: "json",
	      data: commandData
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(profileServices);
	
	module.exports = profileServices;

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 27/01/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var Order = __webpack_require__(198);
	var Catalog = __webpack_require__(278);
	var SessionData = __webpack_require__(379);
	var Error = __webpack_require__(167);
	
	var storeServices = {};
	
	(function (StoreServices) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  StoreServices.getCatalogList = function (successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("list_catalogs"),
	      cache: false,
	      dataType: "json",
	      contentType: "application/json"
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result["catalog-list"]);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.getCatalog = function (catalogKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_catalog"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "catalog-key": utils.isNotNull(catalogKey) ? catalogKey : null
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Catalog(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.getSessionData = function (successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_session_data"),
	      cache: false,
	      dataType: "json",
	      contentType: "application/json"
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new SessionData(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.clearShoppingCart = function (successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("clear_shopping_cart"),
	      cache: false,
	      dataType: "json",
	      contentType: "application/json"
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new SessionData(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.setCartArticleQuantity = function (articleKey, quantity, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("add_to_shopping_cart"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "catalog-article-key": articleKey,
	        "count": quantity
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new SessionData(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.setOrderInfo = function (orderInfo, successCb, failCb) {
	    // Can't update order info if cart is empty
	    request.post({
	      url: utils.getServiceUrl("send_order_info"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "info-json": utils.stringifyJSON(orderInfo)
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new SessionData(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.placeOrder = function (successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("place_order"),
	      cache: false
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Order(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.getSchoolForId = function (identification, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_school"),
	      cache: false,
	      data: {
	        "number": identification
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.getOffer = function (data, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_offer"),
	      cache: false,
	      data: {
	        "firstname": data.firstname,
	        "lastname": data.lastname,
	        "email": data.email,
	        "organisation": data.organisation
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  StoreServices.getPaymentStatus = function (orderNumber, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_payment_status"),
	      cache: false,
	      data: {
	        "order-number": orderNumber
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(storeServices);
	
	module.exports = storeServices;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 15/03/2017.
	 */
	var Shared = __webpack_require__(115);
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var LoginManager = __webpack_require__(149);
	var StoreServices = __webpack_require__(162);
	var StorageController = __webpack_require__(123);
	
	var storeShared = {};
	
	(function (StoreShared) {
	  StoreShared.isLoggedIn = false;
	  StoreShared.sessionData;
	
	  StoreShared.init = function (callback, forceFetchSessionData) {
	    checkUserType();
	
	    if (StoreShared.getUserType() === "CON") {
	      $("#store-breadcrumb-order-payment").show();
	    }
	
	    LoginManager.isLoggedIn(function (userData) {
	      StoreShared.isLoggedIn = utils.isNotNull(userData) && userData.authenticated;
	
	      utils.devLog("Is logged in: %s --> data: %o", StoreShared.isLoggedIn, userData);
	
	      if (StoreShared.isLoggedIn === true) {
	        // overwrite the current user in session (in case the login came from bibnet)
	        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, userData);
	        Shared.setPageProperties();
	
	        $("#store-login-link").hide();
	        $("#store-profile-menu").show();
	
	        $("a[href='/store/logout']").on("click", function (e) {
	          var originalLink = $(this).attr("href");
	          e.preventDefault();
	
	          if (StoreShared.getUserType() === "BIB") {
	            utils.redirect(originalLink);
	          } else {
	            StoreShared.logout();
	          }
	        });
	      }
	    });
	
	    setUserTypeNavigation();
	
	    setCartQuantity(function () {
	      if (forceFetchSessionData === true && utils.isNull(StoreShared.sessionData)) {
	        getSessionData(callback);
	      } else if (utils.isFunction(callback)) {
	        callback();
	      }
	    });
	  };
	
	  StoreShared.logout = function () {
	    LoginManager.logout(function () {
	      utils.refreshPage();
	    });
	  };
	
	  StoreShared.getUserType = function () {
	    if (utils.isNotNull(StoreShared.sessionData) && utils.isNotNull(StoreShared.sessionData.catalog)) {
	      return StoreShared.sessionData.catalog.type;
	    } else {
	      return StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
	    }
	  };
	
	  StoreShared.getUserLocale = function () {
	    if (utils.isNotNull(StoreShared.sessionData) && utils.isNotNull(StoreShared.sessionData.catalog)) {
	      return StoreShared.sessionData.catalog.locale;
	    } else {
	      return StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
	    }
	  };
	
	  StoreShared.setBreadcrumbHighlighting = function (step) {
	    var storeCrumbs = $(".store-breadcrumb").children();
	
	    if (step < 0 || step > storeCrumbs.length) {
	      return;
	    }
	
	    // if(step === storeCrumbs.length - 1)
	    // {
	    //   storeCrumbs.find("li a").on("click", function(e)
	    //   {
	    //     e.preventDefault();
	    //     return false;
	    //   });
	    // }
	
	    storeCrumbs.each(function (index, el) {
	      var $el = $(el);
	
	      if ($el.hasClass("back-link")) {
	        return;
	      }
	
	      if (index === step - 1) {
	        $el.addClass("active");
	
	        $el.find("a").on("click", function (e) {
	          e.preventDefault();
	          return false;
	        });
	      } else if (index > step - 1 /* || step === storeCrumbs.length - 1*/) {
	          $el.addClass("disabled");
	          $el.find("a").on("click", function (e) {
	            e.preventDefault();
	            return false;
	          });
	        }
	    });
	  };
	
	  function setCartQuantity(callback) {
	    var cartQuantityEl = $("#shopping-cart-quantity");
	
	    if (cartQuantityEl.length) {
	      if (utils.isNull(StoreShared.sessionData)) {
	        getSessionData(function () {
	          cartQuantityEl.text(StoreShared.sessionData.cart.itemCount);
	
	          if (utils.isFunction(callback)) {
	            callback();
	          }
	        });
	      } else {
	        cartQuantityEl.text(StoreShared.sessionData.cart.itemCount);
	
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }
	    } else if (utils.isFunction(callback)) {
	      callback();
	    }
	  }
	
	  function setUserTypeNavigation() {
	    var locale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
	    var userType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
	
	    $("#change-user-type-link").html(LanguageManager.getValueForKey("navigation.store.user_type.catalog") + getCountryFlagForUserType(locale) + getIconForUserType(userType)).on("click", function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	
	      var link = $(this).attr("href");
	
	      if (StoreShared.sessionData.cart.itemCount > 0) {
	        Shared.Dialog.showYesNoDialog("store.change_user_type.confirmation.title", "store.change_user_type.confirmation.text", function () {
	          utils.redirect(link);
	        });
	      } else {
	        utils.redirect(link);
	      }
	    });
	  }
	
	  StoreShared.getReadableLocale = function (locale) {
	    switch (locale) {
	      case "nl_BE":
	        return LanguageManager.getValueForKey("store.user_type_selection.countries.belgium");
	      case "nl_NL":
	        return LanguageManager.getValueForKey("store.user_type_selection.countries.netherlands");
	      default:
	        return null;
	    }
	  };
	
	  StoreShared.getReadableUserType = function (userType) {
	    switch (userType) {
	      case "BIB":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.library");
	      case "SCH":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.school");
	      case "AND":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.other");
	      case "CON":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.consumer");
	      case "LOG":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.logopedist");
	      case "KND":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.daycare");
	      case "PSZ":
	        return LanguageManager.getValueForKey("store.user_type_selection.user_types.daycare_nl");
	      default:
	        return null;
	    }
	  };
	
	  function getCountryFlagForUserType(locale) {
	    switch (locale) {
	      case "nl_BE":
	        return "<i class='icon-img icon-img-flag-belgium'></i>";
	      case "nl_NL":
	        return "<i class='icon-img icon-img-flag-netherlands'></i>";
	      default:
	        return null;
	    }
	  }
	
	  function getIconForUserType(userType) {
	    switch (userType) {
	      case "BIB":
	        return "<i class='icon-img icon-img-library'></i>";
	      case "SCH":
	        return "<i class='icon-img icon-img-school'></i>";
	      case "AND":
	        return "<i class='icon-img icon-img-other'></i>";
	      case "CON":
	        return "<i class='icon-img icon-img-consumer'></i>";
	      case "LOG":
	        return "<i class='icon-img icon-img-logopaedics'></i>";
	      case "KND":
	        return "<i class='icon-img icon-img-daycare'></i>";
	      case "PSZ":
	        return "<i class='icon-img icon-img-daycare'></i>";
	      default:
	        return null;
	    }
	  }
	
	  function checkUserType() {
	    if (utils.getPathSection(2) === "store" && (utils.getPathSection(3) === "info" || utils.getPathSection(3) === "catalog")) {
	      var userLocale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
	      var userType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
	
	      var userLocaleUrl = utils.getPathSection(1);
	      var userTypeUrl = urlPathToUserType(utils.getPathSection(4));
	
	      if (utils.isNotNull(userLocaleUrl) && userLocale !== userLocaleUrl) {
	        StorageController.saveToLocal(StorageController.keys.STORE_USER_LOCALE, userLocaleUrl);
	      }
	
	      if (utils.isNotNull(userTypeUrl) && userType !== userTypeUrl) {
	        StorageController.saveToLocal(StorageController.keys.STORE_USER_TYPE, userTypeUrl);
	      }
	    }
	  }
	
	  function urlPathToUserType(path) {
	    switch (path.toLowerCase()) {
	      case "school":
	        return "SCH";
	      case "library":
	        return "BIB";
	      case "other":
	        return "AND";
	      case "consumer":
	        return "CON";
	      case "logopaedics":
	        return "LOG";
	      default:
	        return null;
	    }
	  }
	
	  function getSessionData(callback) {
	    StoreServices.getSessionData(function (data) {
	      // Success
	      StoreShared.sessionData = data;
	
	      utils.devLog("Session data: %o", StoreShared.sessionData);
	
	      if (utils.isFunction(callback)) {
	        callback();
	      }
	    }, function (data) {
	      // Failed
	      console.error("Something went wrong trying to fetch session data");
	    });
	  }
	})(storeShared);
	
	if (false) {
	  window.storeShared = storeShared;
	}
	
	module.exports = storeShared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/03/2017.
	 */
	var utils = __webpack_require__(3);
	
	var knownErrors = ["E95382", "E45370", "E15688", "E79658", "E94337", "E35077", "E76947", "E12319", "E55862", "E55862", "E12159", "E97135", "E85246", "E97581", "E98334", "E98712", "E91684", "E78654", "E64825", "E97316", "E39824", "E78924", "E97357", "E65591", "E99761", "E54652", "E25748", "E23515", "E76378", "E37392", "E14125", "E12796", "E61269", "E87805", "E78220", "E69920", "E77753", "E89251", "E98264", "E65824", "E35712", "E55322", "E26024", "E53496", "E85936", "E22663", "E73541", "E96293", "E38630"];
	
	module.exports = function () {
	  function Error(options) {
	    _classCallCheck(this, Error);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.code;
	    this.message = options.message;
	  }
	
	  _createClass(Error, [{
	    key: "readableErrorTitle",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".title";
	      }
	
	      return "errors.services.general.title";
	    }
	  }, {
	    key: "readableErrorMessage",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".message";
	      }
	
	      return "errors.services.general.message";
	    }
	  }]);
	
	  return Error;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var Subscription = __webpack_require__(279);
	var Product = __webpack_require__(374);
	var DigitalPurchase = __webpack_require__(370);
	var SubscriptionModule = __webpack_require__(382);
	var SubscriptionGuest = __webpack_require__(381);
	var SubscriptionUser = __webpack_require__(383);
	var Ticket = __webpack_require__(230);
	var SubscriptionBorrow = __webpack_require__(380);
	var Error = __webpack_require__(167);
	
	var subscriptionServices = {};
	
	(function (SubscriptionServices) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  SubscriptionServices.getSubscriptionsForProfile = function (profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscriptions_for_user"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptions = [];
	
	        if (data.result.result.hasOwnProperty("summaries")) {
	          for (var i = 0; i < data.result.result.summaries.length; i++) {
	            subscriptions.push(new Subscription(data.result.result.summaries[i]));
	          }
	        }
	
	        successCb(subscriptions);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getLinkedSubscriptionsForProfile = function (profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_linked_subscriptions_for_user"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptions = [];
	
	        if (data.result.result.hasOwnProperty("summaries")) {
	          for (var i = 0; i < data.result.result.summaries.length; i++) {
	            subscriptions.push(new Subscription(data.result.result.summaries[i]));
	          }
	        }
	
	        successCb(subscriptions);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getDigitalPurchasesForProfile = function (profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("list_digital_purchases"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var digitalPurchases = [];
	
	        if (data.result.result.hasOwnProperty("digital-purchase-list")) {
	          for (var i = 0; i < data.result.result["digital-purchase-list"].length; i++) {
	            digitalPurchases.push(new DigitalPurchase(data.result.result["digital-purchase-list"][i]));
	          }
	        }
	
	        successCb(digitalPurchases);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getSubscriptionDetails = function (key, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_details"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": key
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Subscription(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getOrdersForSubscription = function (key, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("list_orders_for_subscription"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": key
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result.orders);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getActivationsForToken = function (tokenKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_activations_for_token"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "token-key": tokenKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result.activations);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.updateToken = function (tokenKey, extraInstallations, extraUsers, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("update_token"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "token-key": tokenKey,
	        "extra-installations": extraInstallations,
	        "extra-users": extraUsers
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.deleteActivation = function (installationId, userKey, tokenKey, successCb, failCb) {
	    request.post({ // Should actually be DELETE but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("delete_activation") + "?key=" + tokenKey,
	      cache: false,
	      dataType: "json",
	      data: {
	        "installation-id": installationId,
	        "user-key": userKey,
	        "token-key": tokenKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.updateContact = function (contactObj, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("update_subscription_contact"),
	      cache: false,
	      dataType: "json",
	      data: contactObj
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Subscription(data.result.result));
	
	        // if(utils.isArray(data.result.result.contacts) && data.result.result.contacts.length === 1)
	        // {
	        //   successCb(data.result.result.contacts[0]);
	        // }
	        // else
	        // {
	        //   utils.devLog("JSON result is not consistent - expected data.result.result.contacts with 1 contact");
	        //   successCb(data.result.result);
	        // }
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.addInvolvedPerson = function (subscriptionKey, email, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("add_subscription_involved_person"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "email": email
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        // successCb(new User(data.result.result));
	        successCb(new Subscription(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.removeInvolvedPerson = function (subscriptionKey, profileKey, successCb, failCb) {
	    request.post({ // Should actually be DELETE but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("remove_subscription_involved_person"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        // successCb(data);
	        successCb(new Subscription(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.renewSubscription = function (subscriptionKey, purchaseOrderNumber, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("extend_subscription"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "bestelbon-number": purchaseOrderNumber
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.cancelSubscription = function (subscriptionKey, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("cancel_subscription"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.updateSubscription = function (data, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("update_subscription"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": data.subscriptionKey,
	        "prolong": data.prolong,
	        "bestelbon-required": data.purchaseOrderRequired,
	        "vat": data.vatNumber,
	        "company-number": data.companyNumber
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.sendSubscriptionOffer = function (subscriptionKey, successCb, failCb) {
	    request.post({
	      url: utils.getServiceUrl("get_subscription_offer"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getSubscriptionModules = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_modules"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var modules = [];
	
	        if (data.result.result.hasOwnProperty("subscription-module-list")) {
	          for (var i = 0; i < data.result.result["subscription-module-list"].length; i++) {
	            modules.push(new SubscriptionModule(data.result.result["subscription-module-list"][i]));
	          }
	        }
	
	        successCb(modules);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getSubscriptionGuests = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_guests"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var guests = [];
	
	        if (data.result.result.hasOwnProperty("subscription-guest-list")) {
	          for (var i = 0; i < data.result.result["subscription-guest-list"].length; i++) {
	            guests.push(new SubscriptionGuest(data.result.result["subscription-guest-list"][i]));
	          }
	        }
	
	        successCb(guests);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  //  SubscriptionServices.inviteHighschoolStudent = function(subscriptionKey, email, successCb, failCb)
	  //  {
	  //    request.get({
	  //        url:  utils.getServiceUrl("invite_highschool_student"),
	  //        cache: false,
	  //        dataType: "json",
	  //        data: {
	  //          "subscription-key": subscriptionKey,
	  //          "email" : email
	  //        }
	  //      },
	  //      function(data)
	  //      {
	  //        if(utils.isFunction(successCb))
	  //        {
	  //          successCb();
	  //        }
	  //      },
	  //      function(data)
	  //      {
	  //        dataToError(data, failCb);
	  //      });
	  //  };
	
	  SubscriptionServices.addSubscriptionGuest = function (subscriptionKey, emailList, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("add_subscription_guest"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "email-list": emailList
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.deleteSubscriptionGuest = function (subscriptionKey, subscriptionGuestKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("delete_subscription_guest"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "subscription-guest-key": subscriptionGuestKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.addSubscriptionUser = function (subscriptionKey, email, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("add_subscription_user"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "email": email
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.deleteSubscriptionUser = function (subscriptionKey, profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("delete_subscription_user"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getSubscriptionUsers = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_users"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var users = [];
	
	        if (data.result.result.hasOwnProperty("subscription-user-list")) {
	          for (var i = 0; i < data.result.result["subscription-user-list"].length; i++) {
	            users.push(new SubscriptionUser(data.result.result["subscription-user-list"][i]));
	          }
	        }
	
	        successCb(users);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.listProductsForSubscription = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_products"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var products = [];
	
	        if (data.result.result.hasOwnProperty("wapiti-product-list")) {
	          for (var i = 0; i < data.result.result["wapiti-product-list"].length; i++) {
	            products.push(new Product(data.result.result["wapiti-product-list"][i]));
	          }
	        }
	
	        successCb(products);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.listSubscriptionTickets = function (subscriptionKey, ticketType, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_tickets"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "ticket-type": ticketType
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var tickets = [];
	
	        if (data.result.result.hasOwnProperty("ticket-list")) {
	          for (var i = 0; i < data.result.result["ticket-list"].length; i++) {
	            tickets.push(new Ticket(data.result.result["ticket-list"][i]));
	          }
	        }
	
	        successCb(tickets);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.addBorrowForSubscription = function (subscriptionKey, productKey, title, count, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("add_subscription_borrow"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey,
	        "product-key": productKey,
	        "product-name": title,
	        "count": count
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        if (data.result.hasOwnProperty("url")) {
	          successCb(data.result["url"]);
	        }
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.getSubscriptionBorrowList = function (subscriptionKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_subscription_borrows"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "subscription-key": subscriptionKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var subscriptionBorrowList = [];
	
	        if (data.result.result.hasOwnProperty("subscription-borrow-list")) {
	          for (var i = 0; i < data.result.result["subscription-borrow-list"].length; i++) {
	            subscriptionBorrowList.push(new SubscriptionBorrow(data.result.result["subscription-borrow-list"][i]));
	          }
	        }
	
	        successCb(subscriptionBorrowList);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  SubscriptionServices.requestDemo = function (type, organisation, role, street, number, zip, city, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("request_demo"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "type": type,
	        "organisation": organisation,
	        "role": role,
	        "street": street,
	        "number": number,
	        "zip": zip,
	        "city": city
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb();
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(subscriptionServices);
	
	module.exports = subscriptionServices;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	var request = {};
	
	(function (Request) {
	  Request.get = function (options, successCb, failCb) {
	    options.type = "GET";
	    doRequest(options, successCb, failCb);
	  };
	
	  Request.post = function (options, successCb, failCb) {
	    options.type = "POST";
	    doRequest(options, successCb, failCb);
	  };
	
	  Request.put = function (options, successCb, failCb) {
	    options.type = "PUT";
	    doRequest(options, successCb, failCb);
	  };
	
	  function doRequest(options, successCb, failCb) {
	    var startTime = Date.now();
	    utils.devLog("Request:\nmethod: %s\nurl: %s,\ndata: %o", options.type, options.url, options.data);
	
	    // Download / Upload progress
	    if (utils.isFunction(options.onProgress) || utils.isFunction(options.onUploadProgress)) {
	      options.xhr = function () {
	        var xhr = new window.XMLHttpRequest();
	
	        if (utils.isFunction(options.onUploadProgress)) {
	          xhr.upload.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onUploadProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        if (utils.isFunction(options.onProgress)) {
	          xhr.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        return xhr;
	      };
	    }
	
	    // Request (order matters! in this case: always -> done / fail)
	    $.ajax(options).always(function (data, textStatus) {
	      if (false) {
	        var executeTime = Date.now() - startTime;
	        executeTime = executeTime / 1000 + "s";
	
	        var css = "background-color: #222;color: #bada55;";
	        console.log("%cRequest complete%c\nurl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\nResult: %o",
	        /*empty string to reset css*/
	        css, "", options.url, options.type, textStatus, executeTime, data);
	      }
	    }).done(function (data) {
	      if (utils.isFunction(successCb) && !data.hasOwnProperty("exception")) {
	        successCb(data);
	      } else if (utils.isFunction(failCb) && data.hasOwnProperty("exception")) {
	        failCb(data);
	      }
	    }).fail(function (data) {
	      if (utils.isFunction(failCb)) {
	        failCb(data);
	      }
	    });
	  }
	})(request);
	
	module.exports = request;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var utils = __webpack_require__(3);
	
	var dialog = function () {
	  var Dialog = {};
	
	  var LanguageManager = __webpack_require__(5);
	
	  Dialog.showMessageDialog = function (title, message, callback, disposable) {
	    setDialogText(title, message, "modal.buttons.ok", "");
	
	    changeModalClickHandlers(callback);
	
	    show(disposable);
	  };
	
	  Dialog.showOkCancelDialog = function (title, message, okCallback, cancelCallback, disposable) {
	    setDialogText(title, message, "modal.buttons.ok", "modal.buttons.cancel");
	
	    changeModalClickHandlers(okCallback, cancelCallback);
	
	    show(disposable);
	  };
	
	  Dialog.showYesNoDialog = function (title, message, yesCallback, noCallback, disposable) {
	    setDialogText(title, message, "modal.buttons.yes", "modal.buttons.no");
	
	    changeModalClickHandlers(yesCallback, noCallback);
	
	    show(disposable);
	  };
	
	  Dialog.showCustomDialog = function (html, top, disposable) {
	    setDialogContent(html);
	
	    show(disposable, top);
	  };
	
	  Dialog.showDialog = function () {
	    show();
	  };
	
	  Dialog.hideDialog = function () {
	    hide();
	  };
	
	  function resetDialog() {
	    var initialContent = "<div class=\"modal-header\">" + "<h4 id=\"dialog-title\"></h4>" + "</div>" + "<div class=\"modal-body\">" + "<p id=\"dialog-body-content\"></p>" + "</div>" + "<div class=\"modal-footer\">" + "<button id=\"dialog-btn1\" type=\"button\" class=\"btn btn-main no-icon message_dialog_button\"></button>" + "<button id=\"dialog-btn2\" type=\"button\" class=\"btn btn-main no-icon message_dialog_button\"></button>" + "</div>";
	
	    var dialog = $("#modal-dialog");
	    dialog.find(".modal-content").empty().html(initialContent);
	  }
	
	  function setDialogText(title, message, button1, button2) {
	    resetDialog();
	
	    var titleEl = $("#dialog-title");
	    var textEl = $("#dialog-body-content");
	    var btn1El = $("#dialog-btn1");
	    var btn2El = $("#dialog-btn2");
	
	    if (utils.isNullOrEmpty(button1)) {
	      btn1El.hide();
	    } else {
	      btn1El.show();
	    }
	
	    if (utils.isNullOrEmpty(button2)) {
	      btn2El.hide();
	    } else {
	      btn2El.show();
	    }
	
	    if (!utils.isNullOrEmpty(button1) && utils.isNullOrEmpty(button2)) {
	      btn1El.css("float", "none");
	      btn1El.css("width", "100%");
	    } else if (utils.isNullOrEmpty(button1) && !utils.isNullOrEmpty(button2)) {
	      btn2El.css("float", "none");
	      btn2El.css("width", "100%");
	    }
	
	    titleEl.html(LanguageManager.getValueForKey(title)).attr("data-localize", title);
	    textEl.html(LanguageManager.getValueForKey(message)).attr("data-localize", message);
	    btn1El.html(LanguageManager.getValueForKey(button1)).attr("data-localize", button1);
	    btn2El.html(LanguageManager.getValueForKey(button2)).attr("data-localize", button2);
	  };
	
	  function changeModalClickHandlers(button1Cb, button2Cb) {
	    $("#dialog-btn1").off();
	    $("#dialog-btn2").off();
	
	    $("#dialog-btn1").on("click", function (e) {
	      Dialog.hideDialog();
	      if (button1Cb !== null && typeof button1Cb === "function") {
	        button1Cb(e);
	      }
	    });
	
	    $("#dialog-btn2").on("click", function (e) {
	      Dialog.hideDialog();
	      if (button2Cb !== null && typeof button2Cb === "function") {
	        button2Cb(e);
	      }
	    });
	  };
	
	  function setDialogContent(html) {
	    var dialogEl = $("#modal-dialog").find(".modal-content").empty();
	
	    if (utils.isString(html)) {
	      dialogEl.html(html);
	    } else {
	      dialogEl.append(html);
	    }
	  };
	
	  function show(disposable, top) {
	    addBackdrop(disposable);
	    $("body").addClass("modal-open");
	    var dialog = $("#modal-dialog").focus();
	    dialog.show();
	    dialog[0].offsetWidth;
	    dialog.addClass("in");
	
	    if (top === true) {
	      dialog.find(".modal-dialog").addClass("top");
	    }
	  };
	
	  function hide() {
	    $("#modal-backdrop").remove();
	    $("body").removeClass("modal-open");
	    var dialog = $("#modal-dialog");
	    dialog.removeClass("in");
	    setTimeout(function () {
	      dialog.hide();
	      dialog.find(".modal-dialog").removeClass("top");
	    }, 200);
	  };
	
	  function addBackdrop(disposable) {
	    if ($("#modal-backdrop").length) return;
	
	    var backdrop = document.createElement("div");
	    backdrop.id = "modal-backdrop";
	    backdrop.className = "modal-backdrop fade";
	
	    $("body").append(backdrop);
	    $("#modal-backdrop").addClass("in");
	
	    if (typeof disposable === "undefined" || disposable === true) {
	      $("#modal-dialog").off().on("click", function (e) {
	        if (e.target.className === ".modal-content" || $(e.target).closest(".modal-content").length) {
	          e.preventDefault();
	          e.stopPropagation();
	          return;
	        }
	
	        Dialog.hideDialog();
	      });
	    } else {
	      $("#modal-dialog").off();
	    }
	  }
	
	  return Dialog;
	}();
	
	module.exports = dialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var utils = __webpack_require__(3);
	var moment = __webpack_require__(1);
	var LanguageManager = __webpack_require__(5);
	var Contact = __webpack_require__(229);
	var Article = __webpack_require__(369);
	var Invoice = __webpack_require__(371);
	var Customer = __webpack_require__(228);
	
	module.exports = function () {
	  function Order(options) {
	    _classCallCheck(this, Order);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.number = options.number || options["order-number"];
	
	    this.profileKey = options["profile-key"];
	
	    this.type = options.type || options["order-type"];
	    this.status = options.status || options["order-status"];
	    this.onHold = options["on-hold"];
	    this.groupPurchaseKey = options["group-purchase-key"];
	
	    this.editable = options["can-be-edited"];
	    this.cancellable = options["can-be-cancelled"];
	
	    this.invoice = options.invoice;
	
	    this.contacts = utils.isArray(options.contacts) ? options.contacts : [];
	
	    this.articles = utils.isArray(options["order-articles"]) ? options["order-articles"] : [];
	
	    this.totalPrice = options["total-price"];
	    this.payReference = options["pay-reference"];
	    this.purchaseOrderNumber = options["bestelbon-number"];
	    this.vat = options.vat;
	    this.companyNumber = options["company-number"];
	
	    this.purchaseOrderRequired = options["bestelbon-required"];
	
	    this.paymentOk = options["payment-ok"];
	    this.cancelled = options.cancelled;
	    this.remark = options.remark;
	
	    this.comment = options.comment;
	
	    this.created = options.created || options["order-created"];
	
	    if (utils.isDefined(options.customer)) {
	      this.customer = options.customer;
	    }
	
	    // Work around for order summary JSON sturcture (manually add a contact with key 'CON')
	    if (utils.isDefined(options["person-firstname"]) && utils.isDefined(options["person-lastname"]) && utils.isDefined(options["organisation-name"]) && utils.isDefined(options["organisation-city"])) {
	      this.addContact({
	        person: {
	          firstname: utils.isNotNull(options["person-firstname"]) ? options["person-firstname"] : "",
	          lastname: utils.isNotNull(options["person-lastname"]) ? options["person-lastname"] : ""
	        },
	        organisation: {
	          name: options["organisation-name"],
	          city: options["organisation-city"]
	        },
	        type: "CON"
	      });
	    }
	  }
	
	  _createClass(Order, [{
	    key: "addContact",
	    value: function addContact(options) {
	      this.contacts.push(new Contact(options));
	    }
	  }, {
	    key: "getContactForType",
	    value: function getContactForType(type) {
	      for (var i = 0; i < this.contacts.length; i++) {
	        if (this.contacts[i].type === type) {
	          return this.contacts[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "isGroupPurchase",
	    get: function get() {
	      return utils.isNotNull(this.groupPurchaseKey) ? "globals.options.yes" : "globals.options.no";
	    }
	  }, {
	    key: "customer",
	    set: function set(customer) {
	      this._customer = new Customer(customer);
	    },
	    get: function get() {
	      return this._customer;
	    }
	  }, {
	    key: "customerKey",
	    get: function get() {
	      return utils.isNotNull(this.customer) ? this.customer.key : null;
	    }
	  }, {
	    key: "created",
	    set: function set(date) {
	      this._created = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._created) ? this._created.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "contacts",
	    set: function set(contacts) {
	      this._contacts = [];
	
	      if (utils.isArray(contacts)) {
	        for (var i = 0; i < contacts.length; i++) {
	          this._contacts.push(new Contact(contacts[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._contacts;
	    }
	  }, {
	    key: "contactFullname",
	    get: function get() {
	      var contactPerson = this.getContactForType("CON");
	
	      if (utils.isNotNull(contactPerson)) {
	        return contactPerson.person.firstname + " " + contactPerson.person.lastname;
	      }
	
	      return null;
	    }
	  }, {
	    key: "organisation",
	    get: function get() {
	      var contactPerson = this.getContactForType("CON");
	
	      return utils.isNotNull(contactPerson) ? contactPerson.organisation.name : null;
	    }
	  }, {
	    key: "city",
	    get: function get() {
	      var contactPerson = this.getContactForType("CON");
	
	      return utils.isNotNull(contactPerson) ? contactPerson.organisation.city : null;
	    }
	  }, {
	    key: "invoice",
	    set: function set(invoice) {
	      this._invoice = new Invoice(invoice);
	    },
	    get: function get() {
	      return this._invoice;
	    }
	  }, {
	    key: "articles",
	    set: function set(articles) {
	      this._articles = [];
	
	      if (utils.isArray(articles)) {
	        for (var i = 0; i < articles.length; i++) {
	          this._articles.push(new Article(articles[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._articles;
	    }
	  }, {
	    key: "readableStatus",
	    get: function get() {
	      switch (this.status) {
	        case "payed":
	        case "complete":
	          return "subscription_details.payment_status.payed";
	        case "awaiting_approval":
	        case "awaiting_invoice":
	          return "subscription_details.payment_status.processing";
	        case "awaiting_payment":
	          return "subscription_details.payment_status.processing_payment";
	        case "awaiting_delivery":
	          return "subscription_details.payment_status.processing_delivery";
	        case "cancelled":
	        case "awaiting_cancellation":
	          return "subscription_details.payment_status.cancelled";
	        default:
	          return this.status;
	      }
	    }
	  }, {
	    key: "readableVatNumber",
	    get: function get() {
	      return utils.isNullOrEmpty(this.vat) ? "-" : this.vat;
	    }
	  }, {
	    key: "readableCompanyNumber",
	    get: function get() {
	      return utils.isNullOrEmpty(this.companyNumber) ? "-" : this.companyNumber;
	    }
	  }, {
	    key: "readablePurchaseOrderRequired",
	    get: function get() {
	      return this.purchaseOrderRequired ? "globals.options.yes" : "globals.options.no";
	    }
	  }, {
	    key: "readablePurchaseOrderNumber",
	    get: function get() {
	      return utils.isNull(this.purchaseOrderNumber) ? "-" : this.purchaseOrderNumber;
	    }
	  }, {
	    key: "readablePayReference",
	    get: function get() {
	      return utils.isNull(this.payReference) ? "-" : this.payReference;
	    }
	  }, {
	    key: "undeliveredArticles",
	    get: function get() {
	      var undeliveredArticles = [];
	
	      for (var i = 0; i < this.articles.length; i++) {
	        if (this.articles[i].physicalDelivery === true && utils.isNull(this.articles[i].delivered)) {
	          undeliveredArticles.push(this.articles[i]);
	        }
	      }
	
	      return undeliveredArticles;
	    }
	  }]);
	
	  return Order;
	}();

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 03/02/2017.
	 */
	var utils = __webpack_require__(3);
	var ElementCreator = __webpack_require__(131);
	var InputSpinner = __webpack_require__(226);
	var Tooltip = __webpack_require__(134);
	__webpack_require__(731);
	
	__webpack_require__(604);
	__webpack_require__(612);
	
	module.exports = function () {
	  function FormGroupTemplate(options) {
	    _classCallCheck(this, FormGroupTemplate);
	
	    /*
	     * options.key
	     * options.dataGroup
	     * options.inputId
	     *
	     * options.appendTo
	     * options.label ( null or undefined for no label)
	     * options.inline (true | false)
	     *
	     * options.formGroupClasses
	     * options.labelClasses
	     * options.inputClasses
	     * options.inputErrorClass
	     *
	     * options.initialValue
	     * options.required
	     * options.inputType (text | number | range | select | password | textarea)
	     * options.inputOptions (if inputType === select)
	     * options.inputAttributes (eg. [ { name: 'max-length', value: 10 } ] )
	     *
	     * options.inputOptionsValueField (only used for "select" inputType)
	     * options.inputOptionsDisplayField (only used for "select" inputType)
	     *
	     *
	     * options.inputHTML
	     *
	     * options.validator
	     * options.onInputChange
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    if (utils.isNullOrEmpty(options.key)) {
	      throw "Key cannot be null or empty";
	    }
	
	    this.key = options.key;
	    this.dataGroup = options.dataGroup;
	
	    this.inputId = utils.isNullOrEmpty(options.inputId) ? this.key.toLowerCase() + "-" + utils.generateUIDShort() : options.inputId;
	
	    this.appendTo = $(options.appendTo);
	    this.label = options.label;
	    this.labelTooltipTitle = options.labelTooltipTitle;
	    this.labelTooltipText = options.labelTooltipText;
	    this.labelTooltipPlacement = options.labelTooltipPlacement;
	    this.labelTooltipClasses = utils.isArray(options.labelTooltipClasses) ? options.labelTooltipClasses : [];
	    this.placeholder = options.placeholder;
	    this.inline = options.inline;
	    this.disabled = utils.isBoolean(options.disabled) ? options.disabled : false;
	
	    this.formGroupClasses = utils.isArray(options.formGroupClasses) ? options.formGroupClasses : [];
	    this.labelClasses = utils.isArray(options.labelClasses) ? options.labelClasses : [];
	    this.inputClasses = utils.isArray(options.inputClasses) ? options.inputClasses : [];
	    this.inputErrorClass = utils.isNotNull(options.inputErrorClass) ? options.inputErrorClass : "input-error";
	
	    this.displayValue = options.displayValue;
	    this.initialValue = options.initialValue;
	    this.required = utils.isBoolean(options.required) ? options.required : false;
	    this.value = this.initialValue;
	    this.inputType = options.inputType;
	    this.groupName = options.groupName;
	    this.inputOptions = options.inputOptions;
	    this.inputAttributes = utils.isArray(options.inputAttributes) ? options.inputAttributes : [];
	
	    this.inputOptionsValueField = utils.isNotNull(options.inputOptionsValueField) ? options.inputOptionsValueField : "value";
	    this.inputOptionsDisplayField = utils.isNotNull(options.inputOptionsDisplayField) ? options.inputOptionsDisplayField : "displayText";
	
	    this.dateOptions = utils.isNotNull(options.dateOptions) ? options.dateOptions : {};
	
	    this.inputHTML = options.inputHTML;
	
	    this.afterRender = options.afterRender;
	    this.validator = options.validator;
	    this.onInputChange = options.onInputChange;
	
	    this.create();
	  }
	
	  _createClass(FormGroupTemplate, [{
	    key: "getInputValue",
	    value: function getInputValue() {
	      return $("#" + this.inputId)[0].value;
	    }
	  }, {
	    key: "getNewVal",
	    value: function getNewVal() {
	      if (utils.isNotNull(this.inputEl) && this.inputEl.length) {
	        this._value = this.inputEl.is(":checked");
	      }
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      if (this.initialized !== true) {
	        var classNames = ["form-group"].concat(this.formGroupClasses);
	
	        if (this.inline === true && utils.isNotNull(this.label)) {
	          classNames.splice(1, 0, "form-inline");
	        }
	
	        this.formGroupEl = $(ElementCreator.createStringElement({
	          classNames: classNames
	        }));
	
	        this.renderLabel();
	        this.renderInput();
	
	        this.addToDOM();
	
	        this.setUpEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	      if (utils.isNotNull(that.inputEl) && that.inputEl.length) {
	        that.inputEl.on("change", function (e) {
	          var thisEl = $(this);
	          var tmpVal = thisEl.val();
	
	          if (that.inputType === "checkbox" || that.inputType === "radio") {
	            tmpVal = thisEl.is(":checked");
	          } else if (that.inputType === "number") {
	            tmpVal = utils.stringToInt(tmpVal);
	            utils.devLog(tmpVal);
	          }
	
	          that._value = tmpVal;
	          that.validate();
	
	          if (utils.isFunction(that.onInputChange)) {
	            that.onInputChange(that.value, e);
	          }
	        });
	
	        that.inputEl.on("blur", function (e) {
	          var thisEl = $(this);
	          var tmpVal = thisEl.val();
	
	          if (that.inputType === "checkbox" || that.inputType === "radio") {
	            tmpVal = thisEl.is(":checked");
	          } else if (that.inputType === "number") {
	            tmpVal = utils.stringToInt(tmpVal);
	            utils.devLog(tmpVal);
	          }
	
	          if (that.value !== tmpVal) {
	            that._value = tmpVal;
	          }
	
	          that.validate();
	        });
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.formGroupEl.empty();
	      this.renderLabel();
	      this.renderInput();
	      this.addToDOM();
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var isValid = true;
	
	      if (this.required && utils.isNullOrEmpty(this.value)) {
	        isValid = false;
	      }
	
	      if (utils.isFunction(this.validator) && isValid) {
	        isValid = this.validator(this.value);
	      }
	
	      if (!isValid && !this.inputEl.hasClass(this.inputErrorClass)) {
	        this.inputEl.addClass(this.inputErrorClass);
	      } else if (isValid && this.inputEl.hasClass(this.inputErrorClass)) {
	        this.inputEl.removeClass(this.inputErrorClass);
	      }
	
	      return isValid;
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel() {
	      if (utils.isNull(this.label)) {
	        this.labelEl = null;
	        return;
	      }
	
	      var classNames = ["form-label"].concat(this.labelClasses);
	
	      if (this.inputType === "checkbox" || this.inputType === "radio") {
	        classNames = this.labelClasses;
	      }
	
	      var tooltipEl = "";
	
	      if (!utils.isNullOrEmpty(this.labelTooltipText)) {
	        var tooltipClasses = ["btn", "btn-icon", "frameless", "question-circle", "form-label-tooltip"].concat(this.labelTooltipClasses);
	
	        tooltipEl = "<button class='" + tooltipClasses.join(" ") + "' type='button'></button>";
	      }
	
	      this.labelEl = ElementCreator.createStringElement({
	        tagName: "label",
	        classNames: classNames,
	        attributes: [{ name: "for", value: this.inputId }],
	        innerHTML: this.label + (this.required ? " <sup>*</sup>" : "") + tooltipEl
	      });
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      if (utils.isNotNull(this.inputHTML)) {
	        this.inputEl = $(this.inputHTML);
	      } else {
	        if (this.inputType === "textarea") {
	          var attributes = [{ name: "placeholder", value: this.placeholder }].concat(this.inputAttributes);
	
	          this.inputEl = $(ElementCreator.createStringElement({
	            tagName: "textarea",
	            classNames: ["form-control"].concat(this.inputClasses),
	            attributes: attributes
	          }));
	        } else if (this.inputType === "select") {
	          var optionsEl = "";
	
	          for (var i = 0; i < this.inputOptions.length; i++) {
	            if (utils.isNull(this.initialValue) && i === 0) {
	              //If there is no initial value then use the first option as current value
	              this.value = this.inputOptions[i].value;
	            }
	
	            optionsEl += ElementCreator.createStringElement({
	              tagName: "option",
	              attributes: [{ name: "value", value: this.inputOptions[i][this.inputOptionsValueField] }],
	              innerHTML: this.inputOptions[i][this.inputOptionsDisplayField]
	            });
	          }
	
	          this.inputEl = $(ElementCreator.createStringElement({
	            tagName: "select",
	            classNames: ["form-control"].concat(this.inputClasses),
	            attributes: this.inputAttributes,
	            innerHTML: optionsEl
	          }));
	
	          if (utils.isNotNull(this.initialValue)) {
	            this.inputEl.val(this.initialValue);
	          }
	        } else if (this.inputType === "date") {
	          var classNames = ["form-control"].concat(this.inputClasses);
	          var attributes = [{ name: "type", value: "text" }, { name: "placeholder", value: this.placeholder }].concat(this.inputAttributes);
	
	          if (this.disabled) {
	            attributes.push({ name: "disabled", value: true });
	          }
	
	          this.inputEl = $(ElementCreator.createStringElement({
	            tagName: "input",
	            classNames: classNames,
	            attributes: attributes
	          }));
	
	          if (utils.isNotNull(this.initialValue)) {
	            this.inputEl.val(this.initialValue);
	          }
	
	          this.inputEl.datepicker(this.dateOptions);
	        } else if (utils.isNull(this.inputType) && (utils.isNotNull(this.displayValue) || utils.isNotNull(this.initialValue))) {
	          var displayValue = utils.isNotNull(this.displayValue) ? this.displayValue : this.initialValue;
	
	          this.inputEl = $(ElementCreator.createStringElement({
	            classNames: ["value-display"],
	            attributes: this.inputAttributes,
	            innerHTML: displayValue
	          }));
	        } else {
	          var classNames = ["form-control"].concat(this.inputClasses);
	          var attributes = [{ name: "type", value: this.inputType }, { name: "placeholder", value: this.placeholder }].concat(this.inputAttributes);
	
	          if (this.disabled) {
	            attributes.push({ name: "disabled", value: true });
	          }
	
	          if (this.inputType === "radio") {
	            classNames = this.inputClasses;
	
	            if (!utils.isNullOrEmpty(this.groupName)) {
	              attributes.push({ name: "name", value: this.groupName });
	            }
	          }
	
	          if (this.inputType === "checkbox") {
	            classNames = this.inputClasses;
	          }
	
	          this.inputEl = $(ElementCreator.createStringElement({
	            tagName: "input",
	            classNames: classNames,
	            attributes: attributes
	          }));
	        }
	      }
	
	      if (utils.isNotNull(this.inputEl) && utils.isNotNull(this.inputType)) {
	        this.inputEl.attr("id", this.inputId);
	
	        if (utils.isNotNull(this.initialValue)) {
	          if ((this.inputType === "checkbox" || this.inputType === "radio") && utils.isBoolean(this.initialValue)) {
	            this.inputEl.prop("checked", this.initialValue);
	          } else {
	            this.inputEl.val(this.initialValue);
	          }
	        }
	      }
	    }
	  }, {
	    key: "addToDOM",
	    value: function addToDOM() {
	      if (this.inputType === "checkbox" || this.inputType === "radio") {
	        this.formGroupEl.append(this.inputEl);
	        this.formGroupEl.append(this.labelEl);
	      } else if (this.inputType === "select") {
	        this.formGroupEl.append(this.labelEl);
	        var inputWrapper = $("<div class='input-wrapper'></div>").append($("<div class='select-wrapper'></div>").append(this.inputEl));
	        this.formGroupEl.append(inputWrapper);
	      } else if (utils.isNull(this.inputType)) {
	        this.formGroupEl.append(this.labelEl).append(this.inputEl);
	      } else {
	        this.formGroupEl.append(this.labelEl);
	        this.formGroupEl.append($("<div class='input-wrapper'></div>").append(this.inputEl));
	      }
	
	      this.appendTo.append(this.formGroupEl);
	
	      if (!utils.isNullOrEmpty(this.labelTooltipText)) {
	        var tooltipEl = this.formGroupEl.find(".form-label-tooltip");
	
	        Tooltip.create({
	          selector: tooltipEl,
	          title: this.labelTooltipTitle,
	          content: this.labelTooltipText,
	          placement: this.labelTooltipPlacement
	        });
	      }
	
	      if (utils.isFunction(this.afterRender)) {
	        this.afterRender(this);
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (utils.isNotNull(this.formGroupEl) && this.formGroupEl.length) {
	        this.formGroupEl.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (utils.isNotNull(this.formGroupEl) && this.formGroupEl.length) {
	        this.formGroupEl.hide();
	      }
	    }
	  }, {
	    key: "value",
	    set: function set(val) {
	      this._value = val;
	
	      if (utils.isNotNull(this.inputEl) && this.inputEl.length) {
	        if (this.inputType === "checkbox") {
	          this.inputEl.prop("checked", this.value);
	        } else {
	          this.inputEl.val(this.value);
	        }
	      }
	    },
	    get: function get() {
	      return this._value;
	    }
	  }]);
	
	  return FormGroupTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 07/04/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	
	module.exports = function () {
	  function RenewSubscriptionModalTemplate(options) {
	    _classCallCheck(this, RenewSubscriptionModalTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
	    this.backdropIdSuffix = "-modal-backdrop";
	    this.title = options.title;
	    this.text = options.text;
	    this.disposable = options.disposable;
	
	    this.purchaseOrderRequired = utils.isBoolean(options.purchaseOrderRequired) ? options.purchaseOrderRequired : false;
	    this.placeholder = options.placeholder;
	
	    this.submitText = options.submitText;
	    this.submitWidth = options.submitWidth;
	    this.cancelText = options.cancelText;
	    this.cancelPosition = options.cancelPosition;
	
	    this.onSubmit = options.onSubmit;
	    this.onCancel = options.onCancel;
	
	    this.dialogEl = null;
	    this.purchaseOrderInputEl = null;
	
	    this.create();
	  }
	
	  _createClass(RenewSubscriptionModalTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.rerender();
	
	        this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade in'></div>";
	
	        this.dialogEl.appendTo("body");
	
	        this.addDisposeListener();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var that = this;
	
	      this.close(function () {
	        if (utils.isNotNull(that.dialogEl) && that.dialogEl.length) {
	          that.dialogEl.remove();
	        }
	
	        that._initialized = false;
	      });
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.open();
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists) {
	        $body.append(this.backdrop);
	      }
	
	      this.dialogEl.show();
	      // Reading a css property forces layout to be computed
	      this.dialogEl.css("width");
	      this.dialogEl.addClass("in");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.close();
	    }
	  }, {
	    key: "close",
	    value: function close(callback) {
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      $("#" + this.backdropId).remove();
	
	      this.dialogEl.removeClass("in");
	
	      var that = this;
	      setTimeout(function () {
	        that.dialogEl.hide();
	
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }, 150);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.close();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      this.renderDialog();
	      this.renderTitle();
	      this.renderBody();
	      this.renderButtons();
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	    }
	  }, {
	    key: "renderTitle",
	    value: function renderTitle() {
	      this.dialogEl.find(".modal-content").append("<h3 class='dialog-title'>" + this.title + "</h3>");
	    }
	  }, {
	    key: "renderBody",
	    value: function renderBody() {
	      var modalBodyEl = $("<div class='modal-body'></div>");
	
	      modalBodyEl.append("<p>" + this.text + "</p>");
	
	      if (this.purchaseOrderRequired) {
	        var that = this;
	        this.purchaseOrderInputEl = $("<input class='form-control' type='text'>").on("input", function (e) {
	          var $this = $(this);
	          if (utils.isNullOrEmpty($this.val())) {
	            that.purchaseOrderInputEl.addClass("input-error");
	          } else {
	            that.purchaseOrderInputEl.removeClass("input-error");
	          }
	        });
	
	        if (utils.isNotNull(this.placeholder)) {
	          this.purchaseOrderInputEl.prop("placeholder", this.placeholder);
	        }
	
	        $("<div class='form-group'></div>").append(this.purchaseOrderInputEl).appendTo(modalBodyEl);
	      }
	
	      this.dialogEl.find(".modal-content").append(modalBodyEl);
	    }
	  }, {
	    key: "renderButtons",
	    value: function renderButtons() {
	      var that = this;
	      var buttonWrapper = $("<div class='button-wrapper clearfix'></div>");
	
	      if (utils.isNotNull(that.cancelText) || that.cancelPosition === "top-right") {
	        var cancelBtn;
	
	        if (that.cancelPosition === "top-right") {
	          cancelBtn = $("<button class='btn btn-icon frameless cross-circle dark-grey pull-right' type='button'></button>");
	          that.dialogEl.find(".modal-content").prepend(cancelBtn);
	        } else {
	          cancelBtn = $("<button class='btn btn-main no-icon pull-right' type='button'>" + that.cancelText + "</button>");
	          buttonWrapper.append(cancelBtn);
	        }
	
	        cancelBtn.on("click", function () {
	          that.cancel();
	        });
	      }
	
	      var submitBtn = $("<button class='btn btn-main no-icon pull-right' type='button'>" + that.submitText + "</button>");
	
	      if (utils.isNotNull(that.submitWidth)) {
	        submitBtn.css("width", that.submitWidth);
	      }
	
	      submitBtn.on("click", function () {
	        if (that.purchaseOrderRequired && utils.isNullOrEmpty(that.purchaseOrderNumber)) {
	          that.purchaseOrderInputEl.addClass("input-error");
	          return;
	        }
	
	        if (utils.isFunction(that.onSubmit)) {
	          that.onSubmit(that.purchaseOrderNumber);
	        }
	      });
	
	      buttonWrapper.append(submitBtn);
	      this.dialogEl.find(".modal-content").append(buttonWrapper);
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	
	        that.cancel();
	      });
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }, {
	    key: "purchaseOrderNumber",
	    get: function get() {
	      var purchaseOrderNumber = null;
	
	      if (this.purchaseOrderRequired && utils.isNotNull(this.purchaseOrderInputEl) && this.purchaseOrderInputEl.length) {
	        purchaseOrderNumber = this.purchaseOrderInputEl.val();
	      }
	
	      return purchaseOrderNumber;
	    }
	  }]);
	
	  return RenewSubscriptionModalTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 13/02/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var moment = __webpack_require__(1);
	var ElementCreator = __webpack_require__(131);
	
	var template = {};
	
	(function (Template) {
	  Template.createTableHeader = function (data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : ["fo-cell", "header"];
	    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : ["fo-row"];
	
	    var cellElements = "";
	
	    for (var i = 0; i < data.length; i++) {
	      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
	      var cellElementAttributes = data[i].attributes;
	      var cellClasses = options.cellClasses.slice();
	
	      if (data[i].sortable && options.sortable) {
	        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
	        // If sortable --> attributes go on the span with the cell text
	        cellElementAttributes = [];
	      }
	
	      cellElements += ElementCreator.createStringElement({
	        classNames: cellClasses,
	        attributes: cellElementAttributes,
	        innerHTML: cellElementInnerHTML
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      classNames: options.rowClasses,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function createTableHeaderSortCell(data) {
	    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];
	
	    // Will be overridden if data-sort-property is set in the headers json file
	    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
	    data.sortAttributes.push({
	      name: "data-sort",
	      value: data.key
	    });
	
	    var sortLinkText = ElementCreator.createStringElement({
	      tagName: "span",
	      attributes: data.attributes,
	      innerHTML: LanguageManager.getValueForKey(data.displayText)
	    });
	
	    var sortLinkIcons = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-icons"]
	    });
	
	    var sortLink = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-link"],
	      attributes: data.sortAttributes,
	      innerHTML: sortLinkText + sortLinkIcons
	    });
	
	    return sortLink;
	  }
	
	  Template.createTokenRow = function (headerKeys, data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClass = utils.isNotNull(options.cellClass) ? options.cellClass : "fo-cell";
	    options.rowClass = utils.isNotNull(options.rowClass) ? options.rowClass : "fo-row";
	
	    options.cellClasses = [options.cellClass];
	
	    if (utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty)) {
	      return "";
	    }
	
	    var cellElements = "";
	
	    for (var j = 0; j < headerKeys.length; j++) {
	      switch (headerKeys[j]) {
	        case "deactivate-action":
	          cellElements += makeDeactivateCell(options);
	          break;
	        default:
	          // Getters do not count for hasOwnProperty ...
	          // if(data.hasOwnProperty(headerKeys[j]))
	          if (utils.isNotNull(data[headerKeys[j]])) {
	            cellElements += makeDefaultTableCell(data[headerKeys[j]], options);
	          }
	          break;
	      }
	    }
	
	    var attributes = [];
	
	    if (utils.isNotNull(options.rowIdProperty)) {
	      attributes.push({
	        "name": "data-row-" + options.rowIdProperty,
	        "value": data[options.rowIdProperty]
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: [options.rowClass],
	      attributes: attributes,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function makeDefaultTableCell(cellValue, options) {
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: cellValue
	    });
	  }
	
	  function makeDeactivateCell(options) {
	    var deactivateBtn = ElementCreator.createStringElement({
	      tagName: "button",
	      classNames: ["btn", "btn-icon", "frameless", "trash-o", "dark-grey", "deactivate-subscription-guest-btn"],
	      attributes: [{ name: "type", value: "button" }]
	    });
	
	    options.cellClasses.push("text-right");
	
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: deactivateBtn
	    });
	  }
	})(template);
	
	module.exports = template;

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 13/02/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var moment = __webpack_require__(1);
	var ElementCreator = __webpack_require__(131);
	
	var template = {};
	
	(function (Template) {
	  Template.createTableHeader = function (data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : ["fo-cell", "header"];
	    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : ["fo-row"];
	
	    var cellElements = "";
	
	    for (var i = 0; i < data.length; i++) {
	      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
	      var cellElementAttributes = data[i].attributes;
	      var cellClasses = options.cellClasses.slice();
	
	      if (data[i].sortable && options.sortable) {
	        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
	        // If sortable --> attributes go on the span with the cell text
	        cellElementAttributes = [];
	      }
	
	      cellElements += ElementCreator.createStringElement({
	        classNames: cellClasses,
	        attributes: cellElementAttributes,
	        innerHTML: cellElementInnerHTML
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      classNames: options.rowClasses,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function createTableHeaderSortCell(data) {
	    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];
	
	    // Will be overridden if data-sort-property is set in the headers json file
	    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
	    data.sortAttributes.push({
	      name: "data-sort",
	      value: data.key
	    });
	
	    var sortLinkText = ElementCreator.createStringElement({
	      tagName: "span",
	      attributes: data.attributes,
	      innerHTML: LanguageManager.getValueForKey(data.displayText)
	    });
	
	    var sortLinkIcons = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-icons"]
	    });
	
	    var sortLink = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-link"],
	      attributes: data.sortAttributes,
	      innerHTML: sortLinkText + sortLinkIcons
	    });
	
	    return sortLink;
	  }
	
	  Template.createSubscriptionUserRow = function (headerKeys, data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClass = utils.isNotNull(options.cellClass) ? options.cellClass : "fo-cell";
	    options.rowClass = utils.isNotNull(options.rowClass) ? options.rowClass : "fo-row";
	
	    options.cellClasses = [options.cellClass];
	
	    if (utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty)) {
	      return "";
	    }
	
	    var cellElements = "";
	
	    for (var j = 0; j < headerKeys.length; j++) {
	      switch (headerKeys[j]) {
	        case "deactivate-action":
	          cellElements += makeDeactivateCell(options);
	          break;
	        case "timestamp":
	          if (utils.isNotNull(data[headerKeys[j]])) {
	            cellElements += makeDefaultTableCell(moment(data[headerKeys[j]], ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]).format("DD-MM-YYYY"), options);
	          }
	          break;
	        default:
	          // Getters do not count for hasOwnProperty ...
	          // if(data.hasOwnProperty(headerKeys[j]))
	          if (utils.isNotNull(data[headerKeys[j]])) {
	            cellElements += makeDefaultTableCell(data[headerKeys[j]], options);
	          }
	          break;
	      }
	    }
	
	    var attributes = [];
	
	    if (utils.isNotNull(options.rowIdProperty)) {
	      attributes.push({
	        "name": "data-row-" + options.rowIdProperty,
	        "value": data[options.rowIdProperty]
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: [options.rowClass],
	      attributes: attributes,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function makeDefaultTableCell(cellValue, options) {
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: cellValue
	    });
	  }
	
	  function makeDeactivateCell(options) {
	    var deactivateBtn = ElementCreator.createStringElement({
	      tagName: "button",
	      classNames: ["btn", "btn-icon", "frameless", "trash-o", "dark-grey", "deactivate-subscription-user-btn"],
	      attributes: [{ name: "type", value: "button" }]
	    });
	
	    options.cellClasses.push("text-right");
	
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: deactivateBtn
	    });
	  }
	})(template);
	
	module.exports = template;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 23/01/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var ElementCreator = __webpack_require__(131);
	var TableCreator = __webpack_require__(130);
	var Dialog = __webpack_require__(183);
	var Collapse = __webpack_require__(224);
	var Tooltip = __webpack_require__(134);
	var activationsTableHeader = __webpack_require__(721);
	var TokenTableRowTemplate = __webpack_require__(396);
	
	// Styles
	__webpack_require__(620);
	
	module.exports = function () {
	  function TokenTemplate(options) {
	    _classCallCheck(this, TokenTemplate);
	
	    /*
	     * options.appendTo
	     * options.token
	     * options.type (installations | users)
	     * options.collapsible
	     * options.lazyload (only when collapsible is true and getActivations is a function)
	     *
	     * options.getActivations
	     * options.increaseMax
	     * options.deactivateActivation
	     * options.activationsCounter
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.appendTo = $(options.appendTo);
	    this.collapsible = utils.isBoolean(options.collapsible) ? options.collapsible : true;
	    this.lazyload = utils.isBoolean(options.lazyload) ? options.lazyload && this.collapsible : true;
	
	    this.showOnlyActivationTable = utils.isBoolean(options.showOnlyActivationTable) ? options.showOnlyActivationTable : false;
	
	    this.token = options.token;
	    this.type = this.token.activationType;
	
	    this.getActivations = options.getActivations;
	    this.increaseMax = options.increaseMax;
	    this.deactivateActivation = options.deactivateActivation;
	
	    this.tokenWrapperEl = null;
	    this.collapseContentEl = null;
	    this.activationsTableWrapper = null;
	
	    this.activationsLoaded = !this.lazyload;
	
	    this.activationsCounter = options.activationsCounter;
	
	    this.create();
	  }
	
	  _createClass(TokenTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        var that = this;
	
	        // %NOTE: this is a quick shortcut - maybe better to create a different template for the new v3.0 token?
	        if (this.showOnlyActivationTable) {
	          this.activationsTableWrapper = this.appendTo;
	
	          this.activationsLoaded = true;
	          this.getActivations(that.token.key, function () {
	            that.renderActivationsTable();
	          });
	        } else {
	
	          this.tokenWrapperEl = $("<div class='token-wrapper'></div>");
	          this.appendTo.append(this.tokenWrapperEl);
	          this.renderToken();
	
	          if (this.collapsible) {
	            var collapseOptions = {
	              selector: this.tokenWrapperEl
	            };
	
	            if (this.lazyload && utils.isFunction(this.getActivations)) {
	              collapseOptions.onExpand = function (thisEl, e) {
	                that.loadActivations(thisEl, e);
	              };
	            }
	
	            Collapse.makeCollapsible(collapseOptions);
	          }
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "loadActivations",
	    value: function loadActivations(thisEl, e) {
	      if (!this.activationsLoaded) {
	        var that = this;
	
	        that.activationsLoaded = true;
	
	        that.getActivations(that.token.key, function () {
	          that.renderCollapseContent();
	        });
	      }
	    }
	  }, {
	    key: "reload",
	    value: function reload(token) {
	      this.token = token;
	      this.renderCollapseContent();
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      if (this.showOnlyActivationTable) {
	        this.activationsTableWrapper.empty();
	        this.renderActivationsTable();
	      } else {
	        this.renderCollapseContent();
	      }
	    }
	  }, {
	    key: "renderToken",
	    value: function renderToken() {
	      this.renderTokenTitle();
	      this.renderCollapseWrapper();
	    }
	  }, {
	    key: "renderTokenTitle",
	    value: function renderTokenTitle() {
	      var tmpTokenTitle = this.tokenWrapperEl.find(".token-title");
	
	      if (tmpTokenTitle.length) {
	        tmpTokenTitle.remove();
	      }
	
	      var platformElements = ElementCreator.createStringElement({
	        classNames: ["platforms"],
	        innerHTML: this.token.getHTMLIconsFormPlatforms()
	      });
	
	      this.tokenWrapperEl.append(ElementCreator.createStringElement({
	        classNames: ["token-title"],
	        attributes: [{ name: "data-trigger" }],
	        innerHTML: this.token.code + platformElements
	      }));
	
	      this.tokenWrapperEl.find(".token-title .platforms i.icon").each(function () {
	        var $this = $(this);
	        var dataType = $this.attr("data-type");
	
	        switch (dataType) {
	          case "picture_ios":
	          case "avi_ios":
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.ios.tooltip.text")
	            });
	            break;
	          case "picture_android":
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.android.tooltip.text")
	            });
	            break;
	          case "picture_pc":
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.windows.tooltip.text")
	            });
	            break;
	          case "avi_web":
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.web.tooltip.text")
	            });
	            break;
	          default:
	            break;
	        }
	      });
	    }
	  }, {
	    key: "renderCollapseWrapper",
	    value: function renderCollapseWrapper() {
	      if (utils.isNotNull(this.collapseWrapperEl) && this.collapseWrapperEl.length) {
	        this.collapseWrapperEl.remove();
	      }
	
	      this.collapseWrapperEl = $("<div data-target></div>");
	
	      if (!this.lazyload) {
	        this.renderCollapseContent();
	      }
	
	      this.tokenWrapperEl.append(this.collapseWrapperEl);
	    }
	  }, {
	    key: "renderCollapseContent",
	    value: function renderCollapseContent() {
	      if (utils.isNull(this.collapseWrapperEl) || !this.collapseWrapperEl.length) {
	        return;
	      }
	
	      if (utils.isNotNull(this.collapseContentEl) && this.collapseContentEl.length) {
	        this.collapseContentEl.remove();
	      }
	
	      this.collapseContentEl = $("<div class='token-data'></div>");
	
	      this.renderTokenInfo();
	      this.renderActivationsTableWrapper();
	
	      this.collapseWrapperEl.append(this.collapseContentEl);
	    }
	  }, {
	    key: "renderTokenInfo",
	    value: function renderTokenInfo() {
	      var that = this;
	      var tmpTokenDataEl = this.tokenWrapperEl.find(".token-data");
	
	      if (tmpTokenDataEl.length) {
	        tmpTokenDataEl.remove();
	      }
	
	      var installationsLabelLocaleKey = "subscription_details.tokens.activations.installations_used";
	      var currentCount = this.token.currentActivationsCount;
	      var maxCount = this.token.maxInstallations;
	
	      if (this.type === "users") {
	        installationsLabelLocaleKey = "subscription_details.tokens.activations.users_active";
	        maxCount = this.token.maxUsers;
	      }
	
	      var infoLabel = ElementCreator.createStringElement({
	        classNames: ["info-label"],
	        innerHTML: LanguageManager.getValueForKey(installationsLabelLocaleKey)
	      });
	
	      var infoValue = ElementCreator.createStringElement({
	        classNames: ["info-value"],
	        innerHTML: currentCount + "/" + maxCount
	      });
	
	      var action = $("<button class='btn btn-icon frameless add-circle dark-grey max-install-btn'></button>").on("click", function (e) {
	        if (utils.isFunction(that.increaseMax)) {
	          that.increaseMax(that);
	        }
	      });
	
	      var infoRow = $(ElementCreator.createStringElement({
	        classNames: ["info-row"],
	        innerHTML: infoLabel + infoValue
	      })).append(action);
	
	      this.collapseContentEl.append(infoRow);
	    }
	  }, {
	    key: "renderActivationsTableWrapper",
	    value: function renderActivationsTableWrapper() {
	      if (utils.isNotNull(this.activationsTableWrapper)) {
	        this.activationsTableWrapper.remove();
	      }
	
	      var titleEl = ElementCreator.createStringElement({
	        tagName: "h6",
	        classNames: ["activation-table-label"],
	        innerHTML: LanguageManager.getValueForKey("subscription_details.tokens.activations.title")
	      });
	
	      var tooltipEl = $("<button type='button' class='btn btn-icon question-circle frameless'></button>");
	      Tooltip.create({
	        selector: tooltipEl,
	        trigger: "hover",
	        title: LanguageManager.getValueForKey("subscription_details.tokens.activations.tooltip.title"),
	        content: LanguageManager.getValueForKey("subscription_details.tokens.activations.tooltip.text"),
	        placement: "right"
	      });
	
	      var titleWrapper = $("<div></div>").append(titleEl).append(tooltipEl);
	
	      this.activationsTableWrapper = $("<div class='activations-table-wrapper'></div>").append(titleWrapper);
	
	      this.collapseContentEl.append(this.activationsTableWrapper);
	
	      this.renderActivationsTable();
	    }
	  }, {
	    key: "renderActivationsTable",
	    value: function renderActivationsTable() {
	      var that = this;
	
	      if (this.token.currentActivations !== null && this.token.currentActivations.length > 0) {
	        if (this.activationsCounter) this.activationsCounter.get(0).innerHTML = "" + this.token.currentActivations.length + "/" + this.token.maxInstallations;
	
	        var tcActivations = new TableCreator({
	          headers: activationsTableHeader,
	          data: this.token.currentActivations,
	          appendTo: this.activationsTableWrapper,
	          headerTemplate: TokenTableRowTemplate.createTableHeader,
	          bodyTemplate: TokenTableRowTemplate.createTokenRow,
	          rowIdProperty: "fakeKey",
	          sortable: true,
	          afterRender: function afterRender(element) {
	            var $el = $(element);
	
	            Tooltip.create({
	              selector: $el.find(".activation-installation-tooltip"),
	              content: LanguageManager.getValueForKey("subscription_details.tokens.activations.installation.tooltip.text")
	            });
	
	            $el.find(".deactivate-token-btn").off("click").on("click", function (e) {
	              var fakeActivationKey = $(this).closest(".fo-row").attr("data-row-fakekey");
	
	              var activation = that.token.getActivationForFakeKey(fakeActivationKey);
	
	              if (utils.isFunction(that.deactivateActivation)) {
	                Dialog.showYesNoDialog("subscription_details.tokens.activations.deactivate.dialog.title", "subscription_details.tokens.activations.deactivate.dialog.text", function () {
	                  that.deactivateActivation(activation, that);
	                });
	              }
	            });
	          }
	        });
	
	        tcActivations.create();
	      } else {
	        this.activationsTableWrapper.append("<p class='activation-table-none'>" + LanguageManager.getValueForKey("subscription_details.tokens.activations.empty") + "</p>");
	      }
	    }
	  }]);
	
	  return TokenTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 19/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	var collapse = {};
	
	(function (Collapsible) {
	  Collapsible.makeCollapsible = function (options) {
	    var collapseWrapper = $(options.selector);
	
	    var triggerEl = collapseWrapper.find("[data-trigger]").first();
	    var collapseEl = collapseWrapper.find("[data-target]").first();
	
	    if (!collapseEl.hasClass("collapse")) {
	      collapseEl.addClass("collapse");
	
	      if (options.expanded && !collapseEl.hasClass("in")) {
	        collapseEl.addClass("in");
	      }
	    }
	
	    collapseEl.collapse({
	      toggle: options.expanded || false
	    });
	
	    triggerEl.on("click", function () {
	      $(this).nextAll(".collapse").collapse("toggle");
	    });
	
	    collapseEl.on("show.bs.collapse", function (e) {
	      if ($(this).is(e.target)) // For some reason the bootstrap datepicker triggers these if it's inside a collapsible element :s
	        {
	          triggerEl.addClass("open");
	
	          if (utils.isFunction(options.onExpand)) {
	            options.onExpand($(this), e);
	          }
	        }
	    });
	
	    collapseEl.on("hide.bs.collapse", function (e) {
	      if ($(this).is(e.target)) // For some reason the bootstrap datepicker triggers these if it's inside a collapsible element :s
	        {
	          triggerEl.removeClass("open");
	
	          if (utils.isFunction(options.onCollapse)) {
	            options.onCollapse($(this), e);
	          }
	        }
	    });
	
	    if (utils.isFunction(options.afterExpand)) {
	      collapseEl.on("shown.bs.collapse", options.afterExpand);
	    }
	
	    if (utils.isFunction(options.afterCollapse)) {
	      collapseEl.on("hidden.bs.collapse", options.afterCollapse);
	    }
	  };
	
	  // Collapsible.makeCollapsible = function(options)
	  // {
	  //   $(options.selector).on("click", function(e)
	  //   {
	  //     var thisEl = $(this);
	  //
	  //     var parent = thisEl.attr("data-parent");
	  //     var target = thisEl.attr("data-target");
	  //
	  //     var targetEl = $(target);
	  //
	  //     if(targetEl.hasClass("collapsing"))
	  //     {
	  //       e.preventDefault();
	  //       e.stopPropagation();
	  //       return;
	  //     }
	  //
	  //     if(targetEl.hasClass("in"))
	  //     {
	  //       if(utils.isFunction(options.onCollapse))
	  //       {
	  //         options.onCollapse(true);
	  //       }
	  //
	  //       Collapsible.collapse(targetEl, "height");
	  //     }
	  //     else
	  //     {
	  //       if(utils.isFunction(options.onCollapse))
	  //       {
	  //         options.onCollapse(false);
	  //       }
	  //
	  //       Collapsible.expand(targetEl, "height");
	  //     }
	  //   });
	  // };
	  //
	  // Collapsible.collapse = function(element, dimension)
	  // {
	  //   element["height"](element[dimension]())[0].offsetHeight;
	  //
	  //   element.removeClass("collapse in").addClass("collapsing");
	  //   element.css(dimension, "0px");
	  //
	  //   setTimeout(function()
	  //   {
	  //     element.removeClass("collapsing").addClass("collapse");
	  //   }, 350);
	  // };
	  //
	  // Collapsible.expand = function(element, dimension)
	  // {
	  //   var scrollSize = "scroll" + dimension.charAt(0).toUpperCase() + dimension.slice(1);
	  //
	  //   element.removeClass("collapse").addClass("collapsing")["height"](0);
	  //   element["height"](element[0][scrollSize]);
	  //
	  //   setTimeout(function()
	  //   {
	  //     element.removeClass("collapsing").addClass("collapse in").css("height", "");
	  //   }, 350);
	  // };
	})(collapse);
	
	module.exports = collapse;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 10/01/2017.
	 */
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	var dataFilter = {};
	
	(function (DataFilter) {
	  DataFilter.search = function (data, searchString, type) {
	    return DataFilter.filter(data, null, [searchString], false, type);
	  };
	
	  DataFilter.filter = function (data, property, values, exact, type) {
	    return filterArray(data, property, values, exact, type);
	  };
	
	  DataFilter.sort = function (data, sortType, sortKey, asc) {
	    // temporary array holds objects with position and sort-value
	    var mapped = data.map(function (el, i) {
	      var value = el[sortKey];
	
	      if (utils.isMomentObject(value)) {
	        value = value.toDate();
	      }
	
	      return { index: i, value: value };
	    });
	
	    // sorting the mapped array containing the reduced values
	    switch (sortType) {
	      case "date":
	        mapped.sort(function (a, b) {
	          // return asc ? a.value - b.value : b.value - a.value;
	          var left = asc ? a.value : b.value;
	          var right = asc ? b.value : a.value;
	
	          return moment.utc(left).diff(moment.utc(right));
	        });
	        break;
	      case "number":
	        mapped.sort(function (a, b) {
	          return asc ? +a.value - +b.value : +b.value - +a.value;
	        });
	        break;
	      case "string":
	        mapped.sort(function (a, b) {
	          // Fail safe
	          var valA = utils.isNotNull(a.value) ? a.value : "",
	              valB = utils.isNotNull(b.value) ? b.value : "";
	
	          return !asc ? valA.localeCompare(valB) : valB.localeCompare(valA);
	        });
	        break;
	      default:
	        mapped.sort(function (a, b) {
	          return asc ? a.value - b.value : b.value - a.value;
	        });
	    }
	
	    // container for the resulting order
	    return mapped.map(function (el) {
	      return data[el.index];
	    });
	  };
	
	  function filterArray(array, property, searchValues, exact, type) {
	    return array.filter(function (obj) {
	      var result = findInObject(obj, property, searchValues, exact, type);
	
	      return result.length > 0;
	    });
	  }
	
	  function findInObject(obj, property, searchValues, exact, type) {
	    var result = [];
	
	    if (utils.isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	        var tmpResult1 = findInObject(obj[i], property, searchValues, exact, type);
	        result = result.concat(tmpResult1);
	      }
	    } else if (utils.isObject(obj)) {
	      for (var prop in obj) {
	        if (obj.hasOwnProperty(prop) && (utils.isNull(property) || property === prop)) {
	          if (utils.isObject(obj[prop]) || utils.isArray(obj[prop])) {
	            var tmpResult2 = findInObject(obj[prop], property, searchValues, exact, type);
	            result = result.concat(tmpResult2);
	          } else {
	            if (compareValues(obj[prop], searchValues, exact, type)) {
	              result.push(obj);
	            }
	          }
	        }
	      }
	    } else // If obj is not an object or array
	      {
	        if (compareValues(obj, searchValues, exact, type)) {
	          result.push(obj);
	        }
	      }
	
	    return result;
	  }
	
	  function compareValues(value, searchValues, exact, type) {
	    if (utils.isUndefined(type) || (typeof value === "undefined" ? "undefined" : _typeof(value)) === type) {
	      for (var x = 0; x < searchValues.length; x++) {
	        var searchValue = searchValues[x];
	        var objValue = value + "";
	
	        if (exact === true) {
	          if (objValue === searchValue) {
	            return true;
	          }
	        } else {
	          if (objValue.toUpperCase().includes(searchValue.toUpperCase())) {
	            return true;
	          }
	        }
	      }
	    }
	
	    return false;
	  }
	})(dataFilter);
	
	module.exports = dataFilter;

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 31/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	// style
	__webpack_require__(613);
	
	$.fn.spinner = function (options, extra) {
	  var returnValue = this;
	  var pluginID = "fundels-spinner";
	
	  this.each(function () {
	    var $this = $(this);
	    var spinner = $this.data(pluginID);
	
	    if (!(spinner instanceof Spinner)) {
	      $this.data(pluginID, new Spinner($.extend({
	        element: this
	      }, options)));
	    }
	
	    if (spinner && utils.isString(options)) {
	      if (options === "get") {
	        returnValue = spinner.value;
	      } else if (options === "destroy") {
	        spinner.destroy();
	        $this.removeData(pluginID);
	      } else {
	        var method = spinner.getAction(options);
	
	        if (utils.isNull(method)) {
	          throw new Error("FundelsSpinner: no such method: '" + options + "'");
	        }
	
	        method.call(spinner, extra);
	      }
	    }
	  });
	
	  return returnValue;
	};
	
	var Spinner = function () {
	  function Spinner(options) {
	    _classCallCheck(this, Spinner);
	
	    /*
	     * options.key
	     * options.element
	     * options.appendTo
	     *
	     * options.initialValue (default: 0)
	     * options.minValue      (default: Number.MIN_SAFE_INTEGER)
	     * options.maxValue      (default: Number.MAX_SAFE_INTEGER)
	     * options.step          (default: 1)
	     *
	     * options.allowDecrease (default: true)
	     * options.allowIncrease (default: true)
	     *
	     * events: (trigger)
	     *  spinner:before-change
	     *  spinner:change
	     *  spinner:step-up
	     *  spinner:step-down
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.key = options.key;
	    this.element = utils.isNotNull(options.element) ? $(options.element) : null;
	    this.appendTo = utils.isNotNull(options.appendTo) ? $(options.appendTo) : null;
	
	    this.spinnerElement = null;
	
	    this.initialValue = utils.isNumber(options.initialValue) ? options.initialValue : 0;
	    this.value = this.initialValue;
	    this.minValue = utils.isNumber(options.minValue) ? options.minValue : utils.getMinSafeInt();
	    this.maxValue = utils.isNumber(options.maxValue) ? options.maxValue : utils.getMaxSafeInt();
	    this.step = utils.isNumber(options.step) ? options.step : 1;
	
	    this.allowDecrease = utils.isBoolean(options.allowDecrease) ? options.allowDecrease : true;
	    this.allowIncrease = utils.isBoolean(options.allowIncrease) ? options.allowIncrease : true;
	
	    this.beforeChange = options.beforeChange;
	    this.onStepDown = options.onStepDown;
	    this.onStepUp = options.onStepUp;
	    this.onChange = options.onChange;
	
	    this.create();
	  }
	
	  _createClass(Spinner, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.spinnerElement = $("<div class='input-spinner'></div>");
	
	        this.rerender();
	
	        if (utils.isNotNull(this.element) && this.element.length) {
	          this.element.hide();
	          this.element.after(this.spinnerElement);
	        } else if (utils.isNotNull(this.appendTo) && this.appendTo.length) {
	          this.appendTo.append(this.spinnerElement);
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.spinnerElement) && this.spinnerElement.length) {
	        this.spinnerElement.remove();
	      }
	
	      if (utils.isNotNull(this.element) && this.element.length) {
	        this.element.val(this.value).show();
	      }
	
	      this._initialized = false;
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      this.spinnerElement.empty();
	
	      // DecreaseBtn
	      var decreaseBtn = "<button class='btn btn-icon frameless minus-circle dark-grey spinner-decrease'></button>";
	      // ValueDisplay
	      var valueDisplay = "<div class='spinner-value'>" + this.value + "</div>";
	      // IncreaseBtn
	      var increaseBtn = "<button class='btn btn-icon frameless add-circle dark-grey spinner-increase'></button>";
	
	      this.spinnerElement.append(decreaseBtn + valueDisplay + increaseBtn);
	
	      this.toggleStepBtns();
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	
	      if (utils.isNotNull(that.spinnerElement) && that.spinnerElement.length) {
	        that.spinnerElement.find(".spinner-decrease").off().on("click", function (e) {
	          that.decrease();
	        });
	
	        that.spinnerElement.find(".spinner-increase").off().on("click", function (e) {
	          that.increase();
	        });
	      }
	    }
	  }, {
	    key: "decrease",
	    value: function decrease() {
	      if (!this.allowDecrease || this.value <= this.minValue) {
	        this.toggleStepBtns();
	        return;
	      }
	
	      this.triggerBeforeChange();
	
	      this.value = this.value - this.step;
	
	      if (this.value < this.minValue) {
	        this.value = this.minValue;
	      }
	
	      this.toggleStepBtns();
	      this.spinnerElement.find(".spinner-value").text(this.value);
	
	      this.triggerStepDown();
	      this.triggerOnChange();
	    }
	  }, {
	    key: "increase",
	    value: function increase() {
	      if (!this.allowIncrease || this.value >= this.maxValue) {
	        this.toggleStepBtns();
	        return;
	      }
	
	      this.triggerBeforeChange();
	
	      this.value = this.value + this.step;
	
	      if (this.value > this.maxValue) {
	        this.value = this.maxValue;
	      }
	
	      this.toggleStepBtns();
	      this.spinnerElement.find(".spinner-value").text(this.value);
	
	      this.triggerStepUp();
	      this.triggerOnChange();
	    }
	  }, {
	    key: "toggleStepBtns",
	    value: function toggleStepBtns() {
	      if (this.allowDecrease) {
	        if (this.value <= this.minValue) {
	          this.disableStepBtn("decrease");
	        } else {
	          this.enableStepBtn("decrease");
	        }
	      } else {
	        this.disableStepBtn("decrease");
	      }
	
	      if (this.allowIncrease) {
	        if (this.value >= this.maxValue) {
	          this.disableStepBtn("increase");
	        } else {
	          this.enableStepBtn("increase");
	        }
	      } else {
	        this.disableStepBtn("increase");
	      }
	    }
	  }, {
	    key: "enableStepBtn",
	    value: function enableStepBtn(type) {
	      this.spinnerElement.find(".spinner-" + type).removeClass("disabled");
	    }
	  }, {
	    key: "disableStepBtn",
	    value: function disableStepBtn(type) {
	      var stepBtn = this.spinnerElement.find(".spinner-" + type);
	
	      if (!stepBtn.hasClass("disabled")) {
	        stepBtn.addClass("disabled");
	      }
	    }
	  }, {
	    key: "triggerBeforeChange",
	    value: function triggerBeforeChange() {
	      if (utils.isNotNull(this.element) && this.element.length) {
	        this.element.trigger("spinner:before-change", [this]);
	      } else {
	        this.spinnerElement.trigger("spinner:before-change", [this]);
	      }
	
	      if (utils.isFunction(this.beforeChange)) {
	        this.beforeChange();
	      }
	    }
	  }, {
	    key: "triggerStepDown",
	    value: function triggerStepDown() {
	      if (utils.isNotNull(this.element) && this.element.length) {
	        this.element.trigger("spinner:step-down", [this]);
	      } else {
	        this.spinnerElement.trigger("spinner:step-down", [this]);
	      }
	
	      if (utils.isFunction(this.onStepDown)) {
	        this.onStepDown();
	      }
	    }
	  }, {
	    key: "triggerStepUp",
	    value: function triggerStepUp() {
	      if (utils.isNotNull(this.element) && this.element.length) {
	        this.element.trigger("spinner:step-up", [this]);
	      } else {
	        this.spinnerElement.trigger("spinner:step-up", [this]);
	      }
	
	      if (utils.isFunction(this.onStepUp)) {
	        this.onStepUp();
	      }
	    }
	  }, {
	    key: "triggerOnChange",
	    value: function triggerOnChange() {
	      if (utils.isNotNull(this.element) && this.element.length) {
	        this.element.trigger("spinner:change", [this]);
	      } else {
	        this.spinnerElement.trigger("spinner:change", [this]);
	      }
	
	      if (utils.isFunction(this.onChange)) {
	        this.onChange();
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(val) {
	      // Does not trigger any events
	      val = val < this.minValue ? this.minValue : val;
	      val = val > this.maxValue ? this.maxValue : val;
	
	      this.value = val;
	      if (utils.isNotNull(this.spinnerElement) && this.spinnerElement.length) {
	        this.spinnerElement.find(".spinner-value").text(this.value);
	      }
	    }
	  }, {
	    key: "disable",
	    value: function disable() {
	      this.allowIncrease = false;
	      this.allowDecrease = false;
	
	      this.toggleStepBtns();
	    }
	  }, {
	    key: "enable",
	    value: function enable() {
	      this.allowDecrease = true;
	      this.allowIncrease = true;
	
	      this.toggleStepBtns();
	    }
	  }, {
	    key: "getAction",
	    value: function getAction(action) {
	      switch (action) {
	        case "set":
	          return this.setValue;
	        case "disable":
	          return this.disable;
	        default:
	          return null;
	      }
	    }
	  }]);
	
	  return Spinner;
	}();
	
	module.exports = Spinner;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var config = {
	  serviceBaseURL: "/services/",
	  serviceVersion: "1.0",
	  stripe: {}
	};
	
	if (false) {
	  config.stripe.callbackUrl = "http://localhost:8080/store/order-confirmation";
	  config.stripe.publicApiKey = "pk_test_Wp7QZcQviYewD6F8ILs6rOWT";
	} else {
	  config.stripe.callbackUrl = "https://my.fundels.com/store/order-confirmation";
	  config.stripe.publicApiKey = "pk_live_zmECrIKNg2z0pfRs3wk7edjx";
	}
	
	module.exports = config;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/04/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function Customer(options) {
	    _classCallCheck(this, Customer);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.identification = options.identification;
	
	    this.type = options.type;
	    this.description = options.description;
	    this.country = options.country;
	  }
	
	  _createClass(Customer, [{
	    key: "readableCountry",
	    get: function get() {
	      switch (this.country) {
	        case "BE":
	          return "globals.countries.belgium";
	        case "NL":
	          return "globals.countries.netherlands";
	        default:
	          return this.country;
	      }
	    }
	  }]);
	
	  return Customer;
	}();

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var utils = __webpack_require__(3);
	var Person = __webpack_require__(373);
	var Organisation = __webpack_require__(372);
	
	module.exports = function () {
	  function Contact(options) {
	    _classCallCheck(this, Contact);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.type = options.type;
	    this.person = options.person;
	    this.organisation = options.organisation;
	  }
	
	  _createClass(Contact, [{
	    key: "person",
	    set: function set(person) {
	      this._person = new Person(person);
	    },
	    get: function get() {
	      return this._person;
	    }
	  }, {
	    key: "organisation",
	    set: function set(organisation) {
	      this._organisation = new Organisation(organisation);
	    },
	    get: function get() {
	      return this._organisation;
	    }
	  }]);
	
	  return Contact;
	}();

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function Ticket(options) {
	    _classCallCheck(this, Ticket);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.type = options.type;
	    this.code = options.code;
	    this.email = options.email;
	    // this.orderId = options["order-id"];
	    this.subscriptionKey = options["subscription-key"];
	    this.enabled = options.enabled;
	    this.revoked = options.revoked;
	    this.created = options.created;
	    this.expires = options.expires;
	    this.used = options.used;
	    this.data1 = options.data1;
	  }
	
	  _createClass(Ticket, [{
	    key: "expires",
	    set: function set(date) {
	      this._expires = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._expires) ? this._expires.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return Ticket;
	}();

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 24/01/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var Order = __webpack_require__(198);
	var Ticket = __webpack_require__(230);
	var Error = __webpack_require__(167);
	
	var orderServices = {};
	
	(function (OrderServices) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  OrderServices.getOrdersForProfile = function (profileKey, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("list_orders_for_profile"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "profile-key": profileKey
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var orders = [];
	
	        if (data.result.result.hasOwnProperty("orders")) {
	          for (var i = 0; i < data.result.result.orders.length; i++) {
	            orders.push(new Order(data.result.result.orders[i]));
	          }
	        }
	
	        successCb(orders);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  OrderServices.getOrderDetails = function (orderNumber, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_order_details"),
	      cache: false,
	      dataType: "json",
	      data: {
	        number: orderNumber
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Order(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  OrderServices.cancelOrder = function (orderNumber, successCb, failCb) {
	    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
	      url: utils.getServiceUrl("cancel_order"),
	      cache: false,
	      dataType: "json",
	      data: {
	        number: orderNumber
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Order(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  OrderServices.listOrderTickets = function (orderNumber, ticketType, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_order_tickets"),
	      cache: false,
	      dataType: "json",
	      data: {
	        "order-number": orderNumber,
	        "ticket-type": ticketType
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        var tickets = [];
	
	        if (data.result.result.hasOwnProperty("ticket-list")) {
	          for (var i = 0; i < data.result.result["ticket-list"].length; i++) {
	            tickets.push(new Ticket(data.result.result["ticket-list"][i]));
	          }
	        }
	
	        successCb(tickets);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(orderServices);
	
	module.exports = orderServices;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 11/04/2017.
	 */
	var utils = __webpack_require__(3);
	
	__webpack_require__(616);
	
	module.exports = function () {
	  function Paginator(options) {
	    _classCallCheck(this, Paginator);
	
	    /*
	     * appendTo
	     *
	     * items
	     * itemsPerPage
	     * edges
	     *
	     * currentPage
	     *
	     * prevText
	     * nextText
	     *
	     * onPageSwitch
	     */
	
	    if (utils.isNull(options) && utils.isObject(options)) {
	      throw "options must be defined";
	    }
	
	    this.appendTo = options.appendTo;
	
	    this.items = options.items;
	    this.itemsPerPage = options.itemsPerPage;
	    this.edges = utils.isNumber(options.edges) ? options.edges : 2;
	    this.pagesShown = utils.isNumber(options.pagesShown) ? options.pagesShown : 5;
	
	    this.currentPage = utils.isNumber(options.currentPage) ? options.currentPage : 1;
	
	    this.prevText = options.prevText;
	    this.nextText = options.nextText;
	
	    this.minPageCount = utils.isNumber(options.minPageCount) ? options.minPageCount : 2;
	
	    this.onPageSwitch = options.onPageSwitch;
	
	    this.paginatorEl = null;
	
	    this.create();
	  }
	
	  _createClass(Paginator, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.paginatorEl = $("<div class='paginator'></div>");
	
	        this.rerender();
	
	        this.paginatorEl.appendTo(this.appendTo);
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      if (utils.isNotNull(this.paginatorEl) && this.paginatorEl.length) {
	        if (this.pageCount < this.minPageCount) {
	          this.hide();
	        } else {
	          this.show();
	        }
	
	        var that = this;
	        var addElipsis = false;
	
	        this.paginatorEl.empty();
	
	        if (this.currentPage < 1) {
	          this.currentPage = 1;
	        } else if (this.currentPage > this.pageCount) {
	          this.currentPage = this.pageCount;
	        }
	
	        var prevBtn = $("<button class='btn btn-link prev-page-btn' type='button'>" + this.prevText + "</button>");
	        prevBtn.on("click", function (e) {
	          that.prevPage();
	        });
	        this.paginatorEl.append(prevBtn);
	
	        if (this.currentPage === 1) {
	          prevBtn.addClass("disabled");
	        }
	
	        for (var i = 0; i < this.pageCount; i++) {
	          if (i < this.edges || i > this.pageCount - 1 - this.edges || this.currentPage - 1 - Math.floor(this.pagesShown / 2) < i && i < this.currentPage - 1 + Math.floor(this.pagesShown / 2)) {
	            var switchPageBtn = $("<button class='btn btn-link switch-page-btn' type='button'>" + (i + 1) + "</button>").data("page-index", i + 1);
	
	            if (i + 1 === this.currentPage) {
	              switchPageBtn.addClass("active");
	            }
	
	            this.paginatorEl.append(switchPageBtn);
	            addElipsis = true;
	          } else if (addElipsis) {
	            addElipsis = false;
	            this.paginatorEl.append("<span class='switch-page-filler'>...</span>");
	          }
	        }
	
	        this.paginatorEl.find(".switch-page-btn").on("click", function () {
	          var pageIndex = $(this).data("page-index");
	          that.goToPage(pageIndex);
	        });
	
	        var nextBtn = $("<button class='btn btn-link next-page-btn' type='button'>" + this.nextText + "</button>");
	        nextBtn.on("click", function (e) {
	          that.nextPage();
	        });
	        this.paginatorEl.append(nextBtn);
	
	        if (this.currentPage === this.pageCount) {
	          nextBtn.addClass("disabled");
	        }
	      }
	    }
	  }, {
	    key: "updateItems",
	    value: function updateItems(items) {
	      this.items = items;
	      this.rerender();
	    }
	  }, {
	    key: "prevPage",
	    value: function prevPage() {
	      if (this.currentPage > 1) {
	        this.goToPage(this.currentPage - 1);
	      }
	    }
	  }, {
	    key: "nextPage",
	    value: function nextPage() {
	      if (this.currentPage < this.pageCount) {
	        this.goToPage(this.currentPage + 1);
	      }
	    }
	  }, {
	    key: "goToPage",
	    value: function goToPage(index, force) {
	      if (1 <= index && index <= this.pageCount && (index !== this.currentPage || force === true)) {
	        this.currentPage = index;
	
	        this.rerender();
	
	        if (utils.isFunction(this.onPageSwitch)) {
	          this.onPageSwitch(this.currentPage);
	        }
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (utils.isNotNull(this.paginatorEl) && this.paginatorEl.length) {
	        this.paginatorEl.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (utils.isNotNull(this.paginatorEl) && this.paginatorEl.length) {
	        this.paginatorEl.hide();
	      }
	    }
	  }, {
	    key: "pageCount",
	    get: function get() {
	      return Math.ceil(this.items / this.itemsPerPage);
	    }
	  }]);
	
	  return Paginator;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function Article(options) {
	    _classCallCheck(this, Article);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.catalogKey = options["catalog-key"];
	
	    this.priceVat = options["price-with-vat"];
	    this.priceNoVat = options["price-without-vat"];
	    this.vat = options.vat;
	
	    this.alreadyOwned = options["already-owned"];
	
	    this.infoKey = options["info-key"];
	
	    this.type = options.article.type;
	    this.title = options.article.title;
	    this.author = options.article.author;
	    this.description = options.article.description;
	    this.publisher = options.article.publisher;
	    this.image = options.article.image;
	    this.download = options.article.download;
	    this.age = options.article.age;
	
	    /*
	    if(utils.isNotNull(options.article.meta))
	    {
	      this.themes = utils.isString(options.article.meta.themes) ? options.article.meta.themes.split(",") : options.article.meta.themes;
	      this.games = utils.isString(options.article.meta.games) ? options.article.meta.games.split(",") : options.article.meta.games;
	    }
	    */
	
	    this.purchasable = options.article.purchasable;
	    this.purchaseOnce = options.article["purchase-once"];
	    this.physicalDelivery = options.article["physical-delivery"];
	    this.digitalDelivery = options.article["digital-delivery"];
	
	    this.remark = options.article.remark;
	  }
	
	  _createClass(Article, [{
	    key: "vatPercentage",
	    get: function get() {
	      return this.vat * 100;
	    }
	  }, {
	    key: "readableType",
	    get: function get() {
	      switch (this.type) {
	        case "book":
	          return "store.catalog.article_details.physical_book";
	        case "digital_product":
	          return "store.catalog.article_details.digital_product";
	        default:
	          return null;
	      }
	    }
	  }]);
	
	  return Article;
	}();

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	var Article = __webpack_require__(277);
	
	module.exports = function () {
	  function Catalog(options) {
	    _classCallCheck(this, Catalog);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.currency = options.valuta;
	    this.type = options.type;
	    this.locale = options.locale;
	
	    this.extraInfoKey = options["extra-info-key"];
	
	    this.articles = options["catalog-articles"];
	  }
	
	  _createClass(Catalog, [{
	    key: "getArticleForKey",
	    value: function getArticleForKey(key) {
	      for (var i = 0; i < this.articles.length; i++) {
	        if (this.articles[i].key === key) {
	          return this.articles[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "articles",
	    set: function set(articles) {
	      this._articles = [];
	
	      if (utils.isArray(articles)) {
	        for (var i = 0; i < articles.length; i++) {
	          this._articles.push(new Article(articles[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._articles;
	    }
	  }, {
	    key: "country",
	    get: function get() {
	      return utils.getValueFromSplit(this.locale, 1, "_");
	    }
	  }, {
	    key: "language",
	    get: function get() {
	      return utils.getValueFromSplit(this.locale, 0, "_");
	    }
	  }]);
	
	  return Catalog;
	}();

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 06/01/2017.
	 */
	var LanguageManager = __webpack_require__(5);
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var Order = __webpack_require__(198);
	var Token = __webpack_require__(384);
	var Contact = __webpack_require__(229);
	var Customer = __webpack_require__(228);
	
	module.exports = function () {
	  function Subscription(options) {
	    _classCallCheck(this, Subscription);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.number = options.number;
	
	    this.type = options.type;
	    this.city = options.city;
	    this.organisation = options.organisation;
	    this.status = options.status;
	    this.paymentStatus = options["payment-status"];
	
	    this.extendable = options["can-be-extended"];
	    this.prolong = options.prolong;
	
	    this.groupPurchaseKey = options["group-purchase-key"];
	
	    this.purchaseOrderRequired = options["bestelbon-required"];
	    this.vatNumber = options["vat"];
	    this.companyNumber = options["company-number"];
	
	    this.validStart = options["valid-from"];
	    this.validEnd = options["valid-until"];
	
	    this.grace = utils.isDefined(options.grace) ? options.grace : 0;
	    this.correction = utils.isDefined(options.correction) ? options.correction : 0;
	
	    this.tokens = utils.isArray(options.tokens) ? options.tokens : [];
	    this.contacts = utils.isArray(options.contacts) ? options.contacts : [];
	    this.linkedProfiles = utils.isArray(options["linked-profiles"]) ? options["linked-profiles"] : [];
	    this.orders = utils.isArray(options.orders) ? options.orders : [];
	
	    if (utils.isDefined(options.customer)) {
	      this.customer = options.customer;
	    }
	  }
	
	  _createClass(Subscription, [{
	    key: "isValidWithGraceAndCorrection",
	    value: function isValidWithGraceAndCorrection() {
	      var validUntilWithGraceAndCorrection = moment(this._validEnd).add(this.grace + this.correction, "days");
	
	      return !validUntilWithGraceAndCorrection.isBefore(moment());
	    }
	  }, {
	    key: "addContact",
	    value: function addContact(contact) {
	      this._contacts.push(new Contact(contact));
	    }
	  }, {
	    key: "setContactForType",
	    value: function setContactForType(type, contact) {
	      this.removeContactForType(type);
	      this.addContact(contact);
	    }
	  }, {
	    key: "removeContactForType",
	    value: function removeContactForType(type) {
	      for (var i = 0; i < this.contacts.length; i++) {
	        if (this.contacts[i].type === type) {
	          this.contacts.splice(i, 1);
	        }
	      }
	    }
	  }, {
	    key: "getContactForType",
	    value: function getContactForType(type) {
	      for (var i = 0; i < this.contacts.length; i++) {
	        if (this.contacts[i].type === type) {
	          return this.contacts[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getTokenForKey",
	    value: function getTokenForKey(tokenKey) {
	      for (var i = 0; i < this.tokens.length; i++) {
	        if (tokenKey === this.tokens[i].key) {
	          return this.tokens[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "isGroupOrderReadable",
	    value: function isGroupOrderReadable() {
	      return this.isGroupPurchase ? "globals.options.yes" : "globals.options.no";
	    }
	  }, {
	    key: "customer",
	    set: function set(customer) {
	      this._customer = new Customer(customer);
	    },
	    get: function get() {
	      return this._customer;
	    }
	  }, {
	    key: "type",
	    get: function get() {
	      switch (this._type) {
	        case "avi":
	        case "bibnet_avi":
	          return "subscription_details.types.avi";
	        case "picture":
	        case "bibnet_picturebooks":
	          return "subscription_details.types.picture";
	        default:
	          return null;
	      }
	    },
	    set: function set(type) {
	      this._type = type;
	    }
	  }, {
	    key: "shortType",
	    get: function get() {
	      switch (this._type) {
	        case "avi":
	          return "subscription_details.types.avi.short";
	        case "bibnet_avi":
	          return "subscription_details.types.avi_bib.short";
	        case "picture":
	          return "subscription_details.types.picture.short";
	        case "bibnet_picturebooks":
	          return "subscription_details.types.picture_bib.short";
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: "validStart",
	    set: function set(date) {
	      this._validStart = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validStart) ? this._validStart.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "validEnd",
	    set: function set(date) {
	      this._validEnd = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "validEndGrace",
	    get: function get() {
	      var grace = "";
	
	      if (this.grace > 0) {
	        grace = " +" + (this.correction + this.grace) + " " + LanguageManager.getValueForKey("products.grace.days");
	      }
	
	      return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") + grace : null;
	    }
	  }, {
	    key: "isGroupPurchase",
	    get: function get() {
	      return utils.isNotNull(this.groupPurchaseKey);
	    }
	  }, {
	    key: "tokens",
	    set: function set(tokens) {
	      this._tokens = [];
	
	      if (utils.isArray(tokens)) {
	        for (var i = 0; i < tokens.length; i++) {
	          this._tokens.push(new Token(tokens[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._tokens;
	    }
	  }, {
	    key: "contacts",
	    set: function set(contacts) {
	      this._contacts = [];
	
	      if (utils.isArray(contacts)) {
	        for (var i = 0; i < contacts.length; i++) {
	          this.addContact(contacts[i]);
	        }
	      }
	    },
	    get: function get() {
	      return this._contacts;
	    }
	  }, {
	    key: "linkedProfiles",
	    set: function set(linkedProfiles) {
	      this._linkedProfiles = [];
	
	      if (utils.isArray(linkedProfiles)) {
	        for (var i = 0; i < linkedProfiles.length; i++) {
	          var tmpLinkedProfile = linkedProfiles[i];
	
	          this._linkedProfiles.push({
	            profileKey: tmpLinkedProfile["profile-key"],
	            incomplete: tmpLinkedProfile.incomplete,
	            email: tmpLinkedProfile.email,
	            firstname: tmpLinkedProfile.meta.firstname,
	            lastname: tmpLinkedProfile.meta.lastname,
	            displayName: tmpLinkedProfile["display-name"],
	            locale: tmpLinkedProfile.locale,
	            subscriptionProfileType: tmpLinkedProfile["subscription-profile-type"]
	          });
	        }
	      }
	    },
	    get: function get() {
	      return this._linkedProfiles;
	    }
	  }, {
	    key: "orders",
	    set: function set(orders) {
	      this._orders = [];
	
	      if (utils.isArray(orders)) {
	        for (var i = 0; i < orders.length; i++) {
	          this._orders.push(new Order(orders[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._orders;
	    }
	  }, {
	    key: "readableStatus",
	    get: function get() {
	      switch (this.status) {
	        case "valid":
	          return "subscription_details.status.valid";
	        case "expired":
	          return "subscription_details.status.expired";
	        case "grace":
	          return "subscription_details.status.grace";
	        case "unknown":
	        default:
	          return "subscription_details.status.unknown";
	      }
	    }
	  }, {
	    key: "readablePaymentStatus",
	    get: function get() {
	      switch (this.paymentStatus) {
	        case "payed":
	        case "complete":
	          return "subscription_details.payment_status.payed";
	        case "awaiting_approval":
	        case "awaiting_invoice":
	          return "subscription_details.payment_status.processing";
	        case "awaiting_payment":
	          return "subscription_details.payment_status.processing_payment";
	        case "awaiting_delivery":
	          return "subscription_details.payment_status.processing_delivery";
	        case "cancelled":
	        case "awaiting_cancellation":
	          return "subscription_details.payment_status.cancelled";
	        default:
	          // return this.paymentStatus;
	          return "subscription_details.payment_status.unknown";
	      }
	    }
	  }, {
	    key: "readableIsGroupPurchase",
	    get: function get() {
	      return this.isGroupPurchase ? "globals.options.yes" : "globals.options.no";
	    }
	  }, {
	    key: "readableVatNumber",
	    get: function get() {
	      return utils.isNullOrEmpty(this.vatNumber) ? "-" : this.vatNumber;
	    }
	  }, {
	    key: "readableCompanyNumber",
	    get: function get() {
	      return utils.isNullOrEmpty(this.companyNumber) ? "-" : this.companyNumber;
	    }
	  }, {
	    key: "readablePurchaseOrderRequired",
	    get: function get() {
	      return this.purchaseOrderRequired ? "globals.options.yes" : "globals.options.no";
	    }
	  }]);
	
	  return Subscription;
	}();

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 01/03/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function User(options) {
	    _classCallCheck(this, User);
	
	    options = utils.isNotNull(options) ? options : {};
	    options.meta = utils.isNotNull(options.meta) ? options.meta : {};
	
	    this.userKey = options["user-key"];
	    this.profileKey = options["profile-key"];
	
	    this.displayName = options["display-name"];
	
	    this.firstname = options.meta.firstname;
	    this.lastname = options.meta.lastname;
	    this.email = options.email;
	    this.newsletter = options.meta.newsletter === "1";
	
	    this._locale = options.locale;
	    this.type = options.type;
	
	    this.role = options.role;
	
	    this.enabled = options.enabled;
	    this.validated = options.validated;
	    this.authenticated = options.authenticated;
	  }
	
	  _createClass(User, [{
	    key: "serialize",
	    value: function serialize() {
	      return utils.stringifyJSON({
	        "user-key": this.userKey,
	        "profile-key": this.profileKey,
	        "type": this.type,
	        "email": this.email,
	        "locale": this._locale,
	        "display-name": this.displayName,
	        "role": this.role,
	        "meta": {
	          "firstname": this.firstname,
	          "lastname": this.lastname
	        },
	        "enabled": this.enabled,
	        "authenticated": this.authenticated,
	        "incomplete": this.incomplete,
	        "validated": this.validated
	      });
	    }
	  }, {
	    key: "locale",
	    get: function get() {
	      return utils.isNullOrEmpty(this._locale) ? null : this._locale.split("_")[0];
	    }
	  }, {
	    key: "country",
	    get: function get() {
	      return utils.isNullOrEmpty(this._locale) ? null : this._locale.split("_")[1];
	    }
	  }, {
	    key: "isAdmin",
	    get: function get() {
	      return this.role === "admin";
	    }
	  }]);
	
	  return User;
	}();

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(169);
	var Ticket = __webpack_require__(230);
	var Error = __webpack_require__(167);
	
	var ticketService = {};
	
	(function (TicketService) {
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (data.hasOwnProperty("exception")) {
	        callback(new Error(data.exception));
	      } else {
	        callback(new Error({
	          code: null,
	          message: null
	        }));
	      }
	    }
	  }
	
	  TicketService.validateTicket = function (code, type, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("validate_ticket"),
	      cache: false,
	      dataType: "json",
	      data: {
	        code: code,
	        type: type
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  TicketService.getTicketInfo = function (code, type, successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_ticket_info"),
	      cache: false,
	      dataType: "json",
	      data: {
	        code: code,
	        type: type
	      }
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(new Ticket(data.result.result));
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	
	  TicketService.getValidateTicketSessionData = function (successCb, failCb) {
	    request.get({
	      url: utils.getServiceUrl("get_validate_ticket_session_data"),
	      cache: false,
	      dataType: "json"
	    }, function (data) {
	      if (utils.isFunction(successCb)) {
	        successCb(data.result.result.type, data.result.result.code);
	      }
	    }, function (data) {
	      dataToError(data, failCb);
	    });
	  };
	})(ticketService);
	
	module.exports = ticketService;

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/05/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function DialogTemplate(options) {
	    _classCallCheck(this, DialogTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateElementId("dialog-");
	
	    this.title = options.title;
	    this.dialogContent = options.dialogContent;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	
	    this.confirmText = options.confirmText;
	    this.cancelText = options.cancelText;
	    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	
	    this.create();
	  }
	
	  _createClass(DialogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.dialogEl.appendTo("body");
	
	        this.dialogEl.modal({
	          backdrop: this.disposable ? true : "static",
	          keyboard: this.disposable,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogHeader();
	      this.renderDialogContent();
	      this.renderDialogFooter();
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "renderDialogHeader",
	    value: function renderDialogHeader() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length && utils.isNotNull(this.title)) {
	        var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
	        dialogContentEl.append(dialogHeader);
	      }
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogBodyEl = $("<div class='modal-body'></div>");
	        dialogBodyEl.append(this.dialogContent);
	
	        dialogContentEl.append(dialogBodyEl);
	      }
	    }
	  }, {
	    key: "renderDialogFooter",
	    value: function renderDialogFooter() {
	      var that = this;
	      var dialogContentEl = that.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogFooterEl = $("<div class='modal-footer'></div>");
	
	        if (utils.isNotNull(that.confirmText)) {
	          var confirmBtn = $("<button class='btn btn-primary dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");
	
	          confirmBtn.on("click", function (e) {
	            if (utils.isFunction(that.onConfirm)) {
	              that.onConfirm();
	            }
	          });
	
	          dialogFooterEl.append(confirmBtn);
	        }
	
	        if (utils.isNotNull(that.cancelText) || that.cancelTopRight === true) {
	          var classNames = "btn btn-primary dialog-cancel-btn";
	          var innerHTML = that.cancelText;
	
	          if (that.cancelTopRight) {
	            classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
	            innerHTML = "";
	          }
	
	          var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML + "</button>");
	
	          cancelBtn.on("click", function () {
	            that.cancel();
	          });
	
	          if (that.cancelTopRight) {
	            that.dialogEl.find(".modal-content").prepend(cancelBtn);
	          } else {
	            dialogFooterEl.append(cancelBtn);
	          }
	        }
	
	        dialogContentEl.append(dialogFooterEl);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.dialogEl) && this.dialogEl.length && this._destroying !== true) {
	        this._destroying = true;
	
	        this.hide();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.dialogEl.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.dialogEl.modal("hide");
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {
	      var that = this;
	
	      this.dialogEl.on("hide.bs.modal", function (e) {});
	
	      this.dialogEl.on("hidden.bs.modal", function (e) {
	        if (that._destroying) {
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        }
	      });
	
	      this.dialogEl.on("show.bs.modal", function (e) {});
	
	      this.dialogEl.on("shown.bs.modal", function (e) {});
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }]);
	
	  return DialogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 283:
201,

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 22/03/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var ElementCreator = __webpack_require__(131);
	var Dialog = __webpack_require__(183);
	var InputSpinner = __webpack_require__(226);
	
	__webpack_require__(619);
	
	module.exports = function () {
	  function CartTemplate(options) {
	    _classCallCheck(this, CartTemplate);
	
	    /*
	     * options.appendTo
	     * options.cart (Cart object [models/store/cart.js])
	     *
	     * options.setItemQuantity(key, quantity)
	     */
	
	    if (utils.isNull(options) || utils.isNull(options.sessionData)) {
	      throw "options must be defined with a valid SessionData object";
	    }
	
	    this.appendTo = $(options.appendTo);
	    this.sessionData = options.sessionData;
	    this.cart = this.sessionData.cart;
	
	    this.editable = options.editable;
	
	    this.canBeGroupPurchase = utils.isBoolean(options.canBeGroupPurchase) ? options.canBeGroupPurchase : false;
	
	    this.setItemQuantity = options.setItemQuantity;
	    this.removeItem = options.removeItem;
	    this.setItemGroupPurchase = options.setItemGroupPurchase;
	
	    this.create();
	  }
	
	  _createClass(CartTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.cartWrapperEl = $("<div class='shopping-cart-wrapper'></div>");
	        this.cartPriceSummaryEl = $("<div class='price-summary'></div>");
	        this.appendTo.append(this.cartWrapperEl).append(this.cartPriceSummaryEl);
	
	        this.refresh();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length) {
	        this.cartWrapperEl.show();
	      }
	
	      if (utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length) {
	        this.cartPriceSummaryEl.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length) {
	        this.cartWrapperEl.hide();
	      }
	
	      if (utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length) {
	        this.cartPriceSummaryEl.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length) {
	        this.cartWrapperEl.destroy();
	      }
	
	      if (utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length) {
	        this.cartPriceSummaryEl.destroy();
	      }
	
	      this._initialized = false;
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      this.cartWrapperEl.empty();
	      this.cartPriceSummaryEl.empty();
	
	      this.renderCart();
	      this.renderPriceSummary();
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "reload",
	    value: function reload(sessionData) {
	      this.sessionData = sessionData;
	      this.cart = this.sessionData.cart;
	      this.refresh();
	    }
	  }, {
	    key: "renderPriceSummary",
	    value: function renderPriceSummary() {
	      this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.subtotal") + ":", utils.roundNumber(this.cart.subtotal, 2)));
	
	      if (utils.isNotNull(this.cart.deliveryCosts)) {
	        this.cartPriceSummaryEl.append(this.createPriceRow(this.cart.deliveryCosts.article.title + ":", utils.roundNumber(this.cart.deliveryCosts["price-without-vat"], 2)));
	      }
	
	      if (utils.isArray(this.cart.discounts)) {
	        for (var i = 0; i < this.cart.discounts.length; i++) {
	          this.cartPriceSummaryEl.append(this.createPriceRow(this.cart.discounts[i].article.title + ":", utils.roundNumber(this.cart.discounts[i]["price-without-vat"], 2), ["candy-pink"]));
	        }
	      }
	
	      if (utils.isArray(this.cart.vatList)) {
	        for (var i = 0; i < this.cart.vatList.length; i++) {
	          this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.vat") + " " + this.cart.vatList[i].vat * 100 + "%:", utils.roundNumber(this.cart.vatList[i].value, 2)));
	        }
	      }
	
	      // this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.vat") + ":", utils.roundNumber(this.cart.totalVat, 2)));
	      this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.total") + ":", utils.roundNumber(this.cart.totalPriceVat, 2), ["total-price", "top-space", "sky-blue"]));
	    }
	  }, {
	    key: "createPriceRow",
	    value: function createPriceRow(label, price, extraClasses) {
	      var labelEl = ElementCreator.createStringElement({
	        classNames: ["price-label"],
	        innerHTML: label
	      });
	
	      var priceEl = ElementCreator.createStringElement({
	        classNames: ["price-value"],
	        innerHTML: this.cart.currency + " " + price.toFixed(2)
	      });
	
	      return ElementCreator.createStringElement({
	        classNames: ["price-row"].concat(extraClasses),
	        innerHTML: labelEl + priceEl
	      });
	    }
	  }, {
	    key: "renderCart",
	    value: function renderCart() {
	      this.renderCartHeader();
	
	      this.renderCartItems();
	    }
	  }, {
	    key: "renderCartHeader",
	    value: function renderCartHeader() {
	      var headerRow = $("<div class='header-row'></div>");
	
	      var headerLeft = $("<div class='flex-left'></div>");
	
	      var flexGroup = $("<div class='flex-group flex-5'></div>");
	      flexGroup.append("<div class='header-label product-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.product") + "</div>");
	
	      if (this.canBeGroupPurchase) {
	        flexGroup.append("<div class='header-label group-purchase-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.group_purchase") + "</div>");
	      }
	
	      headerLeft.append(flexGroup);
	
	      headerLeft.append("<div class='header-label price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.price") + "</div>");
	      headerLeft.append("<div class='header-label quantity-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.quantity") + "</div>");
	      headerRow.append(headerLeft);
	
	      var headerRight = $("<div class='flex-right'></div>");
	      // headerRight.append("<div class='header-label price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.price") + "</div>");
	      // headerRight.append("<div class='header-label quantity-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.quantity") + "</div>");
	      headerRight.append("<div class='header-label total-price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.total_price") + "</div>");
	      headerRow.append(headerRight);
	
	      this.cartWrapperEl.append(headerRow);
	    }
	  }, {
	    key: "renderCartItems",
	    value: function renderCartItems() {
	      for (var i = 0; i < this.cart.items.length; i++) {
	        this.cartWrapperEl.append(this.renderCartItem(this.cart.items[i]));
	      }
	
	      for (var i = 0; i < this.cart.freeArticles.length; i++) {
	        this.cartWrapperEl.append(this.renderFreeItem(this.cart.freeArticles[i]));
	      }
	    }
	  }, {
	    key: "renderCartItem",
	    value: function renderCartItem(item) {
	      var cartItemEl = $("<div class='cart-item'></div>").attr("data-cart-item", item.article.key);
	
	      var cartItemLeftEl = $("<div class='flex-left'></div>");
	      var flexGroup = $("<div class='flex-group'></div>");
	      var cartItemRightEl = $("<div class='flex-right'></div>");
	
	      this.createItemImage(item, cartItemLeftEl);
	      this.createItemInfo(item, flexGroup);
	
	      if (this.canBeGroupPurchase) {
	        this.createPurchaseOrderCheck(item, flexGroup);
	      }
	
	      cartItemLeftEl.append(flexGroup);
	
	      this.createItemPrice(item, cartItemLeftEl);
	      this.createItemQuantity(item, cartItemLeftEl);
	      // this.createItemVAT(item, cartItemRightEl);
	      this.createItemTotalPrice(item, cartItemRightEl);
	      this.createItemRemove(item, cartItemRightEl);
	
	      cartItemEl.append(cartItemLeftEl);
	      cartItemEl.append(cartItemRightEl);
	
	      return cartItemEl;
	    }
	  }, {
	    key: "renderFreeItem",
	    value: function renderFreeItem(item) {
	      var cartItemEl = $("<div class='cart-item'></div>").attr("data-cart-item", item.article.key);
	
	      var cartItemLeftEl = $("<div class='flex-left'></div>");
	      var flexGroup = $("<div class='flex-group'></div>");
	      var cartItemRightEl = $("<div class='flex-right'></div>");
	
	      this.createItemImage(item, cartItemLeftEl);
	      this.createItemInfo(item, flexGroup);
	
	      cartItemLeftEl.append(flexGroup);
	
	      // price no vat
	      cartItemLeftEl.append("<div class='item-cell item-price'><div>" + this.cart.currency + " " + utils.roundNumber(item["price-without-vat"], 2).toFixed(2) + "</div></div>");
	
	      // quantity
	      var quantityEl = $("<div class='item-cell item-quantity'></div>");
	      quantityEl.append("<div>" + item.count + "</div>");
	      cartItemLeftEl.append(quantityEl);
	
	      // total price
	      cartItemRightEl.append("<div class='item-cell item-total-price'><div>" + this.cart.currency + " " + utils.roundNumber(item["price-without-vat"] * item.count, 2).toFixed(2) + "</div></div>");
	
	      cartItemEl.append(cartItemLeftEl);
	      cartItemEl.append(cartItemRightEl);
	
	      return cartItemEl;
	    }
	  }, {
	    key: "createItemImage",
	    value: function createItemImage(item, appendTo) {
	      // Moved to createItemInfo so it aligns with the header row
	      // appendTo.append("<div class='item-cell item-image'><img src='" + item.article.image + "'/></div>");
	    }
	  }, {
	    key: "createItemInfo",
	    value: function createItemInfo(item, appendTo) {
	      appendTo.append("<div class='item-cell item-image'><img src='" + item.article.image + "'/></div>");
	
	      if (utils.isNullOrEmpty(item.comment)) appendTo.append("<div class='item-cell item-info'><div>" + item.article.title + "</div></div>");else appendTo.append("<div class='item-cell item-info'><div>" + item.article.title + "<br/><i>" + item.comment + "</i></div></div>");
	    }
	  }, {
	    key: "createPurchaseOrderCheck",
	    value: function createPurchaseOrderCheck(item, appendTo) {
	      var checkboxId = item.article.key + "-group-purchase-check";
	      appendTo.append("<div class='item-cell item-group-purchase'><div><div class='form-group'><input id='" + checkboxId + "' type='checkbox' name='article-group-purchase-check'><label for='" + checkboxId + "'>" + LanguageManager.getValueForKey("store.cart.items.labels.group_purchase") + "</label></div></div></div>");
	    }
	  }, {
	    key: "createItemPrice",
	    value: function createItemPrice(item, appendTo) {
	      appendTo.append("<div class='item-cell item-price'><div>" + this.cart.currency + " " + utils.roundNumber(item.article.priceNoVat, 2).toFixed(2) + "</div></div>");
	    }
	  }, {
	    key: "createItemQuantity",
	    value: function createItemQuantity(item, appendTo) {
	      var quantityEl = $("<div class='item-cell item-quantity'></div>");
	
	      if (this.editable && !item.article.purchaseOnce) {
	        var spinner = new InputSpinner({
	          appendTo: quantityEl,
	          initialValue: item.quantity,
	          minValue: 1,
	          maxValue: item.article.purchaseOnce ? 1 : utils.getMaxSafeInt()
	        });
	      } else {
	        quantityEl.append("<div>" + item.quantity + "</div>");
	      }
	
	      appendTo.append(quantityEl);
	    }
	  }, {
	    key: "createItemVAT",
	    value: function createItemVAT(item, appendTo) {
	      appendTo.append("<div class='item-cell item-vat'><span>" + LanguageManager.getValueForKey("store.cart.vat") + " " + item.article.vatPercentage + "%" + "</span></div>");
	    }
	  }, {
	    key: "createItemTotalPrice",
	    value: function createItemTotalPrice(item, appendTo) {
	      appendTo.append("<div class='item-cell item-total-price'><div>" + this.cart.currency + " " + utils.roundNumber(item.priceNoVat, 2).toFixed(2) + "</div></div>");
	    }
	  }, {
	    key: "createItemRemove",
	    value: function createItemRemove(item, appendTo) {
	      var removeCell = $("<div class='item-cell item-remove'></div>");
	
	      if (this.editable) {
	        removeCell.append("<button class='btn btn-icon frameless trash-o dark-grey' type='button'></button>");
	      }
	
	      appendTo.append(removeCell);
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	
	      this.cartWrapperEl.find(".item-remove .btn.btn-icon.trash-o").off().on("click", function (e) {
	        if (utils.isFunction(that.removeItem)) {
	          that.removeItem($(this).closest(".cart-item").attr("data-cart-item"));
	        }
	      });
	
	      this.cartWrapperEl.find(".item-group-purchase input[name='article-group-purchase-check']").off().on("change", function (e) {
	        if (utils.isFunction(that.setItemGroupPurchase)) {
	          that.setItemGroupPurchase($(this).closest(".cart-item").attr("data-cart-item"), this.checked);
	        }
	      });
	
	      this.cartWrapperEl.find(".item-quantity .input-spinner").off().on("spinner:change", function (e, spinner) {
	        var thisEl = $(this);
	        var key = thisEl.closest(".cart-item").attr("data-cart-item");
	        var item = that.cart.getItemForKey(key);
	        var quantity = spinner.value;
	
	        if (item.article.purchaseOnce === true) {
	          Dialog.showMessageDialog("store.cart.purchase_once.dialog.title", "store.cart.purchase_once.dialog.text");
	          thisEl.val(1);
	          e.preventDefault();
	          return;
	        }
	
	        if (utils.isFunction(that.setItemQuantity) && utils.isNumber(quantity)) {
	          that.setItemQuantity(key, quantity);
	        }
	      });
	    }
	  }]);
	
	  return CartTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 23/12/2016.
	 */
	var StorageController = __webpack_require__(123);
	var GoogleAnalytics = {};
	var TAG_ID = "G-ZQN7EVFJTK";
	var utils = __webpack_require__(3);
	
	$(function () {
	  GoogleAnalytics.addScriptIfConsented();
	});
	
	(function (GoogleAnalytics) {
	  GoogleAnalytics.hasConsented = function () {
	    return String(StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT)) === "true";
	  };
	
	  GoogleAnalytics.enable = function () {
	    insertScriptTag();
	  };
	
	  GoogleAnalytics.disable = function () {
	    removeScriptTag();
	    removeGACookies();
	  };
	
	  GoogleAnalytics.addScriptIfConsented = function () {
	    if (GoogleAnalytics.hasConsented()) {
	      insertScriptTag();
	    }
	  };
	
	  function insertScriptTag() {
	    console.log("Google analytics - adding script");
	
	    var script = document.createElement("script");
	    script.type = "text/javascript";
	    script.src = "https://www.googletagmanager.com/gtag/js?id=" + TAG_ID;
	    $(script)[0].setAttribute("async", "");
	    document.head.appendChild(script);
	
	    window.dataLayer = window.dataLayer || [];
	
	    function gtag() {
	      window.dataLayer.push(arguments);
	    }
	
	    gtag("js", new Date());
	    gtag("config", TAG_ID, { "send_page_view": false });
	
	    var loc = location.href.replace(/^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//, "");
	    if (loc === "") {
	      loc = "home";
	    }
	
	    gtag("event", "page_view", { "page_title": loc });
	  }
	
	  function removeScriptTag() {
	    console.log("Google analytics - removing script");
	
	    var $gaScriptEl = $("script[src='https://www.googletagmanager.com/gtag/js?id=" + TAG_ID + "']");
	    $gaScriptEl.remove();
	    if (!utils.isUndefined(window.dataLayer)) {
	      window.dataLayer = window.dataLayer.filter(function (x) {
	        return x[0] !== "js" && x[0] !== "config";
	      });
	    }
	  }
	
	  function removeGACookies() {
	    StorageController.removeCookie("_ga");
	    StorageController.removeCookie("_ga_" + TAG_ID);
	    StorageController.removeCookie("_gid");
	  }
	})(GoogleAnalytics);
	
	module.exports = GoogleAnalytics;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	
	module.exports = function () {
	  function Activation(options) {
	    _classCallCheck(this, Activation);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.fakeKey = utils.UUID();
	
	    this.userKey = options["user-key"];
	    this.applicationKey = options["application-key"];
	    this.applicationName = options["application-name"];
	
	    this.tokenKey = options.tokenKey;
	    this.tokenCode = options.tokenCode;
	
	    this.installation = options.installation;
	
	    this.email = options.email;
	
	    this.current = options.current;
	    this.lastUsed = options["last-used"];
	    this.stamp = options.stamp;
	  }
	
	  _createClass(Activation, [{
	    key: "lastUsed",
	    set: function set(date) {
	      this._lastUsed = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._lastUsed) ? this._lastUsed.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "stamp",
	    set: function set(date) {
	      this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "readableInstallation",
	    get: function get() {
	      return this.installation === "avi-default-installation" ? LanguageManager.getValueForKey("globals.not_applicable") : this.installation;
	    }
	  }]);
	
	  return Activation;
	}();
	
	/*
	 get installation()
	 {
	 return this._installation === "avi-default-installation" ? LanguageManager.getValueForKey("globals.not_applicable") : this._installation;
	 }

	 set installation(installation)
	 {
	 this._installation = installation;
	 }
	 */

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function GroupPurchase(options) {
	    _classCallCheck(this, GroupPurchase);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.comment = options.comment;
	    this.invoiceDate = options["invoice-date"];
	  }
	
	  _createClass(GroupPurchase, [{
	    key: "invoiceDate",
	    set: function set(date) {
	      this._invoiceDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._invoiceDate) ? this._invoiceDate.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return GroupPurchase;
	}();

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 04/05/2017.
	 */
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function SubscriptionHistory(options) {
	    _classCallCheck(this, SubscriptionHistory);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.comment = options.comment;
	
	    this.correction = options.correction;
	    this.grace = options.grace;
	
	    this.validStart = options["valid-from"];
	    this.validEnd = options["valid-until"];
	  }
	
	  _createClass(SubscriptionHistory, [{
	    key: "validStart",
	    set: function set(date) {
	      this._validStart = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validStart) ? this._validStart.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "validEnd",
	    set: function set(date) {
	      this._validEnd = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return SubscriptionHistory;
	}();

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 24/01/2017.
	 */
	var utils = __webpack_require__(3);
	var moment = __webpack_require__(1);
	
	module.exports = function () {
	  function Article(options) {
	    _classCallCheck(this, Article);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.article.code;
	
	    this.quantity = options.count;
	    this.price = options.price;
	    this.vat = options.vat;
	    this.currency = utils.isNotNull(options.currency) ? options.currency : "EUR";
	
	    this.type = options.article.type;
	    this.title = options.article.title;
	    this.author = options.article.author;
	    this.description = options.article.description;
	    this.publisher = options.article.publisher;
	    this.image = options.article.image;
	    this.download = options.article.download;
	
	    this.purchasable = options.article.purchasable;
	    this.purchaseOnce = options.article["purchase-once"];
	    this.physicalDelivery = options.article["physical-delivery"];
	    this.digitalDelivery = options.article["digital-delivery"];
	
	    this.delivered = options.delivered;
	  }
	
	  _createClass(Article, [{
	    key: "totalPriceWithCurrency",
	    get: function get() {
	      return utils.roundNumber(this.priceWithVAT * this.quantity, 2).toFixed(2) + " " + this.currency;
	    }
	  }, {
	    key: "priceWithVAT",
	    get: function get() {
	      return this.price + this.price * this.vat;
	    }
	  }, {
	    key: "delivered",
	    set: function set(date) {
	      this._delivered = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._delivered) ? this._delivered.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "readableDelivered",
	    get: function get() {
	      if (this.physicalDelivery === true) {
	        if (utils.isNotNull(this.delivered)) {
	          return this.delivered;
	        } else {
	          return "-";
	        }
	      } else {
	        return "globals.not_applicable";
	      }
	    }
	  }]);
	
	  return Article;
	}();

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 27/04/2017.
	 */
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function DigitalPurchase(options) {
	  _classCallCheck(this, DigitalPurchase);
	
	  options = utils.isNotNull(options) ? options : {};
	
	  this.licenseGroupKey = options["license-group-key"];
	  this.tokenCode = options["token-code"];
	
	  this.title = options["product-title"];
	
	  this.tokenMaxInstallations = options["token-max-installations"];
	};

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 05/04/2017.
	 */
	var utils = __webpack_require__(3);
	var moment = __webpack_require__(1);
	
	module.exports = function () {
	  function Invoice(options) {
	    _classCallCheck(this, Invoice);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.number = options.number;
	    this.ogm = options.ogm;
	
	    this.creationDate = options.date;
	    this.dueDate = options["due-date"];
	
	    this.invoiceUrl = options["invoice-url"];
	    this.creditnoteUrl = options["creditnote-url"];
	  }
	
	  _createClass(Invoice, [{
	    key: "creationDate",
	    set: function set(date) {
	      this._creationDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._creationDate) ? this._creationDate.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "dueDate",
	    set: function set(date) {
	      this._dueDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._dueDate) ? this._dueDate.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return Invoice;
	}();

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function Organisation(options) {
	  _classCallCheck(this, Organisation);
	
	  options = utils.isNotNull(options) ? options : {};
	
	  this.name = options.name;
	  this.identification = options.identification;
	
	  this.address1 = options.address1;
	  this.address2 = options.address2;
	  this.zip = options.zip;
	  this.city = options.city;
	  this.country = options.country;
	};

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var utils = __webpack_require__(3);
	
	module.exports = function Person(options) {
	  _classCallCheck(this, Person);
	
	  options = utils.isNotNull(options) ? options : {};
	
	  this.firstname = options.firstname;
	  this.lastname = options.lastname;
	
	  this.phone = options.phone;
	  this.mobile = options.mobile;
	  this.email = options.email;
	};

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var utils = __webpack_require__(3);
	
	module.exports = function Product(options) {
	  _classCallCheck(this, Product);
	
	  options = utils.isNotNull(options) ? options : {};
	
	  this.abstractKey = options["abstract-key"];
	  this.key = options.key;
	  this.name = options.name;
	  this.meta = options.meta;
	};

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function ProfileSubscriptionGuest(options) {
	    _classCallCheck(this, ProfileSubscriptionGuest);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.subscriptionGuestKey = options["subscription-guest-key"];
	    this.subscriptionKey = options["subscription-key"];
	    this.organisation = options.organisation;
	    this.validUntil = options["valid-until"];
	  }
	
	  _createClass(ProfileSubscriptionGuest, [{
	    key: "validUntil",
	    set: function set(date) {
	      this._validuntil = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validuntil) ? this._validuntil.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return ProfileSubscriptionGuest;
	}();

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	var Article = __webpack_require__(277);
	
	module.exports = function () {
	  function CartItem(options) {
	    _classCallCheck(this, CartItem);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.comment = options["comment"];
	    this.priceNoVat = options["price-without-vat"];
	    this.priceVat = options["price-with-vat"];
	    this.quantity = options.count;
	
	    this.article = options["catalog-article"];
	  }
	
	  _createClass(CartItem, [{
	    key: "article",
	    set: function set(article) {
	      this._article = null;
	
	      if (utils.isNotNull(article)) {
	        this._article = new Article(article);
	      }
	    },
	    get: function get() {
	      return this._article;
	    }
	  }]);
	
	  return CartItem;
	}();

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	var Item = __webpack_require__(376);
	
	module.exports = function () {
	  function Cart(options) {
	    _classCallCheck(this, Cart);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.subtotal = options.subtotal;
	    this.totalVat = options["total-vat"];
	    this.totalPriceVat = options["total-price-with-vat"];
	    this.vatList = options["vat-list"];
	    this.deliveryCosts = options["delivery-cost"];
	    this.discounts = options.discounts;
	    this.freeArticles = options["free-articles"];
	
	    this.message = options.message;
	    this.valid = options.valid;
	
	    this.items = options["shopping-cart-items"];
	  }
	
	  _createClass(Cart, [{
	    key: "getItemForArticleKey",
	    value: function getItemForArticleKey(key) {
	      for (var i = 0; i < this.items.length; i++) {
	        var article = this.items[i].article;
	
	        if (utils.isNotNull(article) && article.key === key) {
	          return this.items[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "containsArticle",
	    value: function containsArticle(key) {
	      for (var i = 0; i < this.items.length; i++) {
	        var article = this.items[i].article;
	
	        if (utils.isNotNull(article) && article.key === key) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "getItemForKey",
	    value: function getItemForKey(key) {
	      for (var i = 0; i < this.items.length; i++) {
	        if (this.items[i].article.key === key) {
	          return this.items[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "itemCount",
	    get: function get() {
	      var itemCount = 0;
	
	      for (var i = 0; i < this.items.length; i++) {
	        itemCount += this.items[i].quantity;
	      }
	
	      return itemCount;
	    }
	  }, {
	    key: "currency",
	    get: function get() {
	      return utils.isNotNull(this._currency) ? this._currency : "€";
	    }
	  }, {
	    key: "items",
	    set: function set(items) {
	      this._items = [];
	
	      if (utils.isArray(items)) {
	        for (var i = 0; i < items.length; i++) {
	          this._items.push(new Item(items[i]));
	        }
	      }
	    },
	    get: function get() {
	      return this._items;
	    }
	  }]);
	
	  return Cart;
	}();

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 06/02/2017.
	 */
	var utils = __webpack_require__(3);
	var Contact = __webpack_require__(229);
	
	module.exports = function () {
	  function OrderInfo(options) {
	    _classCallCheck(this, OrderInfo);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.differentFacContact = utils.isBoolean(options["different-fac-contact"]) ? options["different-fac-contact"] : true;
	    this.differentLevContact = utils.isBoolean(options["different-lev-contact"]) ? options["different-lev-contact"] : true;
	
	    this.vat = options.vat;
	    this.companyNumber = options["company-number"];
	    this.remark = options.remark;
	    this.purchaseOrderNumber = options["bestelbon-number"];
	
	    this.generateInvoice = utils.isBoolean(options["consumer-generate-invoice"]) ? options["consumer-generate-invoice"] : false;
	
	    this.contactCon = options["contact-con"];
	    this.contactFac = options["contact-fac"];
	    this.contactLev = options["contact-lev"];
	
	    this.involvedPersonList = utils.isNotNull(options["involved-person-list"]) ? options["involved-person-list"] : [];
	  }
	
	  _createClass(OrderInfo, [{
	    key: "contactCon",
	    set: function set(contact) {
	      this._contactCon = new Contact(contact);
	    },
	    get: function get() {
	      return this._contactCon;
	    }
	  }, {
	    key: "contactFac",
	    set: function set(contact) {
	      this._contactFac = new Contact(contact);
	    },
	    get: function get() {
	      return this._contactFac;
	    }
	  }, {
	    key: "contactLev",
	    set: function set(contact) {
	      this._contactLev = new Contact(contact);
	    },
	    get: function get() {
	      return this._contactLev;
	    }
	  }]);
	
	  return OrderInfo;
	}();

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 10/02/2017.
	 */
	var utils = __webpack_require__(3);
	var Catalog = __webpack_require__(278);
	var Cart = __webpack_require__(377);
	var OrderInfo = __webpack_require__(378);
	
	module.exports = function () {
	  function SessionData(options) {
	    _classCallCheck(this, SessionData);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.catalog = options.catalog;
	    this.cart = options["shopping-cart"];
	    this.orderInfo = options["order-info"];
	  }
	
	  _createClass(SessionData, [{
	    key: "catalog",
	    set: function set(catalog) {
	      this._catalog = new Catalog(catalog);
	    },
	    get: function get() {
	      return this._catalog;
	    }
	  }, {
	    key: "cart",
	    set: function set(cart) {
	      this._cart = new Cart(cart);
	    },
	    get: function get() {
	      return this._cart;
	    }
	  }, {
	    key: "orderInfo",
	    set: function set(orderInfo) {
	      this._orderInfo = new OrderInfo(orderInfo);
	    },
	    get: function get() {
	      return this._orderInfo;
	    }
	  }]);
	
	  return SessionData;
	}();

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function SubscriptionBorrow(options) {
	    _classCallCheck(this, SubscriptionBorrow);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.tokenCode = options["token-code"];
	    this.count = options.count;
	    this.subscriptionKey = options["subscription-key"];
	    this.profileKey = options["profile-key"];
	    this.email = options["profile-email"];
	    this.timestamp = options.inserted;
	    this.productName = options["product-name"];
	  }
	
	  _createClass(SubscriptionBorrow, [{
	    key: "timestamp",
	    set: function set(date) {
	      this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY HH:mm:ss") : null;
	    }
	  }]);
	
	  return SubscriptionBorrow;
	}();

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function SubscriptionGuest(options) {
	    _classCallCheck(this, SubscriptionGuest);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.key = options.key;
	    this.email = options["user-email"];
	    this.validUntil = options["valid-until"];
	    this.timestamp = options.timestamp;
	  }
	
	  _createClass(SubscriptionGuest, [{
	    key: "timestamp",
	    set: function set(date) {
	      this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY") : null;
	    }
	  }, {
	    key: "validUntil",
	    set: function set(date) {
	      this._validuntil = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._validuntil) ? this._validuntil.format("DD-MM-YYYY") : null;
	    }
	  }]);
	
	  return SubscriptionGuest;
	}();

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function SubscriptionModule(options) {
	  _classCallCheck(this, SubscriptionModule);
	
	  options = utils.isNotNull(options) ? options : {};
	
	  this.key = options.key;
	  this.name = options.name;
	  this.settings = options["settings"];
	};

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var moment = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	module.exports = function () {
	  function SubscriptionUser(options) {
	    _classCallCheck(this, SubscriptionUser);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.subscriptionKey = options["subscription-key"];
	    this.profileKey = options["profile-key"];
	    this.email = options["email"];
	    this.timestamp = options.timestamp;
	  }
	
	  _createClass(SubscriptionUser, [{
	    key: "timestamp",
	    set: function set(date) {
	      this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
	    },
	    get: function get() {
	      return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY HH:mm:ss") : null;
	    }
	  }]);
	
	  return SubscriptionUser;
	}();

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var utils = __webpack_require__(3);
	var Activation = __webpack_require__(366);
	
	module.exports = function () {
	  function Token(options) {
	    _classCallCheck(this, Token);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.code;
	    this.key = options.key;
	    this.platforms = options.platforms;
	    this.maxInstallations = options["max-installations"];
	    this.maxUsers = options["max-users"];
	  }
	
	  _createClass(Token, [{
	    key: "getActivationForFakeKey",
	    value: function getActivationForFakeKey(key) {
	      for (var i = 0; i < this.activations.length; i++) {
	        if (this.activations[i].fakeKey === key) {
	          return this.activations[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "disableActivationForFakeKey",
	    value: function disableActivationForFakeKey(key) {
	      for (var i = 0; i < this.activations.length; i++) {
	        if (this.activations[i].fakeKey === key) {
	          this.activations[i].current = false;
	          return;
	        }
	      }
	
	      throw "Activation with fakeKey [" + key + "] not found.";
	    }
	  }, {
	    key: "enableActivationForFakeKey",
	    value: function enableActivationForFakeKey(key) {
	      for (var i = 0; i < this.activations.length; i++) {
	        if (this.activations[i].fakeKey === key) {
	          this.activations[i].current = true;
	          return;
	        }
	      }
	
	      throw "Activation with fakeKey [" + key + "] not found.";
	    }
	  }, {
	    key: "getHTMLIconsFormPlatforms",
	    value: function getHTMLIconsFormPlatforms() {
	      var icons = "";
	
	      for (var i = 0; i < this.platforms.length; i++) {
	        var iconClass;
	
	        switch (this.platforms[i]) {
	          case "picture_ios":
	          case "avi_ios":
	            iconClass = "icon-ios";
	            break;
	          case "picture_android":
	            iconClass = "icon-android";
	            break;
	          case "picture_pc":
	            iconClass = "icon-windows";
	            break;
	          case "avi_web":
	            iconClass = "icon-desktop";
	            break;
	          default:
	            break;
	        }
	
	        if (utils.isNotNull(iconClass)) {
	          icons += "<i class='icon " + iconClass + "' data-type='" + this.platforms[i] + "'/>";
	        }
	      }
	
	      return icons;
	    }
	  }, {
	    key: "activationType",
	    get: function get() {
	      if (utils.isNotNull(this.maxInstallations) && utils.isNull(this.maxUsers)) {
	        return "installations";
	      } else if (utils.isNull(this.maxInstallations) && utils.isNotNull(this.maxUsers)) {
	        return "users";
	      }
	
	      throw "Invalid activation type";
	    }
	  }, {
	    key: "currentActivationsCount",
	    get: function get() {
	      return this.currentActivations.length;
	    }
	  }, {
	    key: "activations",
	    set: function set(activations) {
	      this._activations = [];
	
	      if (utils.isArray(activations)) {
	        for (var i = 0; i < activations.length; i++) {
	          activations[i].tokenKey = this.key;
	          activations[i].tokenCode = this.code;
	          this._activations.push(new Activation(activations[i]));
	        }
	      }
	    },
	    get: function get() {
	      return utils.isArray(this._activations) ? this._activations : [];
	    }
	  }, {
	    key: "currentActivations",
	    get: function get() {
	      var currentActivations = [];
	
	      for (var i = 0; i < this.activations.length; i++) {
	        if (this.activations[i].current === true) {
	          currentActivations.push(this.activations[i]);
	        }
	      }
	
	      return currentActivations;
	    }
	  }]);
	
	  return Token;
	}();

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 10/02/2021.
	 */
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var StorageController = __webpack_require__(123);
	var GoogleAnalytics = __webpack_require__(365);
	
	//Require the css like any other css file
	__webpack_require__(608);
	__webpack_require__(733); // requires the cookieconsent library like it was a script tag in the html
	// var cookieconsent = require("exports?cookieconsent!cookieconsent/build/cookieconsent.min.js"); // Doesn't rly do much, it still exposes cookieconsent to the window but it now also exports the value
	// import CC from "CookieConsent";
	
	var CookieconsentController = {};
	
	(function (CookieconsentController) {
	  CookieconsentController.initialize = function () {
	    var consentCookie = StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT);
	
	    if (utils.isNull(consentCookie)) {
	      StorageController.removeCookie("cookieconsent_status");
	    }
	
	    window.cookieconsent.initialise({
	      "palette": {
	        "popup": {
	          "background": "#222222",
	          "text": "#ffffff"
	        },
	        "button": {
	          "background": "#28aae1",
	          "text": "#ffffff"
	        }
	      },
	      "theme": "classic",
	      "type": "opt-in",
	      "content": {
	        "message": LanguageManager.getValueForKey("cookies.message"),
	        "deny": LanguageManager.getValueForKey("cookies.button.deny.text"),
	        "allow": LanguageManager.getValueForKey("cookies.button.allow.text"),
	        "link": LanguageManager.getValueForKey("cookies.link.text"),
	        "href": LanguageManager.getValueForKey("cookies.link")
	      },
	      "cookie": {
	        "expiryDays": 365
	      },
	      "onStatusChange": function onStatusChange(status, chosenBefore) {
	        var enableCookies = status === "allow";
	        utils.devLog("User has chosen to '%s' cookies", enableCookies ? "enabled" : "disable");
	        StorageController.saveCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT, enableCookies, 365);
	
	        if (enableCookies) {
	          onConsented();
	        } else {
	          onDeclined();
	        }
	      }
	    });
	  };
	
	  function onConsented() {
	    GoogleAnalytics.enable();
	  }
	
	  function onDeclined() {
	    GoogleAnalytics.disable();
	  }
	})(CookieconsentController);
	
	module.exports = CookieconsentController;

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 18/01/2017.
	 */
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var elementCreator = __webpack_require__(131);
	var template = {};
	
	(function (Template) {
	  Template.defaultHeaderTemplate = function (data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : ["fo-cell", "header"];
	    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : ["fo-row"];
	
	    var cellElements = "";
	
	    for (var i = 0; i < data.length; i++) {
	      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
	      var cellElementAttributes = data[i].attributes;
	
	      if (data[i].sortable && options.sortable) {
	        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
	        // If sortable --> attributes go on the span with the cell text
	        cellElementAttributes = [];
	      }
	
	      cellElements += elementCreator.createStringElement({
	        classNames: options.cellClasses,
	        attributes: cellElementAttributes,
	        innerHTML: cellElementInnerHTML
	      });
	    }
	
	    var row = elementCreator.createStringElement({
	      classNames: options.rowClasses,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function createTableHeaderSortCell(data) {
	    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];
	
	    // Will be overridden if data-sort-property is set in the headers json file
	    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
	    data.sortAttributes.push({
	      name: "data-sort",
	      value: data.key
	    });
	
	    var sortLinkText = elementCreator.createStringElement({
	      tagName: "span",
	      attributes: data.attributes,
	      innerHTML: LanguageManager.getValueForKey(data.displayText)
	    });
	
	    var sortLinkIcons = elementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-icons"]
	    });
	
	    var sortLink = elementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-link"],
	      attributes: data.sortAttributes,
	      innerHTML: sortLinkText + sortLinkIcons
	    });
	
	    return sortLink;
	  }
	
	  Template.defaultBodyTemplate = function (headerKeys, data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : ["fo-cell"];
	    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : ["fo-row"];
	
	    if (utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty)) {
	      return "";
	    }
	
	    var cellElements = "";
	
	    data._filterValues = [];
	
	    for (var j = 0; j < headerKeys.length; j++) {
	      // Getters do not count for hasOwnProperty ...
	      // if(data.hasOwnProperty(headerKeys[j]))
	      var cellValue = data[headerKeys[j]];
	
	      if (utils.isNull(cellValue)) {
	        cellValue = "";
	      }
	
	      cellValue = LanguageManager.getValueForKey(cellValue);
	      data._filterValues.push(cellValue);
	
	      cellElements += elementCreator.createStringElement({
	        classNames: options.cellClasses,
	        innerHTML: cellValue
	      });
	    }
	
	    var row = elementCreator.createStringElement({
	      classNames: options.rowClasses,
	      attributes: [{
	        "name": "data-row-" + options.rowIdProperty,
	        "value": data[options.rowIdProperty]
	      }],
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	})(template);
	
	module.exports = template;

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 13/02/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var moment = __webpack_require__(1);
	var ElementCreator = __webpack_require__(131);
	
	var template = {};
	
	(function (Template) {
	  Template.createTableHeader = function (data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : ["fo-cell", "header"];
	    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : ["fo-row"];
	
	    var cellElements = "";
	
	    for (var i = 0; i < data.length; i++) {
	      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
	      var cellElementAttributes = data[i].attributes;
	      var cellClasses = options.cellClasses.slice();
	
	      if (data[i].sortable && options.sortable) {
	        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
	        // If sortable --> attributes go on the span with the cell text
	        cellElementAttributes = [];
	      }
	
	      if (data[i].key === "installation") {
	        cellElementInnerHTML += "<button class='btn btn-icon frameless question-circle activation-installation-tooltip' type='button'></button>";
	      }
	
	      cellElements += ElementCreator.createStringElement({
	        classNames: cellClasses,
	        attributes: cellElementAttributes,
	        innerHTML: cellElementInnerHTML
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      classNames: options.rowClasses,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function createTableHeaderSortCell(data) {
	    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];
	
	    // Will be overridden if data-sort-property is set in the headers json file
	    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
	    data.sortAttributes.push({
	      name: "data-sort",
	      value: data.key
	    });
	
	    var sortLinkText = ElementCreator.createStringElement({
	      tagName: "span",
	      attributes: data.attributes,
	      innerHTML: LanguageManager.getValueForKey(data.displayText)
	    });
	
	    var sortLinkIcons = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-icons"]
	    });
	
	    var sortLink = ElementCreator.createStringElement({
	      tagName: "span",
	      classNames: ["sort-link"],
	      attributes: data.sortAttributes,
	      innerHTML: sortLinkText + sortLinkIcons
	    });
	
	    return sortLink;
	  }
	
	  Template.createTokenRow = function (headerKeys, data, options) {
	    options = utils.isNotNull(options) ? options : {};
	    options.cellClass = utils.isNotNull(options.cellClass) ? options.cellClass : "fo-cell";
	    options.rowClass = utils.isNotNull(options.rowClass) ? options.rowClass : "fo-row";
	
	    options.cellClasses = [options.cellClass];
	
	    if (utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty)) {
	      return "";
	    }
	
	    var cellElements = "";
	
	    for (var j = 0; j < headerKeys.length; j++) {
	      switch (headerKeys[j]) {
	        case "deactivate-action":
	          cellElements += makeDeactivateCell(options);
	          break;
	        case "stamp":
	          // add application-icon after the date
	          var content = data[headerKeys[j]] + "  <i class='icon icon-" + data["applicationName"] + " activation-platform'></i>";
	          cellElements += makeDefaultTableCell(content, options);
	          break;
	        default:
	          // Getters do not count for hasOwnProperty ...
	          // if(data.hasOwnProperty(headerKeys[j]))
	          if (utils.isNotNull(data[headerKeys[j]]) || headerKeys[j] === "lastUsed") {
	            if (headerKeys[j] === "lastUsed") {
	              var lastUsed = data._lastUsed;
	
	              if (utils.isNotNull(lastUsed) && utils.isMomentObject(lastUsed)) {
	                var tresholdDate = moment().subtract(12, "months");
	
	                if (lastUsed.isBefore(tresholdDate)) {
	                  options.cellClasses.push("text-red-warm");
	                }
	              }
	            }
	
	            cellElements += makeDefaultTableCell(data[headerKeys[j]], options);
	          }
	          break;
	      }
	    }
	
	    var attributes = [];
	
	    if (utils.isNotNull(options.rowIdProperty)) {
	      attributes.push({
	        "name": "data-row-" + options.rowIdProperty,
	        "value": data[options.rowIdProperty]
	      });
	    }
	
	    var row = ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: [options.rowClass],
	      attributes: attributes,
	      innerHTML: cellElements
	    });
	
	    return row;
	  };
	
	  function makeDefaultTableCell(cellValue, options) {
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: cellValue
	    });
	  }
	
	  function makeDeactivateCell(options) {
	    var deactivateBtn = ElementCreator.createStringElement({
	      tagName: "button",
	      classNames: ["btn", "btn-icon", "frameless", "trash-o", "dark-grey", "deactivate-token-btn"],
	      attributes: [{ name: "type", value: "button" }]
	    });
	
	    options.cellClasses.push("text-right");
	
	    return ElementCreator.createStringElement({
	      tagName: "div",
	      classNames: options.cellClasses,
	      innerHTML: deactivateBtn
	    });
	  }
	})(template);
	
	module.exports = template;

/***/ })

/******/ })));


// WEBPACK FOOTER //
// js/commons.2d13b4d17924be9b1797.js